import type { Dict } from '../types';

export const ar: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in Open Design.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening Open Design so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open Open Design",
  'invite.open.opening': "Opening Open Design…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have Open Design installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download Open Design",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "لم تعد هناك مقاعد متاحة في مساحة العمل هذه. أضف مقاعد لدعوة زملائك.",
  "workspaceInvite.seatsExhaustedAction": "عرض المقاعد والخطة",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "هذا البريد الإلكتروني عضو في الفريق بالفعل أو لديه دعوة معلّقة.",
  "workspaceInvite.errorNoSession": "سجّل الدخول إلى حساب Vela قبل دعوة الأعضاء.",
  "workspaceInvite.errorNoWorkspace": "لا توجد مساحة عمل جماعية لدعوة الأعضاء إليها بعد.",
  "workspaceInvite.errorUnreachable": "تعذّر إرسال الدعوة. يرجى المحاولة لاحقًا.",
  'chat.amrCard.switchTitle': 'فشل استدعاء النموذج — تم إيقاف هذه المهمة مؤقتًا',
  'chat.amrCard.switchBody': 'بدِّل إلى خدمة نماذج Open Design Cloud الرسمية — لا حاجة لإعداد مفتاح API. بعد تسجيل الدخول والتفويض والشحن، ستُعاد محاولة هذه المهمة تلقائيًا.',
  'chat.amrCard.chipOfficial': 'استضافة رسمية',
  'chat.amrCard.chipNoKey': 'بدون مفتاح API',
  'chat.amrCard.chipAutoRetry': 'إعادة المحاولة تلقائيًا بعد تسجيل الدخول',
  'chat.amrCard.switchCta': 'التبديل إلى Open Design Cloud وإعادة المحاولة',
  'chat.amrError.authMessage': 'حساب Open Design Cloud الخاص بك لم يتم تفويضه بعد. فوِّضه وستُعاد محاولة هذه المهمة تلقائيًا.',
  'chat.amrError.balanceMessage': 'نفد رصيد Open Design Cloud الخاص بك. اشحن للاستمرار في هذه المهمة.',
  'chat.amrError.authorizeCta': 'تفويض وإعادة المحاولة',
  'chat.amrError.rechargeCta': 'شحن',
  'chat.amrBalanceGate.title': 'قم بالترقية وواصل الإبداع',
  'chat.amrBalanceGate.message': 'الرصيد غير كافٍ (المتبقي {balance}). قم بترقية الباقة أو الشحن وستبدأ المهمة فورًا.',
  'chat.amrBalanceGate.benefitsTitle': 'ما يقدّمه لك Open Design Cloud',
  'chat.amrBalanceGate.benefit1': 'بدون مفاتيح API — تشكيلة واسعة من النماذج',
  'chat.amrBalanceGate.benefit2': 'وكيل تصميم SOTA مدمج، دون أي إعداد',
  'chat.amrBalanceGate.benefit3': 'خدمة رسمية موثوقة',
  'chat.amrBalanceGate.benefit4': 'يتطور باستمرار: نشر بنقرة واحدة، وسائط متعددة، فرق عمل والمزيد',
  'chat.amrBalanceGate.laterCta': 'ليس الآن',
  'chat.amrBalanceGate.plansCta': 'ترقية الباقة',
  'chat.amrBalanceGate.signedOutTitle': 'سجّل الدخول لبدء الإبداع',
  'chat.amrBalanceGate.signedOutMessage': 'أنت تستخدم وكيل Open Design Cloud — سجّل الدخول وستبدأ هذه المهمة فورًا.',
  'chat.amrBalanceGate.signInCta': 'تسجيل الدخول',
  'chat.amrBalanceGate.watchingWallet': 'سنتابع تلقائيًا فور تحديث رصيدك.',
  'chat.amrLowBalance.title': 'رصيدك على وشك النفاد',
  'chat.amrLowBalance.message': 'لم يتبقَّ سوى {balance} — قد لا يكفي لإتمام هذه المهمة. اشحن أو قم بترقية باقتك أولًا.',
  'chat.amrLowBalance.rechargeCta': 'اشحن الرصيد',
  'chat.amrLowBalance.proceedCta': 'ابدأ على أي حال',
  'chat.amrLowBalance.dontRemind': 'لا تسأل مجددًا',
  'chat.amrArtifactUpgrade.title': 'تابع تحسين عملك بنماذج أقوى',
  'chat.amrArtifactUpgrade.message': 'افتح نماذج متقدمة ومهام متوازية أكثر ورصيدًا شهريًا أكبر.',
  'chat.amrArtifactUpgrade.benefit1': 'مزيد من النماذج المتقدمة، بما فيها Fable 5 وGPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'مهام متزامنة أكثر بما يصل إلى 10 أضعاف',
  'chat.amrArtifactUpgrade.benefit3': 'رصيد شهري أكبر بما يصل إلى 300 ضعف',
  'chat.amrArtifactUpgrade.benefit4': 'أولوية في قائمة الانتظار وقت الذروة لتوليد أسرع',
  'chat.amrArtifactUpgrade.promoBanner': 'لفترة محدودة: وفّر حتى 67% على باقات الاشتراك',
  'chat.amrArtifactUpgrade.countdownLabel': 'ينتهي العرض خلال',
  'chat.amrArtifactUpgrade.plansCta': 'رقِّ خطتك الآن بخصم يصل إلى 67%',
  'chat.amrArtifactUpgrade.homePlansCta': 'وفّر 67%',
  'chat.amrArtifactUpgrade.laterCta': 'تابع بالخطة المجانية وأرسل',
  'chat.amrArtifactUpgrade.homeTitle': 'عملك جاهز. ارتقِ بفكرتك التالية.',
  'chat.amrArtifactUpgrade.homeMessage': 'احصل على نماذج أقوى ومهام متوازية أكثر ورصيد شهري أكبر.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'عرض العمل',
  'chat.antigravityError.launchTerminalCta': 'تسجيل الدخول عبر الطرفية',
  'chat.antigravityError.launchSwitchModelCta': 'تبديل النموذج في الطرفية',
  'chat.connectionDropped': 'انقطع الاتصال بخدمة النموذج قبل اكتمال الاستجابة — عادةً بسبب شبكة أو وكيل (proxy) غير مستقر. يرجى إعادة المحاولة.',
  'chat.runError.title.authRequired': 'مطلوب التفويض',
  'chat.runError.title.balance': 'الرصيد غير كافٍ',
  'chat.runError.title.connectionDropped': 'انقطع الاتصال',
  'chat.runError.title.signInRequired': 'تسجيل الدخول مطلوب',
  'chat.runError.title.rateLimited': 'تم بلوغ حد الاستخدام',
  'chat.runError.title.generic': 'فشلت المهمة',
  'chat.runError.title.artifactMissing': 'لم يتم إنشاء أي مخرجات',
  'chat.runError.signInMessage.amr': 'لم يتم تسجيل دخول وكيل Open Design Cloud بعد — سجّل الدخول لبدء استخدامه.',
  'chat.runError.signInMessage.other': '{agent} لم يسجّل الدخول. تحقق من حالة تسجيل الدخول محليًا. نوصي بوكيل Open Design Cloud — أكثر ثباتًا وأفضل قيمة.',
  'chat.runError.agentFallback': 'الوكيل',
  'chat.runError.sourceLabel': 'تفاصيل الخطأ',
  'chat.runError.sourceExpandAria': 'توسيع مصدر الخطأ',
  'chat.runError.sourceCollapseAria': 'طي مصدر الخطأ',
  'chat.runError.title.cliMissing': 'الوكيل غير مثبَّت',
  'chat.runError.title.promptTooLarge': 'الإدخال طويل جدًا',
  'chat.runError.title.modelUnavailable': 'النموذج غير متاح',
  'chat.runError.title.upstreamUnavailable': 'الخدمة غير متاحة مؤقتًا',
  'chat.runError.title.toolLoop': 'عالق في حلقة',
  'chat.runError.title.outputInvalid': 'مخرجات النموذج غير صالحة',
  'chat.runError.title.runtimeConfig': 'خطأ في الإعداد',
  'chat.runError.cliMissingMessage': 'لم يتم العثور على أداة سطر الأوامر لـ {agent}. ثبّتها وتأكد من وجودها في PATH ثم أعد المحاولة.',
  'chat.runError.promptTooLargeMessage': 'تجاوزت هذه الجولة حد سياق النموذج. اختصر الطلب أو أزل المرفقات أو ابدأ محادثة جديدة ثم أعد المحاولة.',
  'chat.runError.modelUnavailableMessage': 'النموذج المحدد غير متاح أو غير موجود. بدّل إلى نموذج آخر في الإعدادات ثم أعد المحاولة.',
  'chat.runError.rateLimitedMessage': 'لقد بلغت حد استخدام خدمة النموذج. انتظر قليلاً ثم أعد المحاولة، أو بدّل إلى نموذج أو خدمة أخرى.',
  'chat.runError.upstreamUnavailableMessage': 'خدمة النموذج غير متاحة مؤقتًا — عادةً بسبب عدم استقرار المصدر أو مشكلة في الشبكة/الوكيل. أعد المحاولة بعد قليل.',
  'chat.runError.toolLoopMessage': 'كرّر {agent} الإجراء نفسه دون تقدّم فتوقّف. تحقق من الملف أو الأمر المستهدف ثم أعد المحاولة.',
  'chat.runError.outputInvalidMessage': 'أنتج النموذج مخرجات غير صالحة وتم إيقاف هذه الجولة. عادةً ما تحل إعادة المحاولة المشكلة.',
  'chat.runError.runtimeConfigMessage': 'إعداد وقت التشغيل للوكيل المحدد غير صالح، لذلك تعذّر بدء التشغيل. حدِّث إلى أحدث إصدار أو تواصل مع الدعم.',
  'chat.runError.title.quotaExhausted': "انتهت الحصة",
  'chat.runError.title.timedOut': "انتهت المهلة",
  'chat.runError.title.emptyOutput': "لا يوجد ناتج",
  'chat.runError.title.sessionExpired': "انتهت الجلسة",
  'chat.runError.title.gitBashMissing': "Git Bash غير موجود",
  'chat.runError.title.cpuUnsupported': "المعالج غير مدعوم",
  'chat.runError.quotaExhaustedMessage': "انتهت حصة خدمة النموذج أو حد الفوترة، لذا لن تفيد إعادة المحاولة. اشحن رصيدك لدى المزوّد أو بدّل إلى نموذج أو خدمة أخرى.",
  'chat.runError.workspaceCreditsMessage': "نفدت أرصدة مساحة عملك. أضف أرصدة (أو اطلب من مالك المساحة إعادة الشحن)، أو بدّل إلى نموذج أو خدمة أخرى.",
  'chat.runError.timedOutMessage': "استغرق هذا التشغيل وقتًا طويلاً وتم إيقافه. أعد المحاولة، أو قلّص المهمة ثم أعد المحاولة.",
  'chat.runError.inactivityTimeoutMessage': "توقّف الوكيل عن إنتاج ناتج جديد لفترة طويلة فتم إيقافه بسبب انتهاء المهلة. عادةً ما تعيد المحاولة تشغيله من جديد.",
  'chat.runError.emptyOutputMessage': "انتهى الوكيل دون إنتاج أي ناتج. هذا مؤقت غالبًا، فأعد المحاولة.",
  'chat.runError.sessionExpiredMessage': "انتهت صلاحية الجلسة المستأنفة. تمت إعادة ضبطها، لذا أعد المحاولة لبدء تشغيل جديد.",
  'chat.runError.gitBashMissingMessage': "يلزم Git Bash لتشغيل هذا الوكيل على Windows لكنه غير موجود. ثبّت Git for Windows ثم أعد المحاولة.",
  'chat.runError.cpuUnsupportedMessage': "تتطلب بيئة تشغيل هذا الوكيل مجموعة تعليمات للمعالج (AVX2) غير متوفرة في هذا الجهاز، لذا يتعذر تشغيلها. حدِّث Open Design إلى أحدث إصدار الذي يتضمن بيئة تشغيل متوافقة.",
  'common.cancel': 'إلغاء',
  'chat.selectFromLibrary': 'استيراد من المكتبة',
  'chat.importFigma': 'استيراد من Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Open Design project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'استيراد من المكتبة',
  'designFiles.library.title': 'استيراد من المكتبة',
  'libraryPicker.title': 'استيراد من المكتبة',
  'libraryPicker.searchPlaceholder': 'البحث في المكتبة…',
  'libraryPicker.empty': 'لا توجد عناصر في مكتبتك بعد',
  'libraryPicker.allKinds': 'الكل',
  'libraryPicker.add': 'استيراد',
  'libraryPicker.loading': 'جارٍ التحميل…',
  'common.save': 'حفظ',
  'common.close': 'إغلاق',
  'common.clear': 'مسح',
  'common.delete': 'حذف',
  'common.rename': 'إعادة تسمية',
  'common.edit': 'تعديل',
  'common.preview': 'معاينة',
  'common.share': 'مشاركة',
  'common.search': 'بحث',
  'common.searchEllipsis': 'بحث...',
  'common.loading': 'جاري التحميل...',
  'common.all': 'الكل',
  'common.none': 'لا شيء',
  'common.default': 'افتراضي',
  'common.installed': 'مثبت',
  'common.notInstalled': 'غير مثبت',
  'common.active': 'نشط',
  'common.inactive': 'غير نشط',
  'common.offline': 'غير متصل',
  'common.selected': 'محدد',
  'common.create': 'إنشاء',
  'common.openPreview': 'فتح المعاينة',
  'common.exitFullscreen': 'الخروج من ملء الشاشة',
  'common.fullscreen': 'ملء الشاشة',
  'common.openInNewTab': 'فتح في علامة تبويب جديدة',
  'common.exportPdf': 'تصدير كـ PDF',
  'common.exportZip': 'تحميل كـ zip.',
  'common.exportHtml': 'تصدير كـ HTML مستقل',
  'common.exportImage': 'تصدير كصورة',
  'common.exportImageFailed': 'فشل التقاط الصورة. يرجى المحاولة مرة أخرى أو استخدام أداة لقطة الشاشة في المتصفح.',
  'common.justNow': 'الآن',
  'common.minutesAgo': 'منذ {n} دقيقة',
  'common.hoursAgo': 'منذ {n} ساعة',
  'common.daysAgo': 'منذ {n} يوم',
  'common.weeksAgo': 'قبل {n} أسبوع',
  'common.now': 'الآن',
  'common.minutesShort': '{n} د',
  'common.hoursShort': '{n} سا',
  'common.daysShort': '{n} ي',
  'common.untitled': 'بدون عنوان',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'سطح المكتب',
  'designBrowser.viewport.desktopTitle': 'استخدام الحجم الكامل لعلامة تبويب المتصفح',
  'designBrowser.viewport.tablet': 'جهاز لوحي',
  'designBrowser.viewport.tabletTitle': 'معاينة بعرض 820 بكسل',
  'designBrowser.viewport.mobile': 'الجوال',
  'designBrowser.viewport.mobileTitle': 'معاينة بعرض 390 بكسل',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'إضافة إلى المحادثة',
  'designBrowser.status.imageAddedToChat': 'تمت إضافة الصورة إلى المحادثة.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'المصدر',
  'plugins.availableDetails.provenanceLine': 'من {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'من {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'تثبيت',
  'plugins.availableDetails.version': 'الإصدار',
  'plugins.availableDetails.pluginVersion': 'إصدار الإضافة',
  'plugins.availableDetails.copyInstallCommand': 'نسخ أمر التثبيت',
  'plugins.availableDetails.copied': 'تم النسخ',
  'plugins.availableDetails.deprecatedPrefix': 'مهمَل: {message}',
  'plugins.availableDetails.deprecatedFallback': 'تم وضع علامة على هذا الإصدار كمهمَل.',
  'plugins.availableDetails.yanked': 'تم السحب.',
  'plugins.availableDetails.yankedWithReason': 'تم السحب: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (مهمَل)',
  'plugins.availableDetails.versionYankedSuffix': ' (مسحوب)',
  'plugins.availableDetails.ref': 'المرجع',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'الأذونات',
  'plugins.availableDetails.capabilitySummary': 'ملخص الإمكانات',
  'plugins.actions.copyInstallCommand': 'نسخ أمر التثبيت',
  'plugins.actions.copyPluginId': 'نسخ معرّف الإضافة',
  'plugins.actions.copyReadmeBadge': 'نسخ شارة README',
  'plugins.actions.openSourceGithub': 'فتح المصدر على GitHub',
  'plugins.actions.openSource': 'فتح المصدر',
  'plugins.actions.openHomepage': 'فتح الصفحة الرئيسية',
  'plugins.actions.openMarketplace': 'فتح في السوق',
  'app.brand': 'Open Design',
  'app.brandPill': 'معاينة البحث',
  'app.brandSubtitle': 'بواسطة Nexu Labs',
  'app.welcomeLoading': 'جاري تحميل مساحة العمل...',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'مرحبًا بك في Open Design',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'ابدأ من ملخص',
  'settings.onboardingCreateBody': 'صِف الموقع أو التطبيق أو العرض التقديمي أو الصورة أو الفيديو الذي تريده. سيُنشئ Open Design مشروعًا ويُبقي العمل قابلاً للتحرير.',
  'settings.onboardingMemoryTitle': 'حفظ سياق العمل',
  'settings.onboardingMemoryBody': 'أضِف التفضيلات وحقائق المشروع والقواعد المتكررة حتى تلتقط المحادثات المستقبلية السياق الصحيح.',
  'settings.onboardingMemoryCalloutTitle': 'محفوظ في الذاكرة الخاصة بك',
  'settings.onboardingMemoryCalloutBody': 'تُغذّي هذه الإجابات ملف الذاكرة الخاص بك. يعيد Open Design استخدامه في كل مهمة — ويستمر في التعلّم أثناء عملك.',
  'settings.onboardingMemoryBenefitIntent': 'يفهم ما تقصده من طلب قصير',
  'settings.onboardingMemoryBenefitFewerQuestions': 'يتخطّى أسئلة الإعداد المتكررة',
  'settings.onboardingMemoryBenefitPersonalized': 'يُكيّف المخرجات وفق دورك وجمهورك وذوقك',
  'settings.onboardingSystemsTitle': 'أحضِر نظام التصميم الخاص بك',
  'settings.onboardingSystemsBody': 'اختر أو أنشئ نظام علامة تجارية حتى يتبع العمل المُولَّد الألوان والطباعة ولغة المنتج الحقيقية.',
  'settings.onboardingExecutionTitle': 'اختر طريقة تشغيل التوليد',
  'settings.onboardingExecutionBody': 'CLI رسمي بإعداد بنقرة واحدة وإعدادات افتراضية جاهزة للاستخدام. استخدم مفتاحًا واحدًا للاختيار من بين العديد من النماذج بأسعار أفضل.',
  'settings.onboardingAmrCloudBenefitOfficial': 'موصى به رسميًا',
  'settings.onboardingAmrCloudBenefitReady': 'بلا نشر',
  'settings.onboardingAmrCloudBenefitModels': 'يدعم Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'حزمة SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'قريبًا',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'الصور والفيديو',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills كثيرة',
  'settings.onboardingAmrCloudUpcomingRouting': 'توجيه ذكي',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'تخويل Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'تم التخويل',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'إنشاء نظام تصميم',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'ابقَ على اطلاع',
  'settings.onboardingNewsletterTitle': 'ابقَ على اطلاع',
  'settings.onboardingNewsletterBody': 'احصل على تحديثات المنتج والقوالب الجديدة وأنظمة التصميم وأنشطة السفراء في بريدك. اختياري — يمكنك التخطي.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'تسجيل الدخول إلى Open Design',
  'settings.onboardingCloudBody': 'سجّل الدخول وابدأ التصميم فورًا باستخدام الذكاء الاصطناعي السحابي، دون أي إعداد معقّد.',
  'settings.onboardingCloudSignIn': 'تسجيل الدخول إلى Open Design',
  'settings.onboardingCloudContinue': 'متابعة (تم تسجيل الدخول)',
  'settings.onboardingCloudAlternative': 'استخدم واجهة سطر أوامر محلية أو مفتاح API الخاص بك',
  'settings.onboardingCloudRights': 'جميع الحقوق محفوظة.',
  'settings.onboardingCloudOr': 'أو',
  'settings.onboardingGateTooltipNoRuntime': 'الخطوات التالية تعمل بالذكاء الاصطناعي — اختر طريقة تشغيل للمتابعة.',
  'settings.onboardingGateTooltipAmr': 'الخطوات التالية تعمل بالذكاء الاصطناعي — سجّل الدخول إلى Open Design Cloud للمتابعة.',
  'settings.onboardingGateTooltipLocal': 'الخطوات التالية تعمل بالذكاء الاصطناعي — اختر CLI محليًا متاحًا للمتابعة.',
  'settings.onboardingGateTooltipByok': 'الخطوات التالية تعمل بالذكاء الاصطناعي — أضف مفتاح النموذج واختبره للمتابعة.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'رسمي',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'نبذة عنك',
  'settings.onboardingProfileBody': 'تفاصيل اختيارية للحصول على إعدادات افتراضية أفضل.',
  'settings.onboardingRoleLabel': 'دورك',
  'settings.onboardingOrgSizeLabel': 'حجم المؤسسة',
  'settings.onboardingUseCaseLabel': 'حالة الاستخدام',
  'settings.onboardingSourceLabel': 'كيف سمعت عنا؟',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 بحث (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 أداة ذكاء اصطناعي (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 صديق أو زميل',
  'settings.onboardingSourceCommunity': '💬 Discord / مجتمع',
  'settings.onboardingSourceEmail': '✉️ بريد إلكتروني / نشرة إخبارية',
  'settings.onboardingSourceBlog': '📝 مدونة / مقال',
  'settings.onboardingSourceOther': '✨ أخرى',
  'settings.onboardingSourceOtherPlaceholder': 'أخبرنا أين (اختياري)',
  'settings.onboardingSelectPlaceholder': 'اختر واحدًا',
  'settings.onboardingSelectMultiplePlaceholder': 'اختر واحدًا أو أكثر',
  'settings.onboardingOrgSolo': 'فردي / شخصي (1)',
  'settings.onboardingOrgTeam': 'فريق صغير (2-10)',
  'settings.onboardingOrgStartup': 'شركة ناشئة / منشأة صغيرة ومتوسطة (11-50)',
  'settings.onboardingOrgGrowth': 'شركة في مرحلة النمو (51-200)',
  'settings.onboardingOrgMidMarket': 'السوق المتوسطة (201-1000)',
  'settings.onboardingOrgEnterprise': 'مؤسسة كبيرة (1000+)',
  'settings.onboardingRolePm': '📋 مدير منتج',
  'settings.onboardingRoleDesigner': '🎨 مصمم',
  'settings.onboardingRoleEngineer': '💻 مهندس',
  'settings.onboardingRoleMarketing': '📣 تسويق',
  'settings.onboardingRoleAgency': '📣 وكالة تسويق',
  'settings.onboardingRoleGrowth': '📈 نمو',
  'settings.onboardingRoleOps': '⚙️ عمليات',
  'settings.onboardingRoleFounder': '🚀 مؤسس / تنفيذي',
  'settings.onboardingRoleStudent': '🎓 طالب / معلّم',
  'settings.onboardingRoleOther': '✨ أخرى',
  'settings.onboardingUseProduct': '🎨 تصميم المنتجات',
  'settings.onboardingUseDesignSystem': '🧩 نظام التصميم',
  'settings.onboardingUsePrototype': '📱 نموذج أولي / واجهة تطبيق',
  'settings.onboardingUseLanding': '🌐 صفحات هبوط',
  'settings.onboardingUseAds': '📣 إعلانات / محتوى اجتماعي',
  'settings.onboardingUseDashboard': '📊 لوحات معلومات / أدوات داخلية',
  'settings.onboardingUseDeck': '🖥️ عرض تقديمي / شرائح',
  'settings.onboardingUseMarketing': '📈 تسويق / نمو',
  'settings.onboardingUseEngineering': '🤝 تسليم هندسي',
  'settings.onboardingUseAgency': '💼 عمل وكالة / عملاء',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'الإعدادات',
  'settings.title': 'النماذج ومقدمو الخدمات',
  'settings.subtitle': 'اختر بين CLI المحلي و BYOK.',
  'settings.general': 'عام',
  'settings.generalHint': 'اللغة والمظهر والإشعارات ومواقع المشاريع والخصوصية وتفاصيل التطبيق.',
  'settings.modeAria': 'وضع التنفيذ',
  'settings.protocolAria': 'بروتوكول API',
  'settings.modeDaemon': 'CLI محلي',
  'settings.modeDaemonHelp': 'التشغيل عبر واجهة CLI على جهازك',
  'settings.modeDaemonOffline': 'البرنامج الخفي لا يعمل',
  'settings.modeDaemonOfflineMeta': 'غير متصل',
  'settings.modeDaemonInstalledMeta': '{count} مثبت',
  'settings.modeApi': 'مزود API',
  'settings.cloudCalloutTitle': 'Use Open Design Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'موفرو API',
  'settings.byokNoFileToolsNotice': 'لا يمكن لـ BYOK قراءة ملفات المشروع أو الكتابة فيها أو تعديلها. استخدم Local CLI عندما تحتاج إلى تغييرات في الكود.',
  'settings.byokDraftNotice': 'أكمل الحقول المطلوبة لحفظ هذا الموفر. سيظل إعدادك الحالي نشطًا.',
  'settings.codeAgent': 'وكيل الكود',
  'settings.codeAgentHint': 'تم اكتشافه عبر مسح PATH الخاص بك. اختر واجهة CLI التي تريد أن تمر الأجيال عبرها.',
  'settings.rescan': '↻ إعادة المسح',
  'settings.rescanTitle': 'إعادة مسح PATH',
  'settings.rescanRunning': 'جارٍ المسح...',
  'settings.rescanSuccess': 'اكتمل المسح. {count} متاح.',
  'settings.designSystemRenameFailed': 'فشلت إعادة التسمية. تحقق من البرنامج الخفي وحاول مرة أخرى.',
  'settings.rescanFailed': 'فشل المسح. تحقق من البرنامج الخفي وحاول مرة أخرى.',
  'settings.test': 'اختبار',
  'settings.testTitle': 'أرسل مطالبة اختبار صغيرة للتحقق من الاتصال',
  'settings.testRunning': 'جاري اختبار الاتصال…',
  'settings.byokReadyToTest': 'جاهز للاختبار',
  'settings.testCancel': 'إلغاء',
  'settings.testRetry': 'إعادة الاختبار',
  'settings.required': 'مطلوب',
  'settings.testMissingFields': 'املأ {fields} لاختبار الاتصال.',
  'settings.testSuccessApi': 'تم الاتصال. رد خلال {ms} مللي ثانية — \'{sample}\'',
  'settings.testSuccessCli': 'رد {agentName} خلال {ms} مللي ثانية — \'{sample}\'',
  'settings.testAuthFailed': 'فشلت المصادقة. تحقق من مفتاح الـ API.',
  'settings.testForbidden': 'الوصول ممنوع. تحقق من الحساب أو المنطقة أو المؤسسة.',
  'settings.testNotFoundModel': 'لم يتم العثور على النموذج \'{model}\' في هذه النقطة.',
  'settings.testInvalidModelId': 'معرّف النموذج \'{model}\' غير صالح. يجب أن يبدأ المعرّف المخصص بحرف أو رقم وألا يحتوي على مسافات.',
  'settings.testInvalidBaseUrl': 'Base URL غير صالح أو يتعذر الوصول إليه.',
  'settings.testRateLimited': 'حد المزود معدّل الاختبار. التكوين يبدو صالحاً.',
  'settings.testUpstream': 'أعاد المزود {status}. حاول مرة أخرى بعد قليل.',
  'settings.testTimeout': 'انتهت مهلة الاختبار بعد {ms} مللي ثانية.',
  'settings.testAgentMissing': '{agentName} غير مثبت أو ليس في PATH.',
  'settings.testAgentSpawn': 'تعذّر تشغيل {agentName}: {detail}.',
  'settings.testUnknown': 'فشل الاختبار: {detail}',
  'settings.agentInstall.install': 'تثبيت',
  'settings.agentInstall.docs': 'الوثائق',
  'settings.agentInstall.pathHint': 'إذا ثبّتّ CLI باستخدام npm أو Homebrew وما زال يظهر كغير مثبت، فتأكد من أن مجلد bin للأداة موجود في PATH الذي يرثه daemon الخاص بـ Open Design (قد يختلف PATH بين Terminal وتطبيقات GUI على macOS). راجع QUICKSTART.md (قسم "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'افتح رابط التثبيت أو الوثائق للوكيل الذي تفضله.',
  'settings.agentInstall.stepAuth': 'أكمِل المصادقة في CLI الخاص بالمزوّد (تسجيل الدخول أو إضافة بيانات اعتماد API) قبل العودة إلى Open Design.',
  'settings.agentInstall.stepRescan': 'انقر إعادة المسح في هذا القسم.',
  'settings.agentInstall.stepSelect': 'اختر بطاقة الوكيل عندما يظهر كأنه مثبت.',
  'settings.noAgentsDetected': 'لم يتم اكتشاف أي وكلاء بعد. قم بتثبيت Claude Code أو Codex أو Devin أو OpenCode أو Cursor Agent أو Qwen أو GitHub Copilot CLI، ثم اضغط على إعادة المسح.',
  'settings.agentInstalledGroup': 'واجهات CLI لديك ({count})',
  'settings.agentInstallGroup': 'متاحة للتثبيت ({count})',
  'settings.agentAuthRequired': 'المصادقة مطلوبة',
  'settings.agentAuthUnknown': 'حالة المصادقة غير معروفة',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': 'تفويض',
  'settings.amrBenefitOfficial': 'رسمي',
  'settings.amrBenefitLowerPrice': 'تكلفة أقل',
  'settings.amrBenefitManyModels': 'نماذج متعددة',
  'settings.amrPromoBonus': 'مكافأة محدودة: +100%',
  'settings.amrSignInToContinue': 'سجّل الدخول للمتابعة',
  'settings.amrSignIn': 'تسجيل الدخول',
  'settings.amrSignedIn': 'تم تسجيل الدخول',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Open Design Cloud wallet balance',
  'settings.amrNotSignedIn': 'لم يتم تسجيل الدخول',
  'settings.amrSigningIn': 'جارٍ تسجيل الدخول…',
  'settings.amrActivationHint': 'لم تُفتح صفحة تسجيل الدخول؟ اضغط الزر أدناه لإعادة فتحها.',
  'settings.amrActivationBrowserFailed': 'تعذّر فتح المتصفح تلقائيًا. افتح صفحة تسجيل الدخول أدناه للمتابعة.',
  'settings.amrActivationOpen': 'فتح صفحة تسجيل الدخول',
  'settings.amrCancelSignIn': 'إلغاء تسجيل الدخول',
  'settings.amrAccountStatus': 'حالة حساب Open Design Cloud',
  'settings.amrConsole': 'إدارة',
  'settings.amrBalance': 'الحصة',
  'settings.amrPlan': 'الخطة',
  'settings.amrUpgrade': 'ترقية',
  'settings.amrModelUpgradeHint': 'قم بالترقية للاستخدام',
  'settings.amrLoginErrorCompact': 'فشل تسجيل الدخول إلى Open Design Cloud.',
  'settings.advanced': 'متقدّم',
  'settings.amrLogin': 'تسجيل الدخول',
  'settings.amrLogout': 'تسجيل الخروج',
  'settings.amrLoggingIn': 'جارٍ تسجيل الدخول…',
  'settings.amrLoggingOut': 'جارٍ تسجيل الخروج…',
  'settings.amrLoggedInAs': 'تم تسجيل الدخول باسم {email}',
  'settings.amrLoggedInWithPlan': 'تم تسجيل الدخول باسم {email} · {plan}',
  'settings.amrLoggedInPill': 'تم تسجيل الدخول',
  'settings.amrNotLoggedIn': 'لم يتم تسجيل الدخول',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'ملء المزوّد سريعًا',
  'settings.providerPreset': 'إعداد الموفر المسبق',
  'settings.protocolGroupProtocols': 'البروتوكولات',
  'settings.protocolGroupGateways': 'البوابات',
  'settings.customProvider': 'مزوّد مخصص',
  'settings.apiKey': 'مفتاح API',
  'settings.apiKeyGetLink': 'الحصول على المفتاح ↗',
  'settings.showKey': 'إظهار المفتاح',
  'settings.hideKey': 'إخفاء المفتاح',
  'settings.show': 'إظهار',
  'settings.hide': 'إخفاء',
  'settings.model': 'النموذج',
  'settings.apiKeyInvalid': 'API key غير صالح.',
  'settings.apiKeyCleaned': 'تمت إزالة المسافات الزائدة من API key.',
  'settings.modelsLoadedFromAccount': '✓ تم تحميل {count} نموذج من حسابك.',
  'settings.modelsLoadedCount': '✓ تم تحميل {count} نموذج.',
  'settings.modelSourceAccount': 'من حسابك',
  'settings.modelSourceSuggested': 'مُقترح',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'تكلفة منخفضة',
  'modelCost.halfToOne': 'تكلفة متوسطة',
  'modelCost.oneToFour': 'تكلفة مرتفعة',
  'modelCost.overFour': 'أعلى تكلفة',
  'settings.fetchModels': 'جلب النماذج',
  'settings.fetchModelsTitle': 'جلب النماذج المتاحة من هذا المزوّد',
  'settings.fetchModelsRunning': 'جارٍ جلب النماذج…',
  'settings.fetchModelsMissingFields': 'املأ {fields} لجلب النماذج.',
  'settings.fetchModelsInvalidBaseUrl': 'أدخل Base URL صالحًا لجلب النماذج.',
  'settings.fetchModelsUnsupportedAzure': 'يستخدم Azure OpenAI أسماء عمليات النشر، لذا فإن اكتشاف النماذج غير متاح هنا.',
  'settings.fetchModelsUnsupportedOllama': 'اكتشاف نماذج Ollama Cloud غير متاح بعد. اختر نموذجًا أو اكتبه.',
  'settings.fetchModelsSuccess': 'تم جلب {count} نموذجًا.',
  'settings.fetchModelsEmpty': 'لم يتم إرجاع أي نماذج نصية متوافقة.',
  'settings.fetchModelsUnsupported': 'اكتشاف النماذج غير متاح لهذا البروتوكول.',
  'settings.fetchModelsFailed': 'تعذّر جلب النماذج: {detail}',
  'settings.suggestedModelsHint': 'هذه نماذج مقترحة لهذا البروتوكول. قد يدعم مزوّدك نماذج مختلفة.',
  'settings.baseUrl': 'رابط القاعدة',
  'settings.baseUrlInvalid': 'استخدم رابط http:// أو https:// عامًا.',
  'settings.baseUrlCustomize': 'تخصيص URL',
  'settings.baseUrlDefaultHint': 'غيّر هذا فقط إذا كنت تستخدم وكيلاً أو بوابة متوافقة.',
  'settings.azureBaseUrlPlaceholder': 'ألصق عنوان URL لنقطة نهاية Azure',
  'settings.azureBaseUrlHint': 'يمكنك العثور على هذا في بوابة Azure ← المورد الخاص بك ← Endpoint.',
  'settings.azureDeploymentModel': 'اسم النشر',
  'settings.azureCustomDeploymentName': 'اسم نشر مخصّص',
  'settings.azureDeploymentModelHint': 'في Azure OpenAI، يُستخدم هذا الحقل كاسم النشر في /openai/deployments/<model>. أدخل اسم النشر الذي أنشأته في Azure.',
  'settings.azureModelFetchHint': 'أدخل اسم النشر من مورد Azure الخاص بك. لا يمكن جلب عمليات نشر Azure تلقائيًا.',
  'settings.apiVersion': 'إصدار API',
  'settings.byokImageModel': 'نموذج إنشاء الصور',
  'settings.byokVideoModel': 'نموذج إنشاء الفيديو',
  'settings.byokVideoI2vHint': 'نموذج صورة-إلى-فيديو: مطلوب صورة مرجعية (يُستخدم أحدث صورة في المشروع تلقائيًا إن لم تحددها)',
  'settings.byokSpeechModel': 'نموذج توليد الصوت',
  'settings.byokSpeechVoice': 'صوت الكلام',
  'settings.byokModelDefaultOption': 'افتراضي',
  'settings.maxTokens': 'أقصى عدد من الرموز (اختياري)',
  'settings.maxTokensHint': 'الحد الأقصى لطول الاستجابة. اتركه فارغًا لاستخدام الإعداد الافتراضي للنموذج.',
  'settings.apiHint': 'يُحفظ محليًا على هذا الجهاز.',
  'settings.skipForNow': 'تخطي الآن',
  'settings.getStarted': 'ابدأ الآن',
  'settings.envConfigure': 'النماذج ومقدمو الخدمات',
  'settings.localCli': 'CLI محلي',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'لم يتم اختيار وكيل',
  'settings.language': 'اللغة',
  'settings.languageHint': 'تغيير لغة الواجهة. تحفظ في المتصفح.',
  'settings.agentModelHead': 'النموذج لـ:',
  'settings.modelPicker': 'النموذج',
  'settings.modelSourceLive': 'مباشر من CLI',
  'settings.modelUsesCliDefault': 'إعداد CLI الافتراضي',
  'settings.modelSourceFallback': 'القائمة المضمنة',
  'settings.reasoningPicker': 'جهد التفكير',
  'settings.serviceTierPicker': 'طبقة الخدمة',
  'settings.modelPickerHint': 'يتم جلبه من CLI عندما يعرض أمر `models`. "الافتراضي" يترك الخيار لإعدادات CLI؛ "مخصص..." يسمح لك بكتابة أي معرف نموذج يقبله CLI.',
  'settings.modelPickerLiveHint': 'تم تحديث النماذج من CLI المثبت. لا يزال الخيار الافتراضي يستخدم إعدادات CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'تم تحديث النماذج من CLI المثبت.',
  'settings.modelPickerFallbackHint': 'يتم عرض الإعدادات الافتراضية المضمنة. انقر على إعادة المسح لجلب النماذج المباشرة من CLI.',
  'settings.cliEnvTitle': 'متقدّم: الوكيل والمسارات المخصّصة',
  'settings.cliEnvHint': 'استخدم هذه الخيارات لتجاوز بيئة CLI المحدّد: مفاتيح API، وعناوين base URL للوكيل، ومجلدات home المخصّصة، أو مسارات تنفيذ غير قياسية. عند عدم ضبط base URL، يستخدم CLI نقطة النهاية الافتراضية الخاصة به. تبقى الأسرار في إعدادات التطبيق المحلية ولا يراها سوى CLI المحدّد.',
  'settings.cliEnvClaudeConfigDir': 'دليل إعدادات Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL لوكيل Claude',
  'settings.cliEnvClaudeApiKey': 'مفتاح API لـ Claude CLI',
  'settings.cliEnvCodexHome': 'مجلد Codex الرئيسي',
  'settings.cliEnvCodexBin': 'مسار ملف Codex التنفيذي',
  'settings.cliEnvCodexBaseUrl': 'Base URL لوكيل Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'مفتاح API لـ Codex/OpenAI CLI',
  'settings.modelCustom': 'مخصص (اكتب أدناه)...',
  'settings.modelCustomLabel': 'معرف النموذج المخصص',
  'settings.modelCustomPlaceholder': 'مثلاً: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'مزودو الوسائط',
  'settings.mediaProvidersHint': 'مفاتيح API لإنشاء الصور والفيديو والصوت. تخزن محلياً وتزامن مع البرنامج الخفي المحلي.',
  'settings.mcpServerTitle': 'Open Design MCP',
  'settings.mcpServerHint': 'كشف Open Design كخادم MCP لوكيل البرمجة الخاص بك.',
  'settings.externalMcpTitle': 'MCP خارجي',
  'settings.externalMcpHint': 'أضف أدوات MCP من خدمات خارجية (Higgsfield، GitHub، …).',
  'settings.mediaProviderApiKey': 'مفتاح API',
  'settings.mediaProviderBaseUrl': 'رابط القاعدة',
  'settings.mediaProviderConfigured': 'تم التكوين',
  'settings.mediaProviderUnset': 'غير محدد',
  'settings.mediaProviderClear': 'مسح',
  'settings.mediaProviderClearConfirm': 'مسح إعدادات {name} المحفوظة؟ ستحتاج إلى إدخالها مرة أخرى لاستخدام {name}.',
  'settings.mediaProviderPlaceholder': 'الصق مفتاح API',
  'settings.mediaProviderBaseUrlPlaceholder': 'تجاوز رابط القاعدة الافتراضي',
  'settings.mediaProviderReload': 'إعادة التحميل من الـ daemon المحلي',
  'settings.mediaProviderReloadError': 'تعذر إعادة تحميل إعدادات موفري الوسائط من الـ daemon المحلي.',
  'settings.mediaProviderReloadSuccess': 'تمت إعادة تحميل إعدادات موفري الوسائط من الـ daemon المحلي.',
  'settings.mediaProviderLoadError': 'تعذر تحميل إعدادات موفري الوسائط من الـ daemon المحلي. سيُستخدم مؤقتًا ما هو محفوظ في المتصفح.',
  'settings.mediaProviderComingSoonHint': 'نحن نتتبع هذه المزودات في خارطة الطريق؛ لم يقم البرنامج الخفي بشحن عميل بعد، لذا لا يوجد شيء لتكوينه.',
  'settings.privacy': 'الخصوصية',
  'settings.privacyHint': 'البيانات التي تتم مشاركتها مع فريق Open Design',
  'settings.privacyConsentKicker': 'ساعدنا في تحسين Open Design',
  'settings.privacyConsentLead': 'تساعدنا مشاركة بيانات الاستخدام على فهم أداء Open Design في مسارات العمل الحقيقية، حتى نتمكن من تحسين الأجزاء الأكثر تأثيرًا في تجربتك.',
  'settings.privacyConsentFooter': 'يمكنك تغيير هذه الخيارات في أي وقت من الإعدادات ← الخصوصية.',
  'settings.privacyConsentShare': 'مشاركة',
  'settings.privacyConsentDecline': 'عدم المشاركة',
  'settings.privacyConsentAccept': 'فهمت',
  'settings.privacyConsentBannerFooter': 'مشاركة البيانات مفعّلة افتراضيًا. يمكنك إيقافها في أي وقت من الإعدادات ← الخصوصية.',
  'settings.privacyConsentPolicyLink': 'اقرأ سياسة الخصوصية',
  'settings.privacyMetrics': 'مقاييس مجهولة المصدر',
  'settings.privacyMetricsHint': 'عدد مرات التشغيل، واستخدام Token، ومعدل الأخطاء، والمدة كمؤشرات استخدام أساسية.',
  'settings.privacyContent': 'محتوى المحادثة والأدوات',
  'settings.privacyContentHint': 'بعد إزالة الأسرار والمعلومات الحساسة الأخرى، نستخدم المطالبات وردود المساعد ومدخلات/مخرجات الأدوات والسياق اللازم لمراجعة الجودة.',
  'settings.privacyInstallationId': 'المُعرّف المجهول',
  'settings.privacyOptedOut': 'تم إلغاء الاشتراك',
  'settings.privacyDataDeletion': 'حذف بياناتي',
  'settings.privacyDataDeletionHint': 'يُجدّد مُعرّفك المجهول ويوقف الإرسال. تنتهي صلاحية الآثار الحالية وفقًا لسياسة الاحتفاظ لدينا.',
  'settings.about': 'حول',
  'settings.aboutHint': 'تفاصيل النسخة ووقت التشغيل',
  'settings.appVersion': 'النسخة',
  'settings.appChannel': 'القناة',
  'settings.appRuntime': 'وقت التشغيل',
  'settings.appPlatform': 'المنصة',
  'settings.appArchitecture': 'المعمارية',
  'settings.runtimePackaged': 'تطبيق معبأ',
  'settings.runtimeDevelopment': 'تطوير',
  'settings.versionUnavailable': 'تفاصيل النسخة غير متوفرة بينما البرنامج الخفي غير متصل.',
  "settings.allowSilentUpdates": "السماح بالتثبيت التلقائي لتحديثات التطبيق الداخلية المستقبلية",
  "settings.allowSilentUpdatesDesc": "عند جاهزية تحديث داخل التطبيق، ثبّته تلقائيًا عند التشغيل التالي. لا يرقّي الجلسة الحالية فورًا. تحديثات المثبّت ما زالت تطلب التأكيد أولًا.",
  'settings.installLatest': 'تثبيت الأحدث',
  'settings.alreadyLatest': 'أنت تستخدم أحدث إصدار',
  'settings.updateCheck': 'التحقق من التحديثات',
  'settings.updateNow': 'حدّث الآن',
  'settings.updateRecheck': 'التحقق مجددًا',
  'settings.updateRetry': 'إعادة المحاولة',
  'settings.updateViewReleases': 'ملاحظات الإصدار',
  'settings.updateActionFailed': 'تعذر إكمال إجراء التحديث.',
  'settings.updateQuitFailed': 'فُتح المثبّت، لكن Open Design لم يتمكن من الإغلاق تلقائيًا.',
  'settings.updateStatusNotChecked': 'لم يتم التحقق بعد',
  'settings.updateStatusDevelopment': 'إصدارات التطوير لا تدعم التحديث داخل التطبيق.',
  'settings.updateStatusUnsupported': 'هذه البيئة لا تدعم التحديث داخل التطبيق.',
  'settings.updateStatusChecking': 'جارٍ التحقق من التحديثات...',
  'settings.updateStatusUpToDate': 'لديك أحدث إصدار بالفعل.',
  'settings.updateStatusAvailable': 'تم العثور على الإصدار {version}. جارٍ تجهيز التنزيل.',
  'settings.updateStatusAvailableUnknown': 'تم العثور على إصدار جديد. جارٍ تجهيز التنزيل.',
  'settings.updateStatusDownloading': 'جارٍ تنزيل التحديث...',
  'settings.updateStatusDownloadingPercent': 'جارٍ تنزيل التحديث {percent}٪.',
  'settings.updateStatusReady': 'الإصدار {version} جاهز للتثبيت.',
  'settings.updateStatusReadyUnknown': 'التحديث جاهز للتثبيت.',
  'settings.updateStatusInstalling': 'جارٍ تثبيت التحديث...',
  'settings.updateStatusFailed': 'فشل التحقق. أعد المحاولة.',
  'settings.mcpTitle': 'خادم MCP',
  'settings.mcpHint': 'اسمح لوكلاء البرمجة (Cursor، Claude Code، VS Code…) بقراءة مشاريع Open Design الخاصة بك مباشرةً.',
  'settings.mcpDaemonError': 'تعذّر الوصول إلى الـ daemon المحلي لتحديد مسارات التثبيت ({error}). تأكد من أن Open Design قيد التشغيل، ثم أعد فتح هذه اللوحة.',
  'settings.mcpBuildDaemon': 'قم ببناء الـ daemon أولًا.',
  'settings.mcpNodeMissing': 'ملف Node التنفيذي مفقود.',
  'settings.mcpBuildHint': 'الملف apps/daemon/dist/cli.js مفقود. شغّل `pnpm --filter @open-design/daemon build` ثم حدّث.',
  'settings.mcpMethodCli': 'أمر CLI',
  'settings.mcpInstructionCli': 'شغّل هذا في الـ terminal لديك.',
  'settings.mcpMethodToml': 'إعداد TOML',
  'settings.mcpInstructionCodex': 'أضف هذا الجدول إلى {path}. يتم مشاركة الإعداد نفسه بين Codex CLI وامتداد Codex IDE.',
  'settings.mcpMethodOneClick': 'تثبيت بنقرة واحدة',
  'settings.mcpInstructionCursor': 'انقر على "Install in Cursor" للتثبيت عبر مربع حوار للموافقة، أو ادمج ملف JSON هذا في {path}.',
  'settings.mcpDeeplinkInstallCursor': 'التثبيت في Cursor',
  'settings.mcpMethodJson': 'إعداد JSON',
  'settings.mcpInstructionKiro': 'افتح {path} وادمج ملف JSON هذا. لإعداد على مستوى مساحة العمل، استخدم .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'افتح Command Palette ({shortcut})، وشغّل "MCP: Open User Configuration"، ثم ادمج ملف JSON هذا. يجب أن يكون Copilot Chat في وضع Agent حتى تظهر الأدوات.',
  'settings.mcpInstructionAntigravity': 'في Antigravity: قائمة "..." في لوحة الوكيل ← MCP Servers ← Manage MCP Servers ← View raw config. ادمج هذا الـ JSON.',
  'settings.mcpInstructionZed': 'افتح إعدادات Zed ({shortcut}) وادمج هذا في الكائن ذي المستوى الأعلى. يستخدم Zed "context_servers" وليس "mcpServers".',
  'settings.mcpInstructionWindsurf': 'افتح {path} (أو استخدم أيقونة MCPs في Cascade ← Configure) وادمج:',
  'settings.mcpCopyAria': 'نسخ مقتطف إعداد MCP',
  'settings.mcpResolvingFailed': '# فشل تحديد المسارات، راجع الخطأ أعلاه',
  'settings.mcpLoadingPaths': '# جارٍ تحميل مسارات التثبيت من الخدمة المحلية…',
  'settings.mcpCopied': 'تم النسخ',
  'settings.mcpCopy': 'نسخ',
  'settings.mcpCursorApproval': 'يُظهر Cursor مربع حوار للموافقة قبل كتابة الإعداد.',
  'settings.mcpCodexOneClickInstall': 'التثبيت في Codex',
  'settings.mcpCodexOneClickUninstall': 'الإزالة من Codex',
  'settings.mcpCodexOneClickUnavailable': 'لم يُعثر على Codex CLI في PATH — ثبّت Codex أو الصق المقتطف يدويًا.',
  'settings.mcpCodexInstallSuccess': 'تم التثبيت. أعد تشغيل Codex لتحميل الخادم الجديد.',
  'settings.mcpCodexUninstallSuccess': 'تمت الإزالة من Codex.',
  'settings.mcpCodexBusy': 'جارٍ العمل…',
  'settings.mcpCodexInstallError': 'فشلت العملية: {error}',
  'settings.mcpRestartNote': 'أعد تشغيل عميلك لالتقاط الخادم الجديد.',
  'settings.mcpRestartDetail': 'معظم المحررات تُحمّل خوادم MCP عند بدء التشغيل فقط. في Cursor / VS Code / Antigravity / Windsurf يمكنك تشغيل `Developer: Reload Window` من Command Palette بدلًا من إعادة التشغيل الكاملة. أما Zed و Claude Code فيحتاجان إلى الإغلاق وإعادة الفتح.',
  'settings.mcpCapabilitiesTitle': 'ما يستطيع Agent القيام به',
  'settings.mcpCapabilityRead': 'قراءة أي ملف في المشروع أو البحث فيه (HTML، JSX، CSS، JSON، SVG، Markdown).',
  'settings.mcpCapabilityPull': 'سحب حزمة تصميم في استدعاء واحد: ملف الإدخال إضافةً إلى كل متغير CSS ومكوّن وخط يشير إليه.',
  'settings.mcpCapabilityDefault': 'الاعتماد افتراضيًا على المشروع والملف المفتوحَين في Open Design، حتى تتمكن من قول "ابنِ هذا في تطبيقي" دون إعادة تحديد التصميم المقصود.',
  'settings.mcpRunningNote': 'يجب أن يكون Open Design قيد التشغيل حتى تنجح استدعاءات أدوات MCP. إذا بدأت تشغيل وكيل البرمجة قبل فتح Open Design، فأعد تشغيل الـ Agent ليتمكن من الوصول إلى الـ daemon النشط.',
  'entry.tabDesigns': 'التصاميم',
  'entry.tabTemplates': 'قوالب',
  'entry.tabDesignSystems': 'أنظمة التصميم',
  'entry.tabConnectors': 'الموصلات',
  'entry.openSettingsTitle': 'الإعدادات',
  'entry.openSettingsAria': 'فتح الإعدادات',
  'entry.discordLabel': 'انضم إلى Discord',
  'entry.discordAria': 'انضم إلى Discord الخاص بـ Open Design',
  'entry.discordAriaWithOnline': 'انضم إلى Discord الخاص بـ Open Design - {online}',
  'entry.discordOnlineLabel': '{count} متصل',
  'entry.mailAria': 'أرسل بريدًا إلكترونيًا إلى Open Design',
  'entry.accountSettings': 'الإعدادات',
  'chat.collapsePane': 'طيّ لوحة المحادثة',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'تابع @OpenDesignHQ على X',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.followInstagramLabel': 'تابع @opendesign.ai على Instagram',
  'entry.followLinkedinLabel': 'تابع Open Design على LinkedIn',
  'entry.followXiaohongshuLabel': 'تابع Open Design على Xiaohongshu',
  'entry.resizeAria': 'تغيير حجم الشريط الجانبي',
  'entry.loadingWorkspace': 'جاري تحميل مساحة العمل...',
  'entry.useEverywhereTitle': 'استخدمه في كل مكان',
  'entry.useEverywhereAria': 'افتح دليل «استخدمه في كل مكان» (CLI، MCP، HTTP، Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "المشاريع الشخصية",
  "workspaceSwitcher.allProjectsTooltip": "مشاريع الفريق",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingFamilyCreator": "Creator",
  "entry.upgradeTitle": "Upgrade plan",
  "entry.upgradeCreditsExhaustedTitle": "Credits exhausted",
  "entry.upgradeAutoRechargeTitle": "Auto recharge",
  "entry.upgradeDialogAria": "Upgrade plan",
  "entry.upgradeSubtitle": "Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeCreditsExhaustedSubtitle": "You need more credits to continue. Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeAutoRechargeMemberSubtitle": "Enable a separate allowance for {member}. Saving this setting will not charge immediately; credits refill only when this member falls below the threshold.",
  "entry.upgradeAutoRechargeTeamSubtitle": "Enable an allowance for all teammates. Saving this setting will not charge immediately; team credits refill only when the balance falls below the threshold.",
  "entry.upgradeScopeLabel": "Scope",
  "entry.upgradeScopeMember": "{member} · single-member allowance",
  "entry.upgradeScopeTeam": "All teammates · shared allowance",
  "entry.upgradePaymentHint": "Uses the subscription payment method by default. You can manage it anytime.",
  "entry.upgradeManagePayment": "Manage payment method",
  "entry.upgradeMonthlyLimit": "Monthly limit",
  "entry.upgradeLimitCustom": "",
  "entry.upgradeLimitUnlimited": "∞ unlimited (no monthly cap)",
  "entry.upgradeBillingCycleAria": "Billing cycle",
  "entry.upgradeAnnual": "Annual",
  "entry.upgradeAnnualSave": "Save 20%",
  "entry.upgradeMonthly": "Monthly",
  "entry.upgradePlanPlus": "Personal Plus",
  "entry.upgradePlanPlusDesc": "Basic token allowance · SOTA models",
  "entry.upgradePlanPro": "Personal Pro",
  "entry.upgradePlanProDesc": "3x token allowance · top multimodal models",
  "entry.upgradePlanMax": "Personal Max",
  "entry.upgradePlanMaxDesc": "10x token allowance · top multimodal models",
  "entry.upgradePlanTeam": "Teams",
  "entry.upgradePlanTeamDesc": "Collaboration · shared assets · role permissions",
  "entry.upgradePriceUnitMonth": "/mo",
  "entry.upgradePriceUnitSeat": "/seat/mo",
  "entry.upgradeProrateAnnualPrefix": "Annual billing saves 20%; ",
  "entry.upgradeProrateMonthlyPrefix": "Monthly billing; ",
  "entry.upgradeProrateSuffix": "upgrades are prorated for the current billing cycle and take effect immediately.",
  "entry.upgradeBack": "Back",
  "entry.upgradeAutoRechargeSaved": "Auto recharge settings saved",
  "entry.upgradeConfirm": "Confirm payment and upgrade",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "الحصة",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help on GitHub",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "تسجيل الخروج",
  "signOut.confirmMessage": "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
  "signOut.confirmAction": "تسجيل الخروج",
  "entry.navRecents": "الرئيسية",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace للفِرَق — أخبرنا باحتياجات فريقك',
  'entry.workspaceTeamsAria': 'فتح صفحة Workspace للفِرَق',
  'entry.navExpand': 'توسيع الشريط الجانبي',
  'entry.navCollapse': 'طي الشريط الجانبي',
  'entry.navNewProject': 'مشروع جديد',
  'entry.navHome': 'الرئيسية',
  'entry.navProjects': 'المشاريع',
  'entry.navTasks': 'الأتمتة',
  'entry.navPlugins': 'الإضافات',
  'entry.navDesignSystems': 'أنظمة التصميم',
  'entry.navBrands': 'حزمة العلامة التجارية',
  'entry.navIntegrations': 'عمليات الدمج',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'المشاريع الشخصية',
  'entry.navAllProjects': 'مشاريع الفريق',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "Open Design Cloud",
  "entry.cloudCalloutBody": "سجّل الدخول لاستخدام Open Design Cloud والتعاون عبر السحابة",
  "entry.cloudCalloutDismissAria": "إغلاق ملاحظة Open Design Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'Open Design updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'workspaceTabs.project': 'المشروع',
  'workspaceTabs.pluginDetails': 'تفاصيل الإضافة',
  'workspaceTabs.marketplace': 'المتجر',
  'homeHero.title': 'ماذا ستصمم مع وكيلك اليوم؟',
  'homeHero.startWithTemplate': 'ابدأ بقالب…',
  'homeHero.startBlankProject': 'ابدأ مشروعًا فارغًا',
  'homeHero.templatePicker.label': 'نوع الإنشاء',
  'homeHero.templatePicker.searchPlaceholder': 'البحث في القوالب',
  'homeHero.templatePicker.projectTypes': 'أنواع المشاريع',
  'homeHero.templatesScrollHint': 'مرّر لأعلى لاستكشاف المزيد من القوالب',
  'homeHero.templatesCollapse': 'طيّ القوالب',
  'homeHero.subtitlePrefix': 'بديل Claude Design متاح المصدر.',
  'homeHero.placeholder': 'صِف ما تريد إنشاءه…',
  'homeHero.placeholderActive': 'عدّل الاستعلام المثال أو اكتب استعلامك الخاص…',
  'homeHero.carousel.hint': 'أرفق ملفًا، أو اربط نظام التصميم الخاص بك، أو صف ما تريد إنشاءه',
  'homeHero.carousel.onePageBrief': 'كتابة موجز مشروع من صفحة واحدة',
  'homeHero.carousel.notesToDeck': 'تحويل ملاحظاتي إلى عرض تقديمي',
  'homeHero.carousel.signupFlow': 'تصميم نموذج لتدفق التسجيل',
  'homeHero.carousel.improveBrief': 'تحسين موجز مشروع موجود',
  'homeHero.carousel.loadingAnimation': 'إنشاء رسم متحرك للتحميل',
  'homeHero.carousel.teamUpdateSlides': 'تصميم شرائح لتحديث الفريق',
  'homeHero.carousel.ordersDashboard': 'إنشاء نموذج أولي للوحة تتبع الطلبات',
  'homeHero.carousel.productDetail': 'تنسيق صفحة تفاصيل المنتج',
  'homeHero.carousel.caseStudy': 'وضع مخطط لدراسة حالة',
  'homeHero.carousel.landingIntro': 'تصميم مقدمة قصيرة لصفحة هبوط',
  'homeHero.carousel.pitchDeck': 'إنشاء عرض تقديمي ترويجي لمنتج جديد',
  'homeHero.carousel.appIdea': 'وصف فكرة تطبيق',
  'homeHero.carousel.landingLayout': 'رسم تخطيط لصفحة هبوط',
  'homeHero.skills': 'المهارات',
  'homeHero.addMenu': 'إضافة سياق',
  'homeHero.addPlugin': 'إضافة مكوّن إضافي',
  'homeHero.addConnectors': 'إضافة موصّلات',
  'homeHero.addMcp': 'إضافة خادم MCP',
  'homeHero.noPlugins': 'لا توجد مكوّنات إضافية مثبّتة',
  'homeHero.noMcp': 'لا توجد خوادم MCP',
  'homeHero.noConnectors': 'لا توجد موصّلات متصلة',
  'homeHero.applying': 'جارٍ التطبيق…',
  'homeHero.pluginTitle': 'الإضافة: {title}',
  'homeHero.pluginPrefix': 'الإضافة: {title}',
  'homeHero.skillPrefix': 'المهارة: {title}',
  'homeHero.removePlugin': 'إزالة الإضافة',
  'homeHero.removePluginAria': 'إزالة الإضافة {title}',
  'homeHero.clearActivePlugin': 'مسح الإضافة النشطة',
  'homeHero.clearActiveSkill': 'مسح المهارة النشطة',
  'homeHero.contextItemsResolved': 'تم حلّ {n} من عناصر السياق',
  'homeHero.removeFile': 'إزالة الملف',
  'homeHero.contextSearchResults': 'نتائج بحث السياق',
  'homeHero.contextSurfaces': 'أسطح السياق',
  'homeHero.loadingContext': 'جارٍ تحميل السياق…',
  'homeHero.noResults': 'لا توجد نتائج لـ "{query}".',
  'homeHero.searchPrompt': 'ابحث في الملفات والإضافات والمهارات وخوادم MCP والموصّلات.',
  'homeHero.parameters': '{n} معامل',
  'homeHero.details': 'التفاصيل',
  'homeHero.toRun': 'للتشغيل',
  'homeHero.forNewLine': 'لسطر جديد',
  'homeHero.run': 'تشغيل',
  'homeHero.typeSomethingToRun': 'اكتب شيئًا لتشغيله',
  'homeHero.promptExamples': 'أمثلة',
  'homeHero.footer.designSystem': 'النمط',
  'homeHero.footer.autoDesignSystem': 'تلقائي',
  'homeHero.footer.autoDesignSystemSummary': 'يطابق تلقائياً نظام التصميم والأسلوب البصري الأنسب للموجه الحالي.',
  'homeHero.footer.ratio': 'النسبة',
  'homeHero.footer.duration': 'المدة',
  'homeHero.footer.resolution': 'الدقة',
  'homeHero.footer.speakerNotes': 'الملاحظات',
  'homeHero.footer.noSpeakerNotes': 'بلا ملاحظات',
  'homeHero.footer.availableCount': '{n} متاح',
  'homeHero.footer.noMatches': 'لا توجد تطابقات',
  'homeHero.moreShortcuts': 'المزيد',
  'homeHero.railAria': 'اختر فئة مشروع أو اختصار بداية',
  'homeHero.subTypeAria': 'اختر نوعًا فرعيًا',
  'homeHero.subTypeMore': 'المزيد',
  'homeHero.confirmReplaceTitle': 'استبدال الموجّه الحالي؟',
  'homeHero.confirmReplaceBody': 'سيؤدي استخدام {title} إلى استبدال النص الموجود حاليًا في حقل الإدخال.',
  'homeHero.confirmReplace': 'استبدال',
  'homeHero.chip.prototype': 'UI Mockup',
  'homeHero.chip.webClone': 'استنساخ موقع ويب',
  'homeHero.chip.liveArtifact': 'عنصر حيّ',
  'homeHero.chip.deck': 'عرض شرائح',
  'homeHero.chip.image': 'صورة',
  'homeHero.chip.video': 'فيديو',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'تجربة WebGL',
  'homeHero.chip.webglDesc': 'ظلّالات وثلاثي الأبعاد ومرئيات GPU توليدية',
  'homeHero.chip.worker': 'مُصوِّر Worker',
  'homeHero.chip.workerDesc': 'محاكاة خارج الخيط الرئيسي وجسيمات وتصوير بيانات',
  'homeHero.chip.audio': 'صوت',
  'homeHero.chip.createBrandKit': 'إنشاء حزمة العلامة التجارية',
  'homeHero.chip.createPlugin': 'إنشاء إضافة',
  'homeHero.chip.figma': 'من Figma',
  'homeHero.chip.folder': 'من مجلد',
  'homeHero.chip.template': 'من قالب',
  'homeHero.chip.liveArtifactHint': 'أنشئ عنصرًا تفاعليًا بـ HTML/CSS/JS يمكنك معاينته مباشرة.',
  'homeHero.chip.hyperframesHint': 'صمّم حركة قائمة على HTML: تسميات توضيحية، ومرئيات تتفاعل مع الصوت، وانتقالات بين المشاهد.',
  'homeHero.chip.createBrandKitHint': 'استخرج حزمة علامة تجارية من موقع ويب ثم طبّقها في أي محادثة.',
  'homeHero.chip.createPluginHint': 'أنشئ إضافة Open Design قابلة لإعادة الاستخدام وأضِفها إلى إضافاتي.',
  'homeHero.chip.figmaHint': 'رحّل إطار Figma إلى نظام التصميم النشط.',
  'homeHero.chip.folderHint': 'استورد مجلدًا محليًا موجودًا وتابع التحرير.',
  'homeHero.chip.templateHint': 'ابدأ من قالب مُضمّن.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.triggerShort': 'Working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'مجلد',
  'workingDirPicker.homeTitle': 'محفوظ في التخزين المحلي — انقر لاختيار مجلد',
  'workingDirPicker.processing': 'جارٍ المعالجة…',
  'workingDirPicker.select': 'التخزين المحلي',
  'workingDirPicker.clearAria': 'مسح دليل العمل',
  'workingDirPicker.replaceFailed': 'تعذّر استبدال دليل العمل',
  'workingDirPicker.unavailable': 'منتقي المجلدات غير متاح في هذه النسخة. شغّل تطبيق سطح المكتب لاختيار مجلد.',
  'workingDirPicker.openUnavailable': 'افتح هذا المشروع في تطبيق سطح المكتب لإظهار المجلد.',
  'workingDirPicker.openFailed': 'تعذّر إظهار هذا المجلد',
  'workingDirPicker.showInFileManager': 'إظهار في مدير الملفات',
  'workingDirPicker.replace': 'اختيار مجلد…',
  'workingDirPicker.recent': 'الأدلّة الأخيرة',
  'workingDirPicker.defaultLabel': 'التخزين المحلي',
  'handoff.toTarget': 'التسليم إلى {target}',
  'handoff.openInTarget': 'فتح في {target}',
  'handoff.openAction': 'فتح',
  'handoff.menuTitle': 'الفتح في أي محرر؟',
  'handoff.action': 'تسليم',
  'handoff.fallbackTitle': 'لم يُعثر على محررات في $PATH - يُفتح في {target}',
  'handoff.chooseTargetAria': 'اختر وجهة التسليم',
  'handoff.optionsAria': 'خيارات التسليم',
  'handoff.editorSection': 'الفتح باستخدام محرر',
  'handoff.cliSection': 'نسخ لاستخدام CLI',
  'handoff.clickOpen': 'انقر للفتح',
  'handoff.framework': 'إطار عمل الكود',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript و HTML و CSS الأساسية',
  'handoff.amrWebsite': 'فتح موقع Open Design Cloud',
  'handoff.copyPrompt': 'نسخ الموجّه',
  'handoff.copyPromptForTarget': 'نسخ الموجّه لـ {target}',
  'handoff.copied': 'تم النسخ',
  'handoff.projectPathUnavailable': 'لا يزال مسار المشروع قيد التحميل. حاول مرة أخرى بعد لحظة.',
  'handoff.copyFailed': 'تم حظر الكتابة إلى الحافظة. حاول مرة أخرى بعد لحظة.',
  'handoff.promptIntro': 'المتابعة من مجلد مشروع Open Design المحلي هذا:',
  'handoff.promptTarget': 'الوجهة',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'أنت تتولّى المهمة الآن في {cli}. يُرجى:',
  'handoff.promptReadFiles': 'ادخل إلى هذا الدليل أو اقرأه أولاً. أعطِ الأولوية لـ DESIGN.md و README وملفات HTML/CSS/JS الموجودة والأصول و package.json إن وُجد.',
  'handoff.promptKeepDesign': 'حافظ على التصميم المرئي الحالي والتخطيط والتفاعلات والأصول. لا تتوقف عند مرحلة التخطيط.',
  'handoff.promptProduceCode': 'أنشئ أو عدّل كود {framework} قابل للتشغيل فعليًا. إذا كان للمشروع بالفعل حزمة تقنية أوضح، فأشر إلى التعارض وأبقِ النتيجة قابلة للتشغيل.',
  'handoff.promptVerify': 'اختم بإخباري بأوامر التشغيل والمعاينة والتحقق.',
  'handoff.promptCommandHint': 'للبدء من دليل المشروع، استخدم:',
  'handoff.promptProject': 'المشروع',
  'handoff.promptProjectId': 'معرّف المشروع',
  'handoff.notInstalled': 'غير مُثبَّت',
  'handoff.notDetectedTitle': '{target} - لم يُكتشف في $PATH',
  'designSystemPicker.select': 'اختر نظام التصميم',
  'designSystemPicker.loading': 'جارٍ تحميل أنظمة التصميم…',
  'designSystemPicker.searchPlaceholder': 'البحث في أنظمة التصميم (العنوان / الفئة / الملخص)',
  'designSystemPicker.searchCompactPlaceholder': 'البحث في أنظمة التصميم',
  'designSystemPicker.noneTitle': 'بدون نظام تصميم',
  'designSystemPicker.noneSummary': 'دع النموذج يختار بحرية',
  'designSystemPicker.empty': 'لا توجد أنظمة تصميم مطابقة',
  'designSystemPicker.openPreview': 'فتح المعاينة',
  'designSystemPicker.loadingPreview': 'جارٍ تحميل المعاينة…',
  'designSystemPicker.noPreview': 'لا توجد صفحة معاينة. افتح أنظمة التصميم لعرض المعاينة الكاملة.',
  'designSystemPicker.previewHint': 'مرّر المؤشر فوق نظام تصميم لمعاينته',
  'designSystemPicker.fullscreenAria': 'معاينة {title} بملء الشاشة',
  'designSystemPicker.closeFullscreen': 'إغلاق معاينة ملء الشاشة',
  'designSystemPicker.closeEsc': 'إغلاق (Esc)',
  'designSystemPicker.previewFrameTitle': 'معاينة {title}',
  'designSystemPicker.fullscreenFrameTitle': 'معاينة {title} بملء الشاشة',
  'recentProjects.title': 'المشاريع الأخيرة',
  'recentProjects.viewAll': 'عرض الكل',
  'recentProjects.empty': 'لا توجد مشاريع بعد — اكتب موجّهًا لبدء مشروع.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'مسح عوامل التصفية',
  'pluginsHome.title': 'المجتمع',
  'pluginsHome.subtitle': 'سير عمل Open Design جاهز للاستخدام ومرفق بهذا التشغيل. اختر واحدًا لتحميل موجّه بدء، أو تصفّح السجل للمزيد.',
  'pluginsHome.browseRegistry': 'تصفح السجل',
  'pluginsHome.count': '{filtered} من {total}',
  'pluginsHome.loadingCatalog': 'جارٍ تحميل الكتالوج…',
  'pluginsHome.emptyCatalog': 'الكتالوج فارغ. تأتي الإضافات المُجمَّعة مع Open Design ومن المفترض أن تظهر هنا تلقائيًا — جرّب إعادة تشغيل الـ daemon إذا استمرت هذه المشكلة.',
  'pluginsHome.emptyFiltered': 'لا توجد إضافات تطابق عوامل التصفية الحالية.',
  'pluginsHome.clearFilters': 'مسح عوامل التصفية',
  'pluginsHome.modeAria': 'وضع الإضافات',
  'pluginsHome.featured': 'محفوظ',
  'pluginsHome.totalInCatalog': '{n} في الكتالوج',
  'pluginsHome.categoryFilterAria': 'تصفية حسب الفئة',
  'pluginsHome.subcategoryFilterAria': 'تصفية حسب الفئة الفرعية لـ {label}',
  'pluginsHome.allCategory': 'كل {label}',
  'pluginsHome.searchPlaceholder': 'البحث عن الإضافات…',
  'pluginsHome.searchAria': 'البحث في الإضافات',
  'pluginsHome.clearSearch': 'مسح البحث',
  'pluginsHome.sortAria': 'ترتيب الفرز',
  'pluginsHome.sortHot': 'الأكثر رواجًا',
  'pluginsHome.sortNewest': 'الأحدث',
  'pluginsHome.facet.import': 'استيراد',
  'pluginsHome.facet.create': 'إنشاء',
  'pluginsHome.facet.export': 'تصدير',
  'pluginsHome.facet.share': 'مشاركة',
  'pluginsHome.facet.deploy': 'نشر',
  'pluginsHome.facet.refine': 'تحسين',
  'pluginsHome.facet.extend': 'توسيع',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'كود / مجلد',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'لقطة شاشة',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'شرائح',
  'pluginsHome.facet.publicLink': 'رابط عام',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'لوحات المعلومات',
  'pluginsHome.subfacet.app-prototypes': 'تطبيقات',
  'pluginsHome.subfacet.landing-marketing': 'صفحات هبوط / تسويق',
  'pluginsHome.subfacet.developer-tools': 'أدوات المطورين',
  'pluginsHome.subfacet.docs-reports': 'مستندات / تقارير',
  'pluginsHome.subfacet.brand-design': 'علامة / تصميم',
  'pluginsHome.subfacet.pitch-business': 'عرض / أعمال',
  'pluginsHome.subfacet.course-training': 'دورات / تدريب',
  'pluginsHome.subfacet.reports-briefings': 'تقارير / موجزات',
  'pluginsHome.subfacet.product-sales': 'منتج / مبيعات',
  'pluginsHome.subfacet.engineering-talks': 'محاضرات تقنية',
  'pluginsHome.subfacet.creative-decks': 'عروض إبداعية',
  'pluginsHome.subfacet.ui-product-mockups': 'واجهات / نماذج منتج',
  'pluginsHome.subfacet.brand-visuals': 'علامة / شعار',
  'pluginsHome.subfacet.storyboards-motion-refs': 'قصص مصورة',
  'pluginsHome.subfacet.social-content': 'سوشيال / محتوى',
  'pluginsHome.subfacet.avatar-portrait': 'صورة رمزية / بورتريه',
  'pluginsHome.subfacet.illustration-style': 'رسوم / أسلوب',
  'pluginsHome.subfacet.motion-effects': 'حركة / مؤثرات',
  'pluginsHome.subfacet.social-short-form': 'سوشيال / فيديو قصير',
  'pluginsHome.subfacet.marketing-product': 'تسويق / منتج',
  'pluginsHome.subfacet.data-explainers': 'بيانات / شروحات',
  'pluginsHome.subfacet.cinematic-story': 'سينمائي / قصة',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'تصفّح سير العمل المثبّتة، واكتشف إدخالات السجل، وأدر المصادر، وجهّز الإضافات لتوزيعها على الفريق.',
  'pluginsView.importPlugin': 'استيراد إضافة',
  'pluginsView.agentContext': 'سياق الـ Agent',
  'pluginsView.summaryAria': 'ملخص الإضافة',
  'pluginsView.areasAria': 'مجالات الإضافة',
  'pluginsView.loading': 'جارٍ تحميل الإضافات…',
  'pluginsView.tab.installed': 'مثبّت',
  'pluginsView.tab.available': 'متاح',
  'pluginsView.tab.sources': 'المصادر',
  'pluginsView.tab.team': 'الفريق',
  'pluginsView.tabHint.installed': 'إضافاتك',
  'pluginsView.tabHint.available': 'من المصادر',
  'pluginsView.tabHint.sources': 'الكتالوجات',
  'pluginsView.tabHint.team': 'المؤسسات',
  'pluginsView.installedTitle': 'الإضافات المثبّتة',
  'pluginsView.installedSubtitle': 'الإضافات التي قمت باستيرادها أو تثبيتها من مصادر المتجر.',
  'pluginsView.installedEmpty': 'لا توجد إضافات مستخدم مثبّتة بعد. استخدم إنشاء / استيراد أو ثبّت إدخالاً متاحاً.',
  'pluginsView.availableTitle': 'متاح من المصادر',
  'pluginsView.availableSubtitle': 'إدخالات الكتالوج المكتشفة من المتاجر المُهيّأة.',
  'pluginsView.availableFiltersAria': 'عوامل تصفية الإضافات المتاحة',
  'pluginsView.searchAvailableAria': 'البحث في الإضافات المتاحة',
  'pluginsView.searchAvailablePlaceholder': 'البحث في الإضافات المتاحة',
  'pluginsView.clearAvailableSearch': 'مسح بحث الإضافات المتاحة',
  'pluginsView.source': 'المصدر',
  'pluginsView.availableEmptyInstalled': 'لا توجد إدخالات متاحة بعد. تُزال إدخالات الكتالوج المثبّتة من المتاح؛ ألغِ تثبيت أحدها لإتاحته من جديد.',
  'pluginsView.availableEmptyFiltered': 'لا توجد إدخالات متاحة تطابق عوامل التصفية الخاصة بك.',
  'pluginsView.availableEmptyNoSources': 'لا توجد إدخالات متاحة بعد. أضف مصدراً في علامة تبويب المصادر.',
  'pluginsView.installing': 'جارٍ التثبيت…',
  'pluginsView.installWaiting': 'في الانتظار…',
  'pluginsView.installQueuedHint': 'يجري تثبيت إضافة أخرى. تُنفَّذ عمليات التثبيت واحدة تلو الأخرى — سيتاح هذا الزر عند انتهائها.',
  'pluginsView.install': 'تثبيت',
  'pluginsView.sourcesTitle': 'مصادر السجل',
  'pluginsView.sourcesSubtitle': 'كتالوجات السوق التي تغذّي إدخالات الإضافات المتاحة.',
  'pluginsView.sourceUrl': 'عنوان URL المصدر',
  'pluginsView.defaultTrust': 'الثقة الافتراضية',
  'pluginsView.trust.restricted': 'مقيّد',
  'pluginsView.trust.trusted': 'موثوق',
  'pluginsView.trust.official': 'رسمي',
  'pluginsView.adding': 'جارٍ الإضافة…',
  'pluginsView.addSource': 'إضافة مصدر',
  'pluginsView.sourcesEmpty': 'لم يتم تكوين أي مصادر سجلّ بعد.',
  'pluginsView.pluginsCount': '{n} إضافة',
  'pluginsView.catalogVersion': 'كتالوج الإصدار v{version}',
  'pluginsView.trustFor': 'الثقة في {name}',
  'pluginsView.refreshing': 'جارٍ التحديث…',
  'pluginsView.removing': 'جارٍ الإزالة…',
  'pluginsView.teamTitle': 'أسواق الفِرق الخاصة',
  'pluginsView.teamBody': 'هذه المنطقة مخصّصة لكتالوجات المؤسسات والفِرق، وسياسات الثقة الخاصة، وعناصر التحكم المشتركة بدورة حياة الإضافات.',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to Open Design.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "Open Design official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. Open Design will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from Open Design official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "مزامنة مع الفريق",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "تمت مزامنة أحدث إصدار من \"{title}\" مع الفريق.",
  "pluginsView.syncUnavailable": "تعذّرت مزامنة \"{title}\" حتى الآن. تأكد من أنك ضمن مساحة عمل جماعية.",
  "pluginsView.syncFailed": "تعذّرت مزامنة \"{title}\" مع الفريق. حاول مرة أخرى لاحقًا.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginCard.details': 'التفاصيل',
  'pluginCard.use': 'استخدام',
  'pluginCard.useWithQuery': 'استخدام مع استعلام',
  'pluginCard.applying': 'جارٍ التطبيق…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'جارٍ Remix…',
  'pluginCard.duplicateFailed': 'تعذّر Remix هذا القالب.',
  'pluginCard.saved': 'محفوظ',
  'pluginCard.publish': 'نشر',
  'pluginCard.contribute': 'المساهمة',
  'pluginCard.starting': 'جارٍ البدء…',
  'pluginCard.detailsAria': 'عرض تفاصيل {title}',
  'pluginCard.chooseUseAria': 'اختر كيفية استخدام {title}',
  'pluginCard.useOptionsAria': 'خيارات استخدام {title}',
  'pluginCard.duplicateAria': 'Remix {title} كمشروع جديد',
  'pluginCard.saveAria': 'حفظ {title}',
  'pluginCard.savedAria': 'تم حفظ {title}',
  'pluginCard.shareAria': 'مشاركة {title}',
  'pluginCard.publishAria': 'نشر {title} كمستودع GitHub',
  'pluginCard.publishTitle': 'نشر الإضافة كمستودع GitHub',
  'pluginCard.contributeAria': 'المساهمة بـ {title} في Open Design',
  'pluginCard.contributeTitle': 'المساهمة بالإضافة في Open Design عبر طلب سحب (PR)',
  'skillPluginCandidate.createForMe': 'إنشاء إضافة/قالب',
  'skillPluginCandidate.contributeToMain': 'المساهمة في open-design',
  'skillPluginCandidate.repoDescription': 'يبدو أن هذا المستودع يمكن أن يعمل كإضافة.',
  'integrations.kicker': 'التكامل',
  'integrations.lede': 'اربط الأنظمة الخارجية، وأدخِل أدوات MCP إلى حلقة الـ Agent الخاصة بك، واستخدم Open Design من بيئات تطوير وبرامج نصية وعمليات أتمتة أخرى.',
  'integrations.agentReady': 'جاهز للـ Agent',
  'integrations.areasAria': 'مجالات التكامل',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'المهارات',
  'integrations.tabHint.mcp': 'الأدوات الخارجية',
  'integrations.tabHint.connectors': 'الحسابات وواجهات API',
  'integrations.tabHint.useEverywhere': 'CLI وHTTP وMCP',
  'integrations.skillsTitle': 'تكاملات المهارات',
  'integrations.skillsBody': 'يجري نقل إدارة التكامل على مستوى المهارات من فرع آخر. هذا التبويب محجوز لكي يكون إعداد MCP والموصِّلات والمهارات المستقبلية ضمن مسار التكامل نفسه.',
  'mcpClient.title': 'خوادم MCP الخارجية',
  'mcpClient.subtitle': 'أدوات الطرف الثالث الخاصة بـ Agent البرمجة لديك.',
  'mcpClient.addServer': 'إضافة خادم',
  'mcpClient.emptyTitle': 'لم يتم تكوين أي خوادم MCP.',
  'mcpClient.emptyBody': 'انقر على "إضافة خادم" للبدء — اختر قالبًا (Higgsfield OpenClaw، Pollinations، Allyson، Imagician، EdgeOne Pages، GitHub، Filesystem…) أو قم بإعداد خادم stdio / HTTP مخصص.',
  'mcpClient.saveChanges': 'حفظ التغييرات',
  'mcpClient.storedAt': 'مخزَّن في',
  'mcpClient.daemonError': 'تعذّر الوصول إلى الخدمة المحلية. تأكّد من أن Open Design قيد التشغيل، ثم أعِد فتح هذه اللوحة.',
  'mcpClient.saveFailed': 'فشل الحفظ. تحقّق من أن الخدمة قيد التشغيل وحاول مرة أخرى.',
  'useEverywhere.modalAria': 'استخدم Open Design في كل مكان',
  'useEverywhere.modalTitle': 'استخدم Open Design في كل مكان',
  'useEverywhere.modalSubtitle': 'أدرِج Open Design في أي IDE أو Agent أو سكربت — CLI وHTTP وMCP وSkills. استخدم “Copy guide for an agent” والصقه في Claude Code أو Codex أو Cursor أو openclaw أو hermes لإعداد كل شيء.',
  'useEverywhere.closeAria': 'إغلاق الاستخدام في كل مكان',
  'useEverywhere.closeTitle': 'إغلاق (Esc)',
  'useEverywhere.tabsAria': 'واجهات التكامل',
  'useEverywhere.footStrong': 'تسليم بنقرة واحدة.',
  'useEverywhere.footBody': 'ينسخ دليلًا منظّمًا بصيغة markdown يمكن لـ Agent الخاص بك التصرف بناءً عليه فورًا — التثبيت والتحقق والاستخدام.',
  'useEverywhere.configureMcp': 'تكوين خادم MCP',
  'useEverywhere.copyGuide': 'نسخ الدليل لـ Agent',
  'useEverywhere.copy': 'نسخ',
  'useEverywhere.copied': 'تم النسخ',
  'useEverywhere.copyFailed': 'فشل النسخ',
  'useEverywhere.copySnippetAria': 'نسخ المقتطف: {label}',
  'useEverywhere.section.overview.tab': 'نظرة عامة',
  'useEverywhere.section.overview.heading': 'يعمل Open Design أينما يعمل الـ Agent الخاص بك',
  'useEverywhere.section.overview.intro': 'Open Design أكثر من مجرد نافذة — إنه daemon محلي ذو صلاحيات (`od`) إضافةً إلى سجل Skills + Design-Systems + Atoms. بمجرد تشغيله على جهازك، يمكن لأي Agent برمجي (Claude Code، Codex، Cursor، OpenCode/openclaw، Hermes، السكربت الخاص بك) أن يقود عمليات التوليد ويفحص المشاريع وينتج مخرجات التصميم عبر أربعة أسطح قابلة للتبادل.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` للسكربتات بلا واجهة، وCI، وأتمتة الـ shell.',
  'useEverywhere.section.overview.bullet2': 'خادم MCP — يربط Open Design كخادم Model Context Protocol بحيث يمكن لأي Agent يدعم MCP سرد المهارات وتشغيل السيناريوهات وقراءة المخرجات.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — نقاط نهاية REST + SSE على `http://127.0.0.1:7456/api/*`؛ نفس السطح الذي تستخدمه واجهة الويب.',
  'useEverywhere.section.overview.bullet4': 'Skills — حزم `SKILL.md` جاهزة للاستخدام (متوافقة مع Claude) يمكن لأي Agent موجود مسبقًا على الـ PATH استدعاؤها دون الحاجة إلى Open Design على الإطلاق.',
  'useEverywhere.section.overview.bullet5': 'المخرجات القياسية — أنشئ مشاريع HTML حقيقية انطلاقًا من Skills، والإضافات الافتراضية المُجمَّعة، وأمثلة إضافات المجتمع قبل بدء تشغيل الـ daemon.',
  'useEverywhere.section.overview.snippet1': 'تشغيل الـ daemon (وواجهة الويب) محليًا',
  'useEverywhere.section.overview.snippet2': 'تأكّد من إمكانية الوصول إليه',
  'useEverywhere.section.overview.snippet3': 'استيراد العناصر القياسية قبل الإقلاع',
  'useEverywhere.section.overview.footer': 'يكتب الـ daemon إلى `./.od/` (محلي للمشروع) افتراضيًا. عيّن `OD_DATA_DIR=~/.open-design` لمشاركة البيانات عبر المشاريع.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'تشغيل Open Design من أي shell',
  'useEverywhere.section.cli.intro': 'يُشحن الملف التنفيذي `od` مع الـ daemon وهو نفس الملف الثنائي الذي يستخدمه Claude Code / Codex عند تشغيل عملية توليد. معظم الأوامر الفرعية هي عملاء بسطاء يرسلون POST إلى الـ daemon المحلي، لذا فهي تعمل بالطريقة نفسها سواء شغّلته عبر `pnpm tools-dev` أو كتطبيق مُحزَّم.',
  'useEverywhere.section.cli.bullet1': '`od` (بدون وسائط) — يُقلِع الـ daemon ويفتح واجهة الويب.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — أنتِج بايتات الصورة / الفيديو / الصوت عبر بروتوكول الوسائط الموحّد.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — ابدأ تشغيل مشروع انطلاقًا من موجّه + مهارة.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — ثبِّت وطبِّق إضافات المجتمع.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — افحص ما هو متاح محليًا.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — تحقق من سلامة الـ daemon واكتشف أدوات Agent CLI على الـ PATH الخاص بك.',
  'useEverywhere.section.cli.snippet1': 'توليد صورة (يُفوَّض إلى مزوّد الوسائط المُهيّأ)',
  'useEverywhere.section.cli.snippet2': 'تشغيل ملحق سيناريو بدون واجهة وبثّ الأحداث كأسطر JSON',
  'useEverywhere.section.cli.snippet3': 'جرد المهارات وأنظمة التصميم المتاحة محليًا',
  'useEverywhere.section.cli.snippet4': 'التحقّق من العناصر المُهيّأة عبر الـ CLI',
  'useEverywhere.section.cli.snippet5': 'التحقق من البيئة + الـ Agents المكتشفة (Claude، Codex، Cursor، …)',
  'useEverywhere.section.cli.footer': 'تقبل جميع الأوامر الفرعية `--daemon-url http://127.0.0.1:<port>` لاستهداف daemon معيّن قيد التشغيل — مفيد عند تشغيل نسخة ثانية معزولة للاختبارات.',
  'useEverywhere.section.mcp.tab': 'خادم MCP',
  'useEverywhere.section.mcp.heading': 'اجعل Open Design متاحًا كخادم MCP لأي coding agent',
  'useEverywhere.section.mcp.intro': 'يأتي Open Design مع خادم Model Context Protocol (`od mcp`) يتيح لأي عميل يدعم MCP — Cursor، Claude Code، Antigravity، VS Code Copilot Chat، openclaw، hermes — اكتشاف أدوات Open Design (سرد المهارات، عرض المعاينات، توليد الوسائط، تشغيل الإضافات) دون استخدام الـ shell يدويًا. ينشر الـ daemon مقتطف تثبيت جاهزًا للصق عبر `GET /api/mcp/install-info` لكل عميل رئيسي.',
  'useEverywhere.section.mcp.bullet1': 'نقل Stdio — لا منفذ إضافي، يُشغِّل العميل `od mcp` مباشرةً.',
  'useEverywhere.section.mcp.bullet2': 'يكتشف تلقائيًا عنوان URL للـ daemon النشط عبر مقبس حالة IPC المحلي عند تشغيله كـ sidecar.',
  'useEverywhere.section.mcp.bullet3': 'يرجع إلى `--daemon-url http://127.0.0.1:<port>` للتثبيتات العادية بحيث تجد عملية MCP دائمًا daemon قيد التشغيل.',
  'useEverywhere.section.mcp.bullet4': 'يثبّت `OD_DATA_DIR` بحيث تكتب عملية MCP المُنشأة إلى المكان نفسه الذي يستخدمه الـ daemon بالفعل (يتجنّب EPERM في حزم تطبيقات macOS المُحزَّمة).',
  'useEverywhere.section.mcp.snippet1': 'إعداد عميل MCP عام (يعمل في Cursor، Claude Code، Codex، …)',
  'useEverywhere.section.mcp.snippet2': 'أو: اطلب من الـ daemon المقتطف المُخصّص لتثبيتك',
  'useEverywhere.section.mcp.snippet3': 'متغيّر MCP للعناصر الحية (قراءة وتحديث لوحات المعلومات)',
  'useEverywhere.section.mcp.footer': 'في تطبيق Open Design، افتح الإعدادات → التكاملات لنسخ أمر تثبيت خاص بكل عميل (Cursor، Claude Code، Antigravity، VS Code) بدلًا من تحرير JSON يدويًا.',
  'useEverywhere.section.http.tab': 'واجهة برمجة تطبيقات HTTP',
  'useEverywhere.section.http.heading': 'نفس واجهة REST + SSE التي تستخدمها واجهة الويب',
  'useEverywhere.section.http.intro': 'يخدم الـ daemon المحلي واجهة HTTP API على `http://127.0.0.1:7456` (المنفذ قابل للتهيئة). كل نقطة نهاية تستدعيها واجهة الويب متاحة أيضًا للنصوص البرمجية الخاصة بك. تُصدر نقاط نهاية البثّ (أدوار المحادثة، عمليات تشغيل المشاريع) أحداث Server-Sent Events بأنواع العقود الموجودة في `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — حيوية الـ daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` و`GET /api/design-systems` — السجلات المتاحة.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` و`POST /api/projects` — سرد المشاريع وإنشاؤها (يُرجِع POST المشروع + المحادثة الأولى).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — تدفق SSE لأحداث Agent الخاصة بمحادثة.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — اربط إضافة مثبّتة واحصل على استعلام المثال المعروض + مدخلاته.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — أدوات Agent البرمجية المكتشفة على الـ PATH الخاص بك.',
  'useEverywhere.section.http.snippet1': 'عرض المهارات المُثبّتة (سيستخدمها الـ Agent كقوالب)',
  'useEverywhere.section.http.snippet2': 'إنشاء مشروع من موجّه (تدفّق كامل من جانب الخادم)',
  'useEverywhere.section.http.snippet3': 'بثّ دور محادثة (SSE — كل سطر متوافق مع JSON-Lines)',
  'useEverywhere.section.http.footer': 'تتوفر أنواع TypeScript خالصة لكل طلب/استجابة في `@open-design/contracts` — استوردها في سكربتك للحصول على إكمال تلقائي كامل دون تهيئة مُولِّد.',
  'useEverywhere.section.skills.tab': 'المهارات والوضع بدون واجهة',
  'useEverywhere.section.skills.heading': 'مهارات Skills جاهزة للاستخدام لأي Agent — حتى دون تشغيل Open Design',
  'useEverywhere.section.skills.intro': 'المهارة هي دليل يحتوي على `SKILL.md` متوافق مع Claude (مقدّمة YAML + متن). يوسّع Open Design التنسيق بفضاء الأسماء `od:` (`mode`، `preview`، `design_system`، `inputs`، …) بحيث يمكن استخدام المخرَج نفسه داخل Open Design ومن قِبل Agent عادي مثل Claude Code أو Codex أو openclaw أو hermes. يتّبع الاكتشاف سلسلة أولوية بحيث يمكن للمشاريع تجاوز مهاراتها الخاصة.',
  'useEverywhere.section.skills.bullet1': 'الاكتشاف: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (تفوز المشاريع).',
  'useEverywhere.section.skills.bullet2': 'اربط مهارة واحدة بروابط رمزية في مشاريع متعددة لمشاركتها دون نسخ.',
  'useEverywhere.section.skills.bullet3': 'يمكن لكل مهارة أن تعلن عن الموصّلات والذرّات ومتطلبات نظام التصميم ومثال مخرجات `preview` للمعرض.',
  'useEverywhere.section.skills.bullet4': 'بدون واجهة: يمكن لأي Agent يحتوي على `od` في الـ PATH الخاص به استدعاء `od skills list` ثم تشغيل أي مهارة؛ الـ daemon اختياري للتدفقات للقراءة فقط.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` يختبر شكل العنصر نفسه مع أمثلة الملحقات الافتراضية وأمثلة ملحقات المجتمع، ثم يخزّن مشاريع `index.html` الناتجة كبيانات اختبار قابلة لإعادة الاستخدام.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md بحدّه الأدنى (front matter متوافق مع Claude + إضافات Open Design)',
  'useEverywhere.section.skills.snippet2': 'ربط مهارة مشتركة برابط رمزي في مشروع (بأسلوب cc-switch)',
  'useEverywhere.section.skills.snippet3': 'بدون واجهة: عرض المهارات التي يراها الـ daemon الآن',
  'useEverywhere.section.skills.snippet4': 'حزمة تجهيزات العناصر بدون واجهة',
  'useEverywhere.section.skills.footer': 'المواصفات: يغطّي `docs/skills-protocol.md` و`docs/agent-adapters.md` كامل واجهة المحوّل (Claude Code، Codex، Cursor، الـ Agents الداعمة لـ MCP، خيار BYOK API الاحتياطي) واستراتيجيات حقن المهارات لكل محوّل.',
  'tasks.kicker': 'مساحة عمل الأتمتة',
  'tasks.comingSoon': 'قريبًا',
  'tasks.lede': 'تحوّل عمليات الأتمتة الموجّهات إلى عمل دائم: يشغّلها Orbit، وتُبقيها الروتينات قائمة، وتقرّر الجداول متى تنطلق، وتُظهر العناصر الحية ما الذي تغيّر.',
  'tasks.newAutomation': 'أتمتة جديدة',
  'tasks.previewNote': 'واجهة معاينة فقط. إعدادات Orbit متاحة اليوم؛ أما الروتينات والجداول وربط العناصر الحية فستظهر مع دمج فروع الواجهة الخلفية.',
  'tasks.primitivesAria': 'أساسيات الأتمتة',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'بيئة تشغيل دائمة لعمل الـ Agent الطويل الأمد أو المتكرر.',
  'tasks.primitive.orbit.enabled': 'تم تفعيل الملخّص اليومي',
  'tasks.primitive.orbit.manualOnly': 'يدوي فقط',
  'tasks.primitive.routines.title': 'الروتينات',
  'tasks.primitive.routines.body': 'تعريفات مهام دائمة تستمر بعد انتهاء محادثة واحدة.',
  'tasks.primitive.routines.meta': 'غلاف المنتج جاهز',
  'tasks.primitive.schedules.title': 'الجداول',
  'tasks.primitive.schedules.body': 'مُشغّلات زمنية أو قائمة على الأحداث تقرّر متى ينبغي تشغيل روتين ما.',
  'tasks.primitive.schedules.meta': 'الفرع قيد الانتظار',
  'tasks.primitive.liveArtifacts.title': 'العناصر الحية',
  'tasks.primitive.liveArtifacts.body': 'تقارير وملاحظات تستمر في التحديث أثناء عمل الـ Agent.',
  'tasks.primitive.liveArtifacts.meta': 'نموذج المعاينة',
  'tasks.listAria': 'قائمة عمليات الأتمتة',
  'tasks.routinesAndRuns': '{n} روتينات وعمليات تشغيل',
  'tasks.filtersAria': 'عوامل تصفية الأتمتة',
  'tasks.filter.scheduled': 'مُجدوَل',
  'tasks.filter.running': 'قيد التشغيل',
  'tasks.filter.done': 'تم',
  'tasks.configurationAria': 'إعداد الأتمتة',
  'tasks.slot.trigger': 'المُشغِّل',
  'tasks.slot.pattern': 'النمط',
  'tasks.slot.runtime': 'وقت التشغيل',
  'tasks.slot.output': 'المُخرَجات',
  'tasks.liveArtifact': 'مُخرَج حي',
  'tasks.viewProgress': 'عرض التقدّم',
  'tasks.pause': 'إيقاف مؤقت',
  'tasks.runNow': 'تشغيل الآن',
  'tasks.openArtifact': 'فتح المُخرَج',
  'tasks.status.dailyAt': 'يوميًا · {time}',
  'tasks.status.pausedManual': 'متوقّف مؤقتًا · يدوي فقط',
  'tasks.sample.orbit.title': 'ملخّص موصّل Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'تمت جدولة موجز الموصّل',
  'tasks.sample.orbit.metaDisabled': 'افتح إعدادات Orbit للتفعيل',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · مخرَج مباشر',
  'tasks.sample.orbit.previewDisabled': 'لا يوجد تشغيل مجدوَل',
  'tasks.sample.orbit.triggerEnabled': 'الجدولة · يوميًا في {time}',
  'tasks.sample.orbit.triggerDisabled': 'يدوي · تشغيل عند الطلب',
  'tasks.sample.orbit.pattern': 'روتين · ملخّص الموصِّلات',
  'tasks.sample.orbit.runtime': 'Orbit · مجدول عبر الـ daemon',
  'tasks.sample.orbit.output': 'مخرَج مباشر · تقرير قابل للتحديث',
  'tasks.sample.orbit.artifactMetaEnabled': 'يتم التحديث بعد كل تشغيل',
  'tasks.sample.orbit.artifactMetaDisabled': 'في انتظار الجدولة',
  'tasks.sample.orbit.body1': '# ملخّص نشاط Orbit Daily',
  'tasks.sample.orbit.body2': 'الموصِّلات المفحوصة · النجاحات والتخطّيات والإخفاقات',
  'tasks.sample.orbit.body3': 'تتحوّل أبرز النقاط إلى مُخرَج حي قابل للتحديث.',
  'tasks.sample.mcp.title': 'بحث في بدائل MCP',
  'tasks.sample.mcp.status': 'قيد التشغيل في orbit · ساعتان و14 دقيقة',
  'tasks.sample.mcp.meta': 'تمت معالجة 14 / 30 مصدرًا',
  'tasks.sample.mcp.preview': 'research_notes.md · مباشر',
  'tasks.sample.mcp.trigger': 'يدوي · لمرة واحدة',
  'tasks.sample.mcp.pattern': 'موجّه بحث معمّق',
  'tasks.sample.mcp.runtime': 'عن بُعد · دائم',
  'tasks.sample.mcp.output': 'تقرير مباشر · يتحدّث تلقائيًا',
  'tasks.sample.mcp.artifactMeta': 'تم التحديث قبل 12 ثانية',
  'tasks.sample.mcp.body1': '# بدائل MCP - نتائج أولية',
  'tasks.sample.mcp.body2': 'تمت مراجعة 14 مصدرًا · 3 مرشّحين في القائمة المختصرة',
  'tasks.sample.mcp.body3': '## القائمة المختصرة',
  'tasks.sample.mcp.body4': '- مخطّطات استدعاء الأدوات عبر JSON-RPC...',
  'tasks.sample.mcp.body5': '- بروتوكولات Agent المعتمدة على gRPC...',
  'tasks.sample.weekly.title': 'الموجز الأسبوعي للفريق',
  'tasks.sample.weekly.status': 'التالي: الإثنين 9:00 صباحًا',
  'tasks.sample.weekly.meta': 'يحدّث مستند الفريق الأسبوعي',
  'tasks.sample.weekly.preview': 'team_weekly.md · المخرَج التالي',
  'tasks.sample.weekly.trigger': 'الجدولة · أسبوعيًا',
  'tasks.sample.weekly.pattern': 'روتين · ملخّص الفريق',
  'tasks.sample.weekly.runtime': 'عن بُعد · متكرر',
  'tasks.sample.weekly.output': 'مُخرَج حي · markdown',
  'tasks.sample.weekly.artifactMeta': 'آخر تحديث قبل 4 أيام',
  'tasks.sample.weekly.body1': '# أسبوع الفريق',
  'tasks.sample.weekly.body2': '## قيد التنفيذ',
  'tasks.sample.weekly.body3': '- دورة دمج نظام التصميم',
  'tasks.sample.weekly.body4': '- مراجعة جودة الموصّلات',
  'tasks.sample.weekly.body5': '## المخاطر',
  'tasks.sample.pr.title': 'تذكير بمراجعة PR',
  'tasks.sample.pr.status': 'عند PR جديد · شُغّل قبل 23 د',
  'tasks.sample.pr.meta': 'يرسل رسالة مباشرة عبر Slack',
  'tasks.sample.pr.preview': 'نجح آخر تسليم',
  'tasks.sample.pr.trigger': 'حدث · PR جديد',
  'tasks.sample.pr.pattern': 'روتين · إشعار',
  'tasks.sample.pr.runtime': 'محلي · تشغيل سريع',
  'tasks.sample.pr.output': 'رسالة · رسالة Slack مباشرة',
  'tasks.sample.pr.artifactMeta': 'آخر تشغيل قبل 23 دقيقة',
  'tasks.sample.pr.body1': 'تم فتح PR #184 للمراجعة',
  'tasks.sample.pr.body2': 'المراجعون المطابقون: design-platform، web-runtime',
  'tasks.sample.pr.body3': 'التسليم: تم إرسال رسالة Slack المباشرة',
  'tasks.sample.meeting.title': 'التحضير لما قبل الاجتماع',
  'tasks.sample.meeting.status': 'غدًا · 10:00 صباحًا',
  'tasks.sample.meeting.meta': 'لمرة واحدة · يرسل ملخصًا',
  'tasks.sample.meeting.preview': 'meeting_brief.md · في قائمة الانتظار',
  'tasks.sample.meeting.trigger': 'مجدول · لمرة واحدة',
  'tasks.sample.meeting.pattern': 'موجّه الإحاطة',
  'tasks.sample.meeting.runtime': 'عن بُعد · محدود',
  'tasks.sample.meeting.output': 'مُخرَج + رسالة',
  'tasks.sample.meeting.artifactMeta': 'في قائمة انتظار التوليد',
  'tasks.sample.meeting.body1': '# موجز الاجتماع',
  'tasks.sample.meeting.body2': 'مصدر جدول الأعمال: حدث التقويم + المستندات المرتبطة',
  'tasks.sample.meeting.body3': 'ستتضمّن المُخرَجات القرارات والعوائق والأسئلة.',
  'tasks.sample.candidate.title': 'تتبّع المرشّحين',
  'tasks.sample.candidate.status': 'فشل · يحتاج إلى انتباه',
  'tasks.sample.candidate.meta': 'انتهت صلاحية المصادقة',
  'tasks.sample.candidate.preview': 'أعد ربط Greenhouse للاستئناف',
  'tasks.sample.candidate.trigger': 'مجدول · يومي',
  'tasks.sample.candidate.pattern': 'روتين · مزامنة المتقدمين',
  'tasks.sample.candidate.runtime': 'عن بُعد · متكرر',
  'tasks.sample.candidate.output': 'مُخرَج حي · جدول',
  'tasks.sample.candidate.artifactMeta': 'متوقف مؤقتًا حتى استعادة المصادقة',
  'tasks.sample.candidate.body1': '# مسار المرشّحين',
  'tasks.sample.candidate.body2': 'آخر مزامنة ناجحة: قبل يومين',
  'tasks.sample.candidate.body3': 'إجراء مطلوب: أعد ربط حساب المصدر.',
  'routines.title': 'الأتمتة',
  'routines.subtitle': 'عمليات أتمتة مجدوَلة تعمل دون إشراف.',
  'routines.newAutomation': 'أتمتة جديدة',
  'routines.loading': 'جارٍ التحميل…',
  'routines.empty': 'لا توجد أتمتة بعد.',
  'routines.emptyHint': 'انقر على أتمتة جديدة لجدولة تشغيل Agent غير مراقب.',
  'routines.runHistoryLoading': 'جارٍ تحميل عمليات التشغيل…',
  'routines.runHistoryEmpty': 'لا توجد عمليات تشغيل بعد.',
  'routines.fieldName': 'الاسم',
  'routines.fieldNamePlaceholder': 'الإحاطة الصباحية',
  'routines.fieldPrompt': 'الموجّه',
  'routines.fieldPromptPlaceholder': 'اجلب نشاط GitHub وLinear ليوم أمس ولخّص ما تغيّر.',
  'routines.fieldSchedule': 'الجدول الزمني',
  'routines.fieldMinute': 'الدقيقة من كل ساعة',
  'routines.fieldTime': 'الوقت',
  'routines.fieldTimezone': 'المنطقة الزمنية',
  'routines.fieldsetProject': 'المشروع',
  'routines.kind.hourly': 'كل ساعة',
  'routines.kind.daily': 'يوميًا',
  'routines.kind.weekdays': 'أيام الأسبوع',
  'routines.kind.weekly': 'أسبوعيًا',
  'routines.weekday.short.0': 'الأحد',
  'routines.weekday.short.1': 'الإثنين',
  'routines.weekday.short.2': 'الثلاثاء',
  'routines.weekday.short.3': 'الأربعاء',
  'routines.weekday.short.4': 'الخميس',
  'routines.weekday.short.5': 'الجمعة',
  'routines.weekday.short.6': 'السبت',
  'routines.weekday.long.0': 'الأحد',
  'routines.weekday.long.1': 'الإثنين',
  'routines.weekday.long.2': 'الثلاثاء',
  'routines.weekday.long.3': 'الأربعاء',
  'routines.weekday.long.4': 'الخميس',
  'routines.weekday.long.5': 'الجمعة',
  'routines.weekday.long.6': 'السبت',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'يعمل كل ساعة عند :{minute}',
  'routines.describe.daily': 'يعمل يوميًا في {time} {tz}',
  'routines.describe.weekdays': 'يعمل من الإثنين إلى الجمعة في {time} {tz}',
  'routines.describe.weekly': 'يعمل كل {day} في {time} {tz}',
  'routines.modeCreate': 'إنشاء مشروع جديد في كل تشغيل',
  'routines.modeCreateHint': 'مساحة عمل جديدة ومعزولة لكل تشغيل.',
  'routines.modeReuse': 'إعادة استخدام مشروع موجود',
  'routines.modeReuseHint': 'يظهر كل تشغيل كمحادثة جديدة داخل المشروع.',
  'routines.pickProject': '— اختر مشروعًا —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '← مشروع جديد في كل تشغيل',
  'routines.tagPaused': 'موقوف مؤقتًا',
  'routines.metaNext': 'التالي: {when}',
  'routines.metaLast': 'الأخير:',
  'routines.triggerManual': 'يدوي',
  'routines.triggerScheduled': 'مجدول',
  'routines.openProject': 'فتح المشروع',
  'routines.openProjectTitle': 'افتح المشروع الذي كتب إليه هذا التشغيل',
  'routines.runNow': 'التشغيل الآن',
  'routines.edit': 'تحرير',
  'routines.pause': 'إيقاف مؤقت',
  'routines.resume': 'استئناف',
  'routines.history': 'السجل',
  'routines.hideHistory': 'إخفاء السجل',
  'routines.delete': 'حذف',
  'routines.deleteTitle': 'حذف هذه الأتمتة',
  'routines.cancel': 'إلغاء',
  'routines.save': 'حفظ',
  'routines.saving': 'جارٍ الحفظ…',
  'routines.create': 'إنشاء',
  'routines.creating': 'جارٍ الإنشاء…',
  'routines.status.queued': 'في قائمة الانتظار',
  'routines.status.running': 'قيد التشغيل',
  'routines.status.succeeded': 'نجح',
  'routines.status.failed': 'فشل',
  'routines.status.canceled': 'أُلغي',
  'routines.confirmDelete': 'حذف هذه الأتمتة؟ سيتم الاحتفاظ بعمليات التشغيل السابقة ومشاريعها.',
  'routines.errorPickProject': 'اختر مشروعًا لإعادة استخدامه، أو بدّل إلى “إنشاء مشروع جديد في كل تشغيل”',
  'routines.errorAgentEmptyOutput': 'أكمل الـ Agent دون إنتاج أي مُخرَج. ربما أرجع النموذج أو المزوّد استجابة فارغة — تحقّق من سجلات الـ Agent بحثًا عن أخطاء المصدر.',
  'entry.helpAria': 'المساعدة',
  'entry.helpMenuAria': 'قائمة المساعدة',
  'entry.helpGetHelp': 'احصل على مساعدة على GitHub',
  'entry.helpSubmitFeature': 'اقترح ميزة',
  'entry.helpWhatsNew': 'الجديد',
  'entry.helpDownloadDesktop': 'تنزيل تطبيق سطح المكتب',
  'entry.githubStarLabel': 'نجمة',
  'entry.githubStarTitle': 'انقر لمنحنا نجمة على GitHub',
  'entry.githubStarAria': 'منح Open Design نجمة على GitHub',
  'entry.tabImageTemplates': 'قوالب الصور',
  'entry.tabVideoTemplates': 'قوالب الفيديو',
  'promptTemplates.searchPlaceholder': 'بحث في القوالب...',
  'promptTemplates.countLabel': '{n} نتائج',
  'promptTemplates.emptyImage': 'لم يتم تثبيت قوالب صور بعد.',
  'promptTemplates.emptyVideo': 'لم يتم تثبيت قوالب فيديو بعد.',
  'promptTemplates.emptyNoMatch': 'لا توجد قوالب تطابق بحثك.',
  'promptTemplates.attributionFooter': 'مقتبس من مكتبات الأوامر العامة. كل بطاقة تشير إلى المؤلف الأصلي.',
  'promptTemplates.openPreviewTitle': 'فتح الأمر والمعاينة',
  'promptTemplates.sourcePrefix': 'المصدر:',
  'promptTemplates.fetchError': 'تعذر تحميل جسم هذا القالب.',
  'promptTemplates.promptLabel': 'جسم الأمر',
  'promptTemplates.copyPrompt': 'نسخ الأمر',
  'promptTemplates.copyDone': 'تم النسخ!',
  'promptTemplates.modelHint': 'النموذج المقترح: {model}',
  'promptTemplates.openSource': 'عرض الأصلي',
  'promptTemplates.openFullscreen': 'فتح معاينة بملء الشاشة',
  'promptTemplates.closeFullscreen': 'إغلاق معاينة بملء الشاشة',
  'promptTemplates.allSources': 'جميع المصادر',
  'promptTemplates.sourceFilterAria': 'تصفية حسب المصدر',
  'promptTemplates.retry': 'إعادة المحاولة',
  'connectors.title': 'الموصلات',
  'connectors.subtitle': 'مصادر بيانات محلية وقادمة يمكنها تشغيل العناصر الحية.',
  'connectors.account': 'الحساب',
  'connectors.noAccount': 'غير متصل',
  'connectors.tools': 'الأدوات',
  'connectors.connect': 'اتصال',
  'connectors.disconnect': 'قطع الاتصال',
  'connectors.authorizationPending': 'بانتظار التفويض...',
  'connectors.authorizationPendingHint': 'أكمل التفويض في النافذة المفتوحة.',
  'connectors.cancelAuthorization': 'إلغاء',
  'connectors.configure': 'إعداد',
  'connectors.unavailable': 'غير متاح',
  'connectors.phaseStubTitle': 'واجهات الموصلات ستصل في المرحلة 3؛ هذه مجرد واجهة معاينة.',
  'connectors.statusAvailable': 'متاح',
  'connectors.statusConnected': 'متصل',
  'connectors.statusError': 'خطأ',
  'connectors.statusDisabled': 'معطل',
  'connectors.gateTitle': 'أضف مفتاح Composio API للمتابعة',
  'connectors.gateBody': 'الصق المفتاح أعلاه واضغط حفظ المفتاح لتحميل التكاملات المتاحة.',
  'connectors.aboutLabel': 'حول',
  'connectors.detailsLabel': 'التفاصيل',
  'connectors.statusLabel': 'الحالة',
  'connectors.category.aiAgents': 'وكلاء AI',
  'connectors.category.aiInfrastructure': 'بنية AI التحتية',
  'connectors.category.accounting': 'المحاسبة',
  'connectors.category.admin': 'الإدارة',
  'connectors.category.advertising': 'الإعلانات',
  'connectors.category.analytics': 'التحليلات',
  'connectors.category.automation': 'الأتمتة',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'التقويم',
  'connectors.category.commerce': 'التجارة',
  'connectors.category.communication': 'التواصل',
  'connectors.category.contacts': 'جهات الاتصال',
  'connectors.category.dataPlatform': 'منصة البيانات',
  'connectors.category.database': 'قاعدة البيانات',
  'connectors.category.design': 'التصميم',
  'connectors.category.developer': 'أدوات المطورين',
  'connectors.category.documentation': 'التوثيق',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'التعليم',
  'connectors.category.email': 'البريد الإلكتروني',
  'connectors.category.events': 'الأحداث',
  'connectors.category.fieldService': 'الخدمة الميدانية',
  'connectors.category.finance': 'المالية',
  'connectors.category.fitness': 'اللياقة',
  'connectors.category.forms': 'النماذج',
  'connectors.category.gaming': 'الألعاب',
  'connectors.category.hr': 'الموارد البشرية',
  'connectors.category.hospitality': 'الضيافة',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'التكامل',
  'connectors.category.localization': 'التوطين',
  'connectors.category.logistics': 'اللوجستيات',
  'connectors.category.maps': 'الخرائط',
  'connectors.category.marketing': 'التسويق',
  'connectors.category.media': 'الوسائط',
  'connectors.category.meetings': 'الاجتماعات',
  'connectors.category.nonprofit': 'غير ربحي',
  'connectors.category.observability': 'قابلية المراقبة',
  'connectors.category.payments': 'المدفوعات',
  'connectors.category.personal': 'شخصي',
  'connectors.category.presentations': 'العروض التقديمية',
  'connectors.category.procurement': 'المشتريات',
  'connectors.category.product': 'المنتج',
  'connectors.category.productivity': 'الإنتاجية',
  'connectors.category.projectManagement': 'إدارة المشاريع',
  'connectors.category.recruiting': 'التوظيف',
  'connectors.category.research': 'البحث',
  'connectors.category.salesIntelligence': 'ذكاء المبيعات',
  'connectors.category.scheduling': 'الجدولة',
  'connectors.category.search': 'البحث',
  'connectors.category.security': 'الأمان',
  'connectors.category.signing': 'التوقيع',
  'connectors.category.social': 'اجتماعي',
  'connectors.category.spreadsheets': 'جداول البيانات',
  'connectors.category.storage': 'التخزين',
  'connectors.category.support': 'الدعم',
  'connectors.category.surveys': 'الاستبيانات',
  'connectors.category.tasks': 'المهام',
  'connectors.category.timeTracking': 'تتبع الوقت',
  'connectors.category.video': 'الفيديو',
  'connectors.category.whiteboard': 'السبورة',
  'connectors.categoryLabel': 'الفئة',
  'connectors.providerLabel': 'المزوّد',
  'connectors.toolsSection': 'الأدوات',
  'connectors.toolsLoading': 'جارٍ تحميل الأدوات…',
  'connectors.noToolsAvailable': 'لا توجد أدوات متاحة بعد. بعد الاتصال ستظهر إمكانات هذا التكامل.',
  'connectors.toolDetailsUnavailable': 'تفاصيل الأدوات غير متوفرة، لكن هذا الموصّل يُبلّغ عن {n} أداة.',
  'connectors.loadMoreTools': 'تحميل المزيد من الأدوات',
  'connectors.openDetailsAria': 'فتح تفاصيل {name}',
  'connectors.toolsBadgeNone': 'لا أدوات',
  'connectors.toolsBadgeOne': '{n} أداة',
  'connectors.toolsBadgeMany': '{n} أدوات',
  'connectors.searchPlaceholder': 'ابحث في الموصلات…',
  'connectors.searchAriaLabel': 'ابحث في الموصلات حسب الاسم أو المزوّد أو الأداة',
  'connectors.searchClear': 'مسح البحث',
  'connectors.emptyNoMatchTitle': 'لا توجد موصلات تطابق “{query}”',
  'connectors.emptyNoMatchBody': 'جرّب كلمة مفتاحية أخرى أو امسح البحث لعرض القائمة الكاملة.',
  'connectors.emptyNoMatchAction': 'مسح البحث',
  'newproj.tabPrototype': 'نموذج أولي',
  'newproj.tabLiveArtifact': 'عنصر مباشر',
  'newproj.tabDeck': 'عرض تقديمي',
  'newproj.tabTemplate': 'من قالب',
  'newproj.tabMedia': 'الوسائط',
  'newproj.tabOther': 'آخر',
  'newproj.titlePrototype': 'نموذج أولي جديد',
  'newproj.titleLiveArtifact': 'عنصر مباشر جديد',
  'newproj.titleDeck': 'عرض تقديمي جديد',
  'newproj.titleTemplate': 'ابدأ من قالب',
  'newproj.titleImage': 'صورة جديدة',
  'newproj.titleVideo': 'فيديو جديد',
  'newproj.titleAudio': 'صوت جديد',
  'newproj.titleMedia': 'وسائط جديدة',
  'newproj.titleOther': 'مشروع جديد',
  'newproj.namePlaceholder': 'اسم المشروع',
  'newproj.fidelityLabel': 'الدقة',
  'newproj.fidelityWireframe': 'رسم تخطيطي',
  'newproj.fidelityHigh': 'دقة عالية',
  'newproj.toggleSpeakerNotes': 'استخدم ملاحظات المتحدث',
  'newproj.toggleSpeakerNotesHint': 'نص أقل على الشرائح - احتفظ بنقاط الحديث في الملاحظات.',
  'newproj.toggleAnimations': 'تضمين الرسوم المتحركة',
  'newproj.toggleAnimationsHint': 'أضف الحركة (دخول، تحويم، انتقالات) فوق القالب.',
  'newproj.targetPlatformsLabel': 'المنصات المستهدفة',
  'newproj.targetPlatformsHint': 'اختر واحدة أو أكثر. الويب المتجاوب يغطي نقاط توقف المتصفح فقط؛ أضف iOS أو Android أو تطبيق الجهاز اللوحي أو تطبيق سطح المكتب للحصول على نسخ أصلية متعددة المنصات.',
  'newproj.platform.responsive.label': 'ويب متجاوب',
  'newproj.platform.responsive.hint': 'تجربة ويب واحدة مُهيّأة لمتصفحات سطح المكتب والجهاز اللوحي والجوال',
  'newproj.platform.webDesktop.label': 'ويب سطح المكتب',
  'newproj.platform.webDesktop.hint': 'منتج أو صفحة هبوط يعتمد على المتصفح أولاً',
  'newproj.platform.mobileIos.label': 'تطبيق iOS',
  'newproj.platform.mobileIos.hint': 'إطارات iPhone وقواعد تفاعل iOS',
  'newproj.platform.mobileAndroid.label': 'تطبيق Android',
  'newproj.platform.mobileAndroid.hint': 'إطارات Pixel وقواعد تفاعل Material',
  'newproj.platform.tablet.label': 'تطبيق الجهاز اللوحي',
  'newproj.platform.tablet.hint': 'تجربة جهاز لوحي بأسلوب أصلي مع عروض مقسّمة',
  'newproj.platform.desktopApp.label': 'تطبيق سطح المكتب',
  'newproj.platform.desktopApp.hint': 'واجهة تطبيق macOS/Windows',
  'newproj.surfaceOptionsLabel': 'الأسطح المصاحبة',
  'newproj.includeLandingPage': 'تضمين صفحة هبوط',
  'newproj.includeLandingPageHint': 'أضف صفحة تسويقية متجاوبة للإعلانات أو قوائم الانتظار أو حملات الإطلاق أو تنزيلات التطبيق أو شرح المنتج.',
  'newproj.includeOsWidgets': 'تضمين عناصر واجهة نظام التشغيل',
  'newproj.includeOsWidgetsHint': 'أضف عناصر واجهة أصلية للمنصة على الشاشة الرئيسية أو شاشة القفل أو الوصول السريع لتطبيقات الجوال/الجهاز اللوحي.',
  'newproj.includeOsWidgetsDisabledHint': 'متاح عند اختيار تطبيق iOS أو Android أو الجهاز اللوحي كمنصة مستهدفة.',
  'newproj.templateLabel': 'القالب',
  'newproj.noTemplatesTitle': 'لا توجد قوالب بعد',
  'newproj.noTemplatesBody': 'افتح أي مشروع، ثم استخدم قائمة المشاركة داخل عارض الملفات لتحويله إلى قالب. ستظهر القوالب هنا.',
  'newproj.savedTemplate': 'قالب محفوظ',
  'newproj.fileSingular': 'ملف',
  'newproj.filePlural': 'ملفات',
  'newproj.create': 'إنشاء',
  'newproj.locationLabel': 'حفظ في',
  'newproj.locationDefault': 'مشاريع Open Design',
  'newproj.locationExternalBase': 'قاعدة خارجية',
  'newproj.createLiveArtifact': 'إنشاء عنصر مباشر',
  'newproj.createFromTemplate': 'إنشاء من قالب',
  'newproj.createDisabledTitle': 'احفظ مشروعاً كقالب أولاً (قائمة المشاركة داخل أي مشروع).',
  'newproj.openFolder': 'فتح مجلد',
  'newproj.openingFolder': 'جاري الفتح…',
  'newproj.importClaudeZip': 'استيراد ZIP من Claude Design',
  'newproj.importClaudeZipTitle': 'استيراد تصدير .zip من Claude Design',
  'newproj.importingClaudeZip': 'جاري الاستيراد...',
  'newproj.privacyFooter': 'أنت فقط من يمكنه رؤية مشروعك افتراضياً.',
  'newproj.designSystem': 'نظام التصميم',
  'newproj.dsNoneFreeform': 'لا يوجد - شكل حر',
  'newproj.dsNoneSubtitleEmpty': 'لا توجد رموز نظام، اختر لوحة الألوان الخاصة بك',
  'newproj.dsNoneSubtitleSelected': 'تخطي رموز النظام. يختار الوكيل لوحة الألوان الخاصة به.',
  'newproj.dsCategoryFallback': 'نظام التصميم',
  'newproj.dsSearch': 'بحث في أنظمة التصميم...',
  'newproj.dsModeAria': 'وضع الاختيار',
  'newproj.dsModeSingle': 'فردي',
  'newproj.dsModeMulti': 'متعدد',
  'newproj.dsNoneTitle': 'لا يوجد - شكل حر',
  'newproj.dsNoneSub': 'تخطي رموز النظام. يختار الوكيل لوحة الألوان الخاصة به.',
  'newproj.dsEmpty': 'لا توجد أنظمة تصميم تطابق "{query}".',
  'newproj.dsFootSingular': 'للإلهام فقط.',
  'newproj.dsFootPlural': 'للإلهام فقط.',
  'newproj.dsFootClear': 'مسح',
  'newproj.dsBadgeDefault': 'افتراضي',
  'newproj.dsPrimaryFallback': 'أساسي',
  'newproj.surfaceImage': 'صورة',
  'newproj.surfaceVideo': 'فيديو',
  'newproj.surfaceAudio': 'صوت',
  'newproj.modelLabel': 'النموذج',
  'newproj.modelSearch': 'بحث في النماذج…',
  'newproj.modelEmpty': 'لا توجد نماذج مطابقة.',
  'newproj.modelRecommended': 'موصى به',
  'newproj.modelMissingTitle': 'اختر نموذجًا',
  'newproj.modelMissingSub': 'اختر النموذج المسؤول عن هذا السياق.',
  'newproj.aspectLabel': 'الأبعاد',
  'newproj.videoLengthLabel': 'الطول',
  'newproj.videoLengthSeconds': '{n} ثا',
  'newproj.audioKindLabel': 'نوع الصوت',
  'newproj.audioKindMusic': 'موسيقى',
  'newproj.audioKindSpeech': 'كلام / TTS',
  'newproj.audioKindSfx': 'تأثيرات صوتية',
  'newproj.audioDurationLabel': 'المدة',
  'newproj.audioDurationSeconds': '{n} ثا',
  'newproj.voiceLabel': 'الصوت',
  'newproj.voicePlaceholder': 'معرف صوت المزود، اختياري',
  'newproj.connectorsLabel': 'الموصلات',
  'newproj.connectorsHint': 'مصادر البيانات التي يمكن لهذا العنصر استخدامها.',
  'newproj.connectorsEmptyTitle': 'لا توجد موصلات مُعدّة',
  'newproj.connectorsEmptyBody': 'صِل مصدر بيانات حتى يستخدم العنصر الحي بيانات حقيقية بدل العناصر النائبة.',
  'newproj.connectorsEmptyCta': 'إعداد الموصلات ←',
  'newproj.connectorsLoading': 'جارٍ تحميل الموصلات…',
  'newproj.connectorsCountOne': '{n} متصل',
  'newproj.connectorsCountMany': '{n} متصل',
  'newproj.connectorsManage': 'إدارة',
  'newproj.promptTemplateLabel': 'قالب مرجعي',
  'newproj.promptTemplateNoneTitle': 'لا يوجد - اكتب خاصتك',
  'newproj.promptTemplateNoneSub': 'تخطي المعرض، صف موجزك الخاص',
  'newproj.promptTemplateRefSub': 'قالب مرجعي',
  'newproj.promptTemplateSearch': 'بحث في القوالب...',
  'newproj.promptTemplateEmpty': 'لم يتم تثبيت قوالب لهذه السطح بعد.',
  'newproj.promptTemplateBodyLabel': 'الأمر (يمكنك ضبطه)',
  'newproj.promptTemplateOptimizeHint': 'عدل أي شيء - تغييراتك تنتقل إلى موجز الوكيل.',
  'newproj.promptTemplateBodyEmpty': 'جسم فارغ - لن يحصل الوكيل على مرجع قالب.',
  'newproj.deleteTemplateTitle': 'حذف القالب',
  'newproj.deleteTemplateConfirm': 'هل تريد حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
  'newproj.deleteTemplateConfirmCta': 'حذف القالب',
  'newproj.deleteTemplateError': 'تعذر حذف هذا القالب. يرجى المحاولة مرة أخرى.',
  'designs.subRecent': 'الأخيرة',
  'designs.subYours': 'تصاميمك',
  'designs.filterAria': 'تصفية المشاريع',
  'designs.searchPlaceholder': 'بحث...',
  'designs.emptyNoProjects': 'لا توجد مشاريع بعد.',
  'designs.emptyNoMatch': 'لا توجد مشاريع تطابق بحثك.',
  'designs.deleteTitle': 'حذف المشروع',
  'designs.deleteConfirm': 'هل تريد حذف "{name}"؟',
  'designs.cardFreeform': 'شكل حر',
  'designs.badgeLive': 'مباشر',
  'designs.liveArtifactBadgesAria': 'شارات العناصر المباشرة',
  'designs.liveCount': '{n} مباشر',
  'designs.statusLive': 'عنصر مباشر',
  'designs.statusArchived': 'مؤرشف',
  'designs.statusError': 'خطأ',
  'designs.statusRefreshing': 'جارٍ التحديث…',
  'designs.statusRefreshFailed': 'فشل التحديث',
  'designs.statusRefreshed': 'تم التحديث',
  'designs.status.notStarted': 'لم يبدأ',
  'designs.status.queued': 'في الانتظار',
  'designs.status.running': 'جاري التشغيل',
  'designs.status.awaitingInput': 'يحتاج مدخلات',
  'designs.status.incomplete': 'غير مكتمل',
  'designs.status.succeeded': 'اكتمل',
  'designs.status.published': 'تم النشر',
  'designs.status.failed': 'فشل',
  'designs.status.canceled': 'ملغى',
  'designs.viewToggleAria': 'وضع العرض',
  'designs.viewGrid': 'عرض الشبكة',
  'designs.viewKanban': 'عرض اللوحة',
  'designs.kanbanEmptyColumn': 'لا توجد تصاميم',
  'designs.deleteAria': 'حذف المشروع {name}',
  'designs.menuMore': 'المزيد من الإجراءات',
  'designs.menuRename': 'إعادة تسمية',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'حذف',
  'designs.renamePrompt': 'اسم جديد لـ "{name}"',
  'designs.selectMode': 'تحديد',
  'designs.cancelSelect': 'إلغاء',
  'designs.deleteSelected': 'حذف المحدد',
  'designs.selectedCount': 'تم تحديد {n}',
  'designs.deleteSelectedConfirm': 'حذف {n} مشروع؟',
  'designs.deleteSelectedSuccess': 'تم حذف {n} مشروع بنجاح.',
  'designs.deleteSelectedPartial': 'تم حذف {deleted} مشروع؛ فشل {failed}.',
  'designs.tagPrototype': 'نموذج أولي',
  'designs.tagLiveArtifact': 'عنصر مباشر',
  'designs.tagWebClone': 'استنساخ موقع ويب',
  'designs.tagSlide': 'شريحة',
  'designs.tagMedia': 'وسائط',
  'designs.renameTitle': 'إعادة تسمية المشروع',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'إلغاء',
  'examples.typeLabel': 'النوع',
  'examples.surfaceLabel': 'السطح',
  'examples.surfaceWeb': 'ويب',
  'examples.surfaceImage': 'صورة',
  'examples.surfaceVideo': 'فيديو',
  'examples.surfaceAudio': 'صوت',
  'examples.scenarioLabel': 'السيناريو',
  'examples.modeAll': 'الكل',
  'examples.modePrototypeDesktop': 'نماذج أولية · سطح المكتب',
  'examples.modePrototypeMobile': 'نماذج أولية · الجوال',
  'examples.modeDeck': 'شرائح',
  'examples.modeDocument': 'مستندات وقوالب',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'مباشر',
  'examples.scenarioGeneral': 'عام',
  'examples.scenarioEngineering': 'هندسة',
  'examples.scenarioProduct': 'منتج',
  'examples.scenarioDesign': 'تصميم',
  'examples.scenarioMarketing': 'تسويق',
  'examples.scenarioSales': 'مبيعات',
  'examples.scenarioFinance': 'مالية',
  'examples.scenarioHr': 'موارد بشرية',
  'examples.scenarioOperations': 'عمليات',
  'examples.scenarioSupport': 'دعم',
  'examples.scenarioLegal': 'قانوني',
  'examples.scenarioEducation': 'تعليم',
  'examples.scenarioPersonal': 'شخصي',
  'examples.searchPlaceholder': 'بحث في الأمثلة...',
  'examples.searchAria': 'بحث في الأمثلة بالاسم',
  'examples.emptyNoSkills': 'لا توجد مهارات متوفرة. هل البرنامج الخفي يعمل؟',
  'examples.emptyNoMatch': 'لا توجد أمثلة تطابق هذه الفلاتر.',
  'examples.openPreview': '⤢ فتح المعاينة',
  'examples.loadingPreview': 'جاري تحميل المعاينة...',
  'examples.hoverPreview': 'حوم للمعاينة',
  'examples.usePrompt': 'استخدم هذا الأمر',
  'examples.previewModalTitle': 'فتح المعاينة الكاملة (نافذة)',
  'examples.shareTitle': 'مشاركة هذا المثال',
  'examples.shareLoadFirst': 'حوم لتحميل المعاينة أولاً',
  'examples.unavailablePlaceholder': 'لا توجد معاينة {kind} مرفقة — افتح لمعرفة المزيد',
  'examples.shareUnavailable': 'لا توجد معاينة {kind} مرفقة للمشاركة',
  'examples.shareMenu': 'مشاركة ▾',
  'examples.exportPdfAllSlides': 'تصدير كـ PDF (كل الشرائح)',
  'examples.exportPptxLocked': 'تصدير كـ PPTX... (افتح القالب أولاً)',
  'examples.tagSlideDeck': 'عرض تقديمي',
  'examples.tagTemplate': 'قالب',
  'examples.tagDesignSystem': 'نظام تصميم',
  'examples.tagMobilePrototype': 'نموذج أولي للجوال',
  'examples.tagDesktopPrototype': 'نموذج أولي لسطح المكتب',
  'examples.tagImage': 'صورة',
  'examples.tagVideo': 'فيديو',
  'examples.tagAudio': 'صوت',
  'examples.previewLabel': 'معاينة',
  'ds.surfaceLabel': 'السطح',
  'ds.surfaceWeb': 'ويب',
  'ds.surfaceImage': 'صورة',
  'ds.surfaceVideo': 'فيديو',
  'ds.surfaceAudio': 'صوت',
  'ds.searchPlaceholder': 'بحث في أنظمة التصميم...',
  'ds.emptyNoMatch': 'لا توجد أنظمة تصميم تطابق بحثك.',
  'ds.badgeDefault': 'افتراضي',
  'ds.preview': 'معاينة',
  'ds.previewTitle': 'معاينة نظام التصميم',
  'ds.categoryAll': 'الكل',
  'ds.categoryUncategorized': 'غير مصنف',
  'ds.showcase': 'عرض',
  'ds.tokens': 'الرموز',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'جاري تحميل DESIGN.md...',
  'avatar.title': 'الحساب والإعدادات',
  'avatar.localCli': 'CLI محلي',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'استخدام CLI محلي',
  'avatar.useApi': 'استخدام API · BYOK',
  'avatar.codeAgent': 'وكيل الكود',
  'avatar.rescan': 'إعادة مسح PATH',
  'avatar.amrConsole': 'حساب Open Design Cloud',
  'avatar.amrConsoleMeta': 'الرصيد وإعادة الشحن',
  'avatar.settings': 'الإعدادات',
  'avatar.backToProjects': 'العودة للمشاريع',
  'avatar.metaActive': 'نشط',
  'avatar.metaOffline': 'غير متصل',
  'avatar.metaSelected': 'محدد',
  'avatar.noAgentSelected': 'لم يتم اختيار وكيل',
  'avatar.modelSection': 'النموذج',
  'avatar.modelLabel': 'النموذج',
  'avatar.reasoningLabel': 'التفكير',
  'avatar.serviceTierLabel': 'طبقة الخدمة',
  'avatar.customSuffix': '(مخصص)',
  'socialShare.openDesignSection': 'مشاركة Open Design',
  'socialShare.openDesignTitle': 'Open Design على GitHub',
  'socialShare.openDesignText': 'Open Design هي مساحة عمل متاحة المصدر لإنشاء عناصر التصميم وتحريرها ونشرها وتسليمها.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'المشاركة الاجتماعية',
  'socialShare.publishPageTitle': 'نشر صفحة المشاركة',
  'socialShare.publishPageSubtitle': 'انشر هذه المعاينة حتى يمكن مشاركتها على منصات التواصل الاجتماعي.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'تم الإنشاء باستخدام Open Design: {title}. اعرض العنصر المنشور وامنح نجمة للمستودع: {repo}',
  'socialShare.projectCopyText': 'تم الإنشاء باستخدام Open Design: {title}\n{url}\nمستودع Open Design: {repo}',
  'socialShare.deployFirst': 'انشر ثم شارك…',
  'socialShare.copied': 'تم النسخ',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'شياو هونغ شو',
  'inlineSwitcher.chipTitle': 'تبديل CLI / النموذج',
  'inlineSwitcher.chipCli': 'CLI محلي',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'افتراضي',
  'inlineSwitcher.noAgent': 'لا يوجد عميل',
  'inlineSwitcher.modeLabel': 'الوضع',
  'inlineSwitcher.agentLabel': 'عميل',
  'inlineSwitcher.providerLabel': 'المزود',
  'inlineSwitcher.modelLabel': 'النموذج',
  'inlineSwitcher.useCli': 'استخدام CLI محلي',
  'inlineSwitcher.useByok': 'استخدام مفتاح API الخاص بك',
  'inlineSwitcher.daemonOffline': 'الخادم غير متصل — افتح الإعدادات',
  'inlineSwitcher.noAgentsDetected': 'لم يتم العثور على CLI في PATH',
  'inlineSwitcher.openSettingsForModel': 'قم بإعداد المزود في الإعدادات',
  'inlineSwitcher.missingApiKey': 'مفتاح API غير محدد — افتح الإعدادات لإضافته.',
  'inlineSwitcher.openFullSettings': 'فتح إعدادات التنفيذ',
  'inlineSwitcher.customSuffix': '(مخصص)',
  'project.backToProjects': 'العودة للمشاريع',
  'project.brandReadyTitle': 'نظام تصميم {name} جاهز',
  'project.brandReadyTitleGeneric': 'نظام التصميم جاهز',
  'project.brandReadyCta': 'معاينة في أنظمة التصميم',
  'project.brandReadyDismiss': 'تجاهل',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'تم فتح معاينة نظام التصميم.',
  'project.previewCommentSaveFailed': 'تعذّر حفظ التعليق. حاول مرة أخرى.',
  'project.previewCommentReorderFailed': 'تعذّر حفظ ترتيب التعليقات وقد يُعاد ضبطه عند إعادة التحميل.',
  'project.metaFreeform': 'شكل حر',
  'project.typePrototype': 'نموذج أولي',
  'project.typeDeck': 'شرائح',
  'project.typeTemplate': 'قالب',
  'project.typeImage': 'صورة',
  'project.typeVideo': 'فيديو',
  'project.typeAudio': 'صوت',
  'project.customInstructions': 'تعليمات المشروع',
  'project.customInstructionsPlaceholder': 'تعليمات لهذا المشروع (تُحقَن في كل رسالة)…',
  'project.resizeChatPanel': 'تغيير حجم لوحة الدردشة',
  'project.instructionsActive': 'نشط — مُضمَّن في كل رسالة',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'دردشة',
  'chat.tabComments': 'تعليقات',
  'chat.commentsSoon': 'التعليقات - قريباً',
  'chat.comments.attached': 'مرفق بالدردشة',
  'chat.comments.emptyAttached': 'لا توجد تعليقات مرفقة.',
  'chat.comments.saved': 'تعليقات محفوظة',
  'chat.comments.emptySaved': 'لا توجد تعليقات محفوظة.',
  'chat.comments.add': 'إضافة',
  'chat.comments.addAll': 'إضافة الكل',
  'chat.comments.remove': 'إزالة',
  'chat.comments.placeholder': 'علق على هذا العنصر...',
  'chat.comments.addSend': 'إضافة وإرسال',
  'chat.comments.updateSend': 'تحديث وإرسال',
  'chat.comments.removeAttachment': 'إزالة مرفق التعليق',
  'chat.comments.removeAttachmentAria': 'إزالة مرفق التعليق لـ {name}',
  'chat.comments.comment': 'تعليق',
  'chat.comments.sendToChat': 'إرسال إلى المحادثة',
  'chat.comments.sending': 'جارٍ الإرسال…',
  'chat.comments.edit': 'تحرير',
  'chat.comments.select': 'تحديد',
  'chat.comments.selectAll': 'تحديد الكل',
  'chat.comments.deselect': 'إلغاء التحديد',
  'chat.comments.nSelected': '{n} محدد',
  'chat.comments.pin': 'تثبيت',
  'chat.comments.addNote': 'إضافة ملاحظة',
  'chat.comments.savedToast': 'تم حفظ التعليق',
  'chat.comments.pinSavedToast': 'تم حفظ التثبيت',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} عنصر ملتقط',
  'chat.comments.clear': 'مسح',
  'chat.comments.targetImage': 'صورة',
  'chat.comments.targetControl': 'عنصر تحكم',
  'chat.comments.targetLink': 'رابط',
  'chat.comments.targetText': 'نص',
  'chat.comments.targetSection': 'قسم',
  'chat.comments.targetPage': 'صفحة',
  'chat.comments.targetArea': 'منطقة',
  'chat.annotationNotePlaceholder': 'أضف ملاحظة لهذه العلامة',
  'chat.annotationAttachImage': 'إرفاق صورة',
  'chat.annotationAttachedImages': 'الصور المرفقة',
  'chat.annotationAttachedRemove': 'إزالة آخر صورة',
  'chat.annotationAddToInput': 'إضافة إلى الإدخال',
  'chat.annotationAddingToInput': 'جارٍ الإضافة...',
  'chat.annotationQueue': 'قائمة الانتظار',
  'chat.annotationQueueing': 'جارٍ الإضافة إلى قائمة الانتظار...',
  'chat.annotationSubmitOptions': 'خيارات الإرسال',
  'chat.annotationSending': 'جارٍ الإرسال...',
  'chat.annotationSendDisabledReason': 'هناك مهمة قيد التشغيل حاليًا',
  'chat.annotationPreviewMissing': 'تعذّر التقاط المعاينة. يُرجى المحاولة مرة أخرى.',
  'chat.annotationPreviewMissingInk': 'تعذّر التقاط المعاينة. حاول مرة أخرى لتجنّب إرسال الحبر فقط.',
  'chat.annotationSentWithoutScreenshot': 'تعذّر التقاط المعاينة. تم إرسال التعليق التوضيحي بدون لقطة شاشة.',
  'chat.annotationTimeout': 'انتهت مهلة إرسال التعليق التوضيحي. يُرجى المحاولة مرة أخرى.',
  'chat.annotationFailed': 'فشل إرسال التعليق التوضيحي. يُرجى المحاولة مرة أخرى.',
  'chat.annotationProjectCreateFailed': 'تعذّر إنشاء مشروع، لذا لم يتم إرسال التعليق التوضيحي.',
  'chat.annotationUploadFailed': 'فشل رفع المرفق. يُرجى المحاولة مرة أخرى.',
  'chat.conversationsTitle': 'المحادثات',
  'chat.conversationsAria': 'سجل المحادثات',
  'chat.newConversation': 'محادثة جديدة',
  'chat.newConversationsTitle': 'محادثة جديدة',
  'chat.conversationsHeading': 'المحادثات',
  'chat.new': 'جديد',
  'chat.emptyConversations': 'لا توجد محادثات بعد.',
  'chat.deleteConversation': 'حذف المحادثة',
  'chat.renameConversationLabel': 'إعادة تسمية "{title}"',
  'chat.deleteConversationConfirm': 'هل تريد حذف "{title}"؟ سيؤدي هذا لإزالة رسائلها.',
  'chat.untitledConversation': 'محادثة بدون عنوان',
  'chat.forkedConversationTitle': 'تفرع {title}',
  'chat.forkConversationFailed': 'تعذر تفرع هذه المحادثة.',
  'chat.startTitle': 'ابدأ محادثة',
  'chat.startHint': 'صِف ما تريد إنشاءه، أو ابدأ من أحد هذه الأمثلة:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "تحسين بالذكاء الاصطناعي",
  'brandEnrichment.body': "سيشغل Open Design عملية استخراج أعمق في الخلفية، ويطبق مهارات نظام التصميم المناسبة تلقائياً، ويحدث هذا النظام في مكانه. قد يستغرق ذلك 10-20 دقيقة؛ يمكنك متابعة العمل.",
  'brandEnrichment.cta': "تحسين بالذكاء الاصطناعي",
  'brandEnrichment.busy': "بدء التحسين بالذكاء الاصطناعي...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md الملصق',
  'brandExtractionTranscript.user': 'استخرج نظام تصميم من {source}.',
  'brandExtractionTranscript.doneTitle': 'اكتمل الاستخراج البرمجي لـ {name}.',
  'brandExtractionTranscript.doneBody': 'أنشأت وسجلت نظام التصميم {designSystemId} من {source}. أصبح جاهزاً للمعاينة ويمكن استخدامه الآن في تصاميم جديدة.',
  'brandExtractionTranscript.next': 'بعد ذلك، يمكنك تشغيل تحسين الذكاء الاصطناعي لاستخراج أعمق، أو إنشاء تصميم جديد بهذا النظام.',
  'chat.fillInputTitle': 'اضغط لملء المدخلات',
  'chat.jumpToLatest': 'انتقال للأحدث',
  'chat.scrollToLatest': 'التمرير للأحدث',
  'chat.messageRail.aria': 'التنقل بين رسائل المستخدم',
  'chat.messageRail.jumpAria': 'الانتقال إلى رسالة المستخدم {index}',
  'chat.messageRail.empty': '(لا يوجد محتوى)',
  'chat.you': 'أنت',
  'chat.openFile': 'فتح {name}',
  'chat.copyPrompt': 'نسخ الأمر',
  'chat.copyErrorDiagnostic': 'نسخ تشخيصات الخطأ',
  'chat.copyDone': 'تم النسخ!',
  'chat.inspect.noEditableTargets': 'لم يُعثر على نصوص قابلة للتحرير أو أهداف نمط.',
  'chat.inspect.noCommentTargets': 'لم يُعثر على نصوص قابلة للتعليق أو أهداف مرئية.',
  'chat.inspect.editHint': 'حدّد نصًا أو هدف نمط في المعاينة لتحريره.',
  'chat.inspect.commentHint': 'حدّد نصًا أو منطقة في المعاينة للتعليق عليها.',
  'chat.composerPlaceholder': 'صِف ما تريد إنشاءه…',
  'chat.activeFileEditingLabel': 'جارٍ التحرير',
  'chat.activeFilePlaceholder': 'اطلب من Open Design تعديل {file}...',
  'chat.designArtifactsShowMore': 'عرض {count} ملفات تصميم إضافية',
  'chat.mode.chat.label': 'اسأل',
  'chat.mode.chat.title': 'وضع السؤال',
  'chat.mode.chat.summary': 'للإجابات السريعة، التعديلات، التخطيط، والنقاش من دون افتراض إنشاء ملف تصميم.',
  'chat.mode.chat.solves': 'استخدمه لتوضيح الأفكار، تحسين المطالبات، مقارنة الخيارات، أو السؤال عن عمل موجود.',
  'chat.mode.chat.query1': 'لخص هذه المسودة وحدد الفجوات.',
  'chat.mode.chat.query2': 'ساعدني في اختيار أفضل بنية لصفحة الهبوط هذه.',
  'chat.mode.chat.query3': 'راجع هذا التصميم واقترح تحسينات عملية.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'التصميم',
  'chat.mode.design.title': 'وضع Design',
  'chat.mode.design.summary': 'لإنشاء أو تعديل مخرجات تصميم ملموسة مثل الصفحات، النماذج، القطع الحية، العروض، الصور، الفيديو، HyperFrames، الصوت، لوحات البيانات، وملفات المشروع.',
  'chat.mode.design.solves': 'استخدمه عندما تريد من Open Design إنشاء ملفات، تحديث مساحة العمل، أو تحويل موجز إلى مخرجات متعددة الوسائط جاهزة.',
  'chat.mode.design.query1': 'أنشئ صفحة هبوط لإطلاق منتج ونموذج HyperFrames من هذا الموجز.',
  'chat.mode.design.query2': 'اصنع عرضا استثماريا من 10 شرائح مع ملاحظات للمتحدث.',
  'chat.mode.design.query3': 'ولّد أفكار صور وفيديو وصوت لهذه الحملة.',
  'chat.mode.cardBestFor': 'الأفضل لـ',
  'chat.mode.cardTry': 'جرب أن تسأل',
  'chat.mode.cardCost': 'الاستهلاك المتوقع',
  'chat.mode.chat.cost': 'منخفض',
  'chat.mode.chat.costNote': 'محادثة فقط — لا يتم إنشاء أي ملفات، لذا يستهلك أقل قدر.',
  'chat.mode.plan.cost': 'متوسط',
  'chat.mode.plan.costNote': 'ينشئ مستند خطة قابلاً للتعديل قبل أي عملية إنشاء.',
  'chat.mode.design.cost': 'مرتفع',
  'chat.mode.design.costNote': 'ينشئ ملفات ووسائط متعددة الأنماط، لذا قد يستهلك التشغيل الواحد أكبر قدر.',
  'chat.modePicker.choose': 'اختر وضعًا',
  'chat.modePicker.current': 'الوضع: {name}',
  'chat.modePicker.clear': 'مسح الوضع',
  'chat.modePicker.mode': 'الوضع',
  'chat.composerHint': '⌘/Ctrl + Enter للإرسال · اذكر الهدف والمحتوى والأسلوب والتنسيق',
  'chat.cliSettingsTitle': 'إعدادات CLI والنموذج',
  'chat.cliSettingsAria': 'فتح إعدادات CLI والنموذج',
  'chat.attachTitle': 'إرفاق ملفات (أو الصق / اسحب)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'إرفاق ملفات',
  'chat.importTitle': 'استيراد المصادر (قريباً)',
  'chat.importLabel': 'استيراد',
  'chat.importComingSoon': 'قريباً',
  'chat.importSoon': 'قريباً',
  'chat.importFig': 'رفع ملف .fig',
  'chat.importGitHub': 'ربط GitHub',
  'chat.importWeb': 'جلب عنصر ويب',
  'chat.importFolder': 'ربط مجلد كود',
  'chat.importSkills': 'المهارات وأنظمة التصميم',
  'chat.importProject': 'الإشارة إلى مشروع آخر',
  'chat.importDesignSystemHeader': 'اختر نظام تصميم',
  'chat.importDesignSystemBack': 'رجوع',
  'chat.importDesignSystemSearch': 'البحث في أنظمة التصميم…',
  'chat.importDesignSystemEmpty': 'لا توجد أنظمة تصميم تطابق "{query}"',
  'chat.importDesignSystemNone': 'لا شيء — حر',
  'chat.importDesignSystemNoneSub': 'لا تربط بنظام في هذه الجولة',
  'chat.importDesignSystemActive': 'نشط',
  'chat.importDesignSystemSwitched': 'تم تبديل نظام التصميم إلى {title}',
  'chat.importDesignSystemFailed': 'تعذر تبديل نظام التصميم. حاول مرة أخرى.',
  'chat.importDesignSystemLoadFailed': 'تعذّر تحميل أنظمة التصميم.',
  'browserUse.title': 'الإلهام',
  'browserUse.summary': '{count} إجراء على الويب، مع إعطاء الأولوية لاستخراج الأصول، ولغة التصميم، والحركة، والفحوصات البصرية، وبنية المكوّنات.',
  'browserUse.searchAria': 'البحث عن الإلهام',
  'browserUse.searchPlaceholder': 'ابحث عن لقطات الشاشة والخطوط والألوان وإمكانية الوصول...',
  'browserUse.empty': 'لا يوجد إلهام مطابق',
  'browserUse.unavailable': 'الإلهام غير متاح هنا',
  'browserUse.added': 'تمت الإضافة إلى أداة الإنشاء',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'إيقاف التحميل',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Open Design browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'استخراج الأصول',
  'browserUse.category.tokens': 'لغة التصميم',
  'browserUse.category.motion': 'الحركة',
  'browserUse.category.visual': 'الفحوصات المرئية',
  'browserUse.category.structure': 'المكوّنات',
  'browserUse.category.project': 'تشغيل المشروع',
  'browserUse.category.general': 'عام',
  'browserUse.input.none': 'لا يوجد إدخال',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts، limit=200',
  'browserUse.input.optionalSelector': 'محدِّد اختياري',
  'browserUse.input.requirementSelector': 'متطلَّب، محدِّد اختياري',
  'browserUse.input.selectorOptional': 'محدِّد اختياري',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'محدِّد، scale=2',
  'browserUse.input.gridOverlay': '12 عمودًا، بحد أقصى 1200، فجوة 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL أو نطاق أو مصطلحات بحث',
  'browserUse.input.selector': 'محدِّد',
  'browserUse.input.selectorText': 'محدِّد ونص',
  'browserUse.input.scroll': 'بكسلات، أعلى، أسفل، أو صفحة',
  'browserUse.input.terminalRun': 'أمر، مهلة 120 ثانية',
  'browserUse.input.command': 'أمر',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'أفضل المرشحين للشعار من الترويسة، والتنقُّل، وأسماء الفئات، والموضع، وصورة OG، مع الرجوع إلى أيقونة favicon.',
  'browserUse.action.list_images.output': 'جميع صور img وsrcset وsource وصور الخلفية في CSS مع الأبعاد والنص البديل.',
  'browserUse.action.download_assets.output': 'مجلد الأصول المنزّلة بالإضافة إلى _manifest.json مع دعم referer وملفات تعريف الارتباط.',
  'browserUse.action.extract_svgs.output': 'ملفات SVG المضمّنة والملفات المرتبطة ‎.svg محفوظة كملفات SVG منفردة.',
  'browserUse.action.optimize_svgs.output': 'ملفات SVG مُحسَّنة بالإضافة إلى نسبة الضغط.',
  'browserUse.action.extract_colors.output': 'لوحة ألوان مُرجَّحة بالإضافة إلى متغيرات ألوان CSS ضمن ‎:root كـ palette.json وpalette.html.',
  'browserUse.action.extract_fonts.output': 'أبرز عائلات الخطوط والأحجام والأوزان وقواعد ‎@font-face كـ typography.json.',
  'browserUse.action.extract_design_tokens.output': 'نصف القطر والظل والتباعد ومتغيرات CSS كـ tokens.json.',
  'browserUse.action.extract_type_scale.output': 'سلّم أحجام الخط للعناوين والنص والأزرار مع الحجم والوزن وارتفاع السطر والنسب.',
  'browserUse.action.extract_buttons.output': 'مكتبة أنماط أزرار خالية من التكرار كـ buttons.html وbuttons.json.',
  'browserUse.action.extract_grid_system.output': 'حاويات Grid وflex والاتجاه والفجوات والأعمدة والعروض القصوى كـ layout.json.',
  'browserUse.action.extract_breakpoints.output': 'نقاط التوقف المتجاوبة لاستعلامات الوسائط كـ breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'تدرّجات CSS كـ gradients.css وgradients.json ومعاينة HTML.',
  'browserUse.action.extract_shadows.output': 'ظلال الصناديق وظلال النصوص والظلال المُسقَطة كـ shadows.json بالإضافة إلى معاينة.',
  'browserUse.action.extract_easings.output': 'دوال تخفيف الانتقالات والحركات كـ easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css وtokens.scss وtailwind.theme.js وstyle-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': 'قواعد ‎@keyframes والانتقال والتحويل، ومكتبات الحركة المكتشفة، وmotion.css، وmotion.json.',
  'browserUse.action.validate_view.output': 'مسارات لقطات الشاشة بالإضافة إلى مشكلات مرئية وتخطيطية مُهيكلة.',
  'browserUse.action.audit_layout.output': 'عيوب التخطيط بما في ذلك الفائض، والحدود، والتداخل، والنص المقصوص كـ audit.json.',
  'browserUse.action.audit_accessibility.output': 'مشكلات إمكانية الوصول مع المحدِّدات والتسميات والأدوار والتركيز والتباين ولقطات الشاشة حيثما كان مفيدًا.',
  'browserUse.action.responsive_screenshots.output': 'لقطات شاشة للهاتف 390، والجهاز اللوحي 834، وسطح المكتب 1440.',
  'browserUse.action.screenshot_full.output': 'لقطة شاشة للصفحة كاملةً تتجاوز منطقة العرض.',
  'browserUse.action.screenshot_element.output': 'لقطة شاشة لعنصر واحد بدقة 2x افتراضيًا.',
  'browserUse.action.screenshot_with_grid.output': 'لقطة شاشة مع تراكب شبكة التخطيط.',
  'browserUse.action.screenshot_dark_mode.output': 'لقطة شاشة مع ‎prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'دليل أنماط من صفحة واحدة يتضمّن الألوان وسلّم أحجام الخط ونصف القطر والظلال.',
  'browserUse.action.extract_html.output': 'HTML نظيف ومكتفٍ ذاتيًا دون سمات script أو noscript أو أحداث مضمّنة.',
  'browserUse.action.extract_component_inventory.output': 'أنماط المكوّنات المتكررة والمحدِّدات والأعداد ولقطات الشاشة.',
  'browserUse.action.extract_copy.output': 'العناوين، ودعوات اتخاذ الإجراء، والنص الأساسي، والأوصاف كـ copy.md وcopy.json.',
  'browserUse.action.extract_nav.output': 'التنقُّل الأساسي وروابط التذييل كـ sitemap.md وnav.json.',
  'browserUse.action.extract_forms.output': 'حقول النموذج والتسميات وتلميحات التحقق وإجراءات الإرسال كـ forms.json.',
  'browserUse.action.run_project.output': 'عنوان URL لخادم التطوير المكتشف مفتوحًا في علامة تبويب Browser.',
  'browserUse.action.detect_project.output': 'إطار العمل، ومدير الحزم، وأمر التثبيت، وأمر التطوير، والمنفذ.',
  'browserUse.action.page_info.output': 'URL، والعنوان، والوصف، وصورة OG، ولون السمة، وأيقونة favicon، ومنطقة العرض.',
  'browserUse.action.snapshot.output': 'ما يصل إلى 120 عنصرًا مرئيًا تفاعليًا ونصيًا مع الوسم والتسمية وhref والإحداثيات.',
  'browserUse.action.navigate.output': 'افتح الصفحة وأعد page_info.',
  'browserUse.action.click.output': 'انقر على أول عنصر مطابق بعد تمريره إلى نطاق العرض.',
  'browserUse.action.type_text.output': 'املأ حقل إدخال وأرسل حدثي input وchange.',
  'browserUse.action.scroll.output': 'موضع التمرير الحالي والأقصى.',
  'browserUse.action.extract_og_metadata.output': 'عنوان Meta، الوصف، الـ URL الأساسي (canonical)، بطاقات OG/Twitter، صورة التواصل الاجتماعي، ولون السمة.',
  'browserUse.action.terminal_run.output': 'stdout وstderr ورمز الخروج.',
  'browserUse.action.terminal_run_background.output': 'معرّف المهمة في الخلفية والمخرجات الأخيرة.',
  'browserUse.action.terminal_read.output': 'مخرجات الـ Terminal المشتركة الأخيرة.',
  'chat.designToolbox.title': 'صندوق أدوات التصميم',
  'chat.designToolbox.tooltip': 'صندوق أدوات التصميم',
  'chat.designToolbox.aria': 'افتح صندوق أدوات التصميم',
  'chat.designToolbox.searchPlaceholder': 'ابحث في المهارات / MCP / الإضافات / الموصّلات / ملفات التصميم...',
  'chat.designToolbox.searchAria': 'ابحث في موارد صندوق أدوات التصميم',
  'chat.designToolbox.followupSection': 'متابعة',
  'chat.designToolbox.resourcesSection': 'الموارد العامة',
  'chat.designToolbox.selected': 'المحدد',
  'chat.designToolbox.noResources': 'لم يتم العثور على موارد لـ "{query}".',
  'chat.designToolbox.badge.video': 'فيديو',
  'chat.designToolbox.badge.image': 'صورة',
  'chat.designToolbox.badge.motion': 'حركة',
  'chat.designToolbox.badge.polish': 'صقل',
  'chat.designToolbox.action.auto-match.title': 'طابق الخطوة التالية',
  'chat.designToolbox.action.auto-match.badge': 'طابق',
  'chat.designToolbox.action.auto-match.description': 'حدّد معيار الذوق أولاً، ثم طابق المهارات وMCP والإضافات والموصّلات والملفات.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'أضف رسومًا متحركة / حركة',
  'chat.designToolbox.action.motion.badge': 'حركة',
  'chat.designToolbox.action.motion.description': 'أضف حركات الدخول والتمرير وانتقال الحالة والتفاعلات الدقيقة إلى HTML الحالي أو عنصر الصفحة.',
  'chat.designToolbox.action.motion-polish.title': 'اصقل الحركة',
  'chat.designToolbox.action.motion-polish.badge': 'التوقيت',
  'chat.designToolbox.action.motion-polish.description': 'راجع التوقيت والتخفيف (easing) والأداء وبدائل تقليل الحركة للحركة الحالية.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'أزل الطابع الاصطناعي للذكاء الاصطناعي',
  'chat.designToolbox.action.anti-ai-polish.badge': 'الذوق',
  'chat.designToolbox.action.anti-ai-polish.description': 'أزل الطابع القالبي وتدرّجات الذكاء الاصطناعي وأكوام البطاقات الرخيصة والنصوص المبهمة.',
  'chat.designToolbox.action.visual-polish.title': 'صقل التصميم / جاهز للإطلاق',
  'chat.designToolbox.action.visual-polish.badge': 'صقل',
  'chat.designToolbox.action.visual-polish.description': 'دقّق التسلسل البصري والخط والتباعد والسلوك المتجاوب وإمكانية الوصول وجودة التسليم.',
  'chat.designToolbox.action.image-gen.title': 'أنشئ صورًا / مراجع بصرية',
  'chat.designToolbox.action.image-gen.badge': 'صورة',
  'chat.designToolbox.action.image-gen.description': 'أنشئ مراجع أقسام أو أصولًا أو أيقونات أو صور تواصل اجتماعي أو لوحة إلهام للصفحة الحالية.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'أنشئ فيديو / نص حركة',
  'chat.designToolbox.action.video-gen.badge': 'فيديو',
  'chat.designToolbox.action.video-gen.description': 'حوّل التصميم إلى فيديو قصير أو لوحة قصة Remotion / Hyperframes أو موجه جاهز للتوليد.',
  'chat.designToolbox.kind.skill': 'مهارة',
  'chat.designToolbox.kind.plugin': 'إضافة',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'قالب MCP',
  'chat.designToolbox.kind.connector': 'موصّل',
  'chat.designToolbox.kind.designFile': 'ملف تصميم',
  'chat.designToolbox.context.browser': 'المتصفح',
  'chat.designToolbox.context.designFiles': 'ملفات التصميم',
  'chat.designToolbox.context.designSystem': 'نظام التصميم',
  'chat.designToolbox.context.folder': 'مجلد',
  'chat.designToolbox.context.terminal': 'الطرفية',
  'chat.designToolbox.context.sideChat': 'محادثة جانبية',
  'chat.designToolbox.context.liveArtifact': 'عنصر حي',
  'chat.designToolbox.context.file': 'ملف',
  'chat.designToolbox.prompt.contextGeneric': 'الهدف الحالي: ملف HTML / ملف التصميم / عنصر الويب المفتوح حاليًا.',
  'chat.designToolbox.prompt.contextSpecific': 'الهدف الحالي: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'حافظ على القصد الموجود بالفعل في المُحرّر: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'المهارة المحددة: {skill}. استخدمها كسير العمل الأساسي في هذه الجولة.',
  'chat.designToolbox.prompt.noSkill': 'إذا لم تتطابق أي مهارة محددة، فاختر أولاً أفضل توليفة من المهارات وMCP والإضافات والموصِّلات وملفات التصميم المتاحة.',
  'chat.designToolbox.prompt.autoMatchIntro': 'تصرّف بصفتك المنسِّق للمدير الإبداعي وأكمِل سير عمل تصميمي:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. حدّد أولًا معنى “التصميم الجميل”: الجمهور، والهدف التجاري، وإحساس العلامة التجارية، والمراجع الأسلوبية، وكثافة المعلومات، ومعايير الألوان/الخطوط/الحركة/الأصول، وأنماط الذكاء الاصطناعي/القوالب التي يجب تجنّبها.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. ابحث وطابِق فهرس الموارد الكامل أعلاه. لا تكتفِ بتوصيات صندوق أدوات التصميم؛ بل ادمج المهارات وMCP والإضافات والموصِّلات وملفات التصميم عند الحاجة.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. أكمِل التدفق بهذا الترتيب: التشخيص ← اتجاه النمط ← اختيار الموارد ← التحرير/التوليد الملموس ← التحقق. وفي كل خطوة، اشرح سبب اختيار هذه الموارد وما الذي يحتاج إلى تأكيد بعد ذلك.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'راجِع وحسِّن توقيت الحركة الحالي والتخفيف والأداء وإمكانية الوصول. أزِل الحركة المفاجئة أو الرخيصة أو الضارة بقابلية القراءة؛ واستخدم خطًا زمنيًا أكثر تنقيحًا عند الحاجة.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'نفِّذ تمريرة تنقيح واحدة لإزالة الطابع الاصطناعي للذكاء الاصطناعي: أزِل التخطيطات النمطية والتدرّجات/التوهّجات الرخيصة وأكوام البطاقات بلا معنى والنصوص المبهمة. احفظ المعلومات واجعلها تبدو وكأن مصمِّمًا حقيقيًا قد سلّمها.',
  'chat.designToolbox.prompt.visualPolish': 'نقِّح هذا التصميم حتى يصبح جاهزًا للإطلاق: تحقّق من التسلسل الهرمي والطباعة والتباعد والسلوك المتجاوب وحالات الأزرار وحالات الفراغ/التحميل/الخطأ وإمكانية الوصول؛ وأصلِح أهم المشكلات مباشرة.',
  'chat.designToolbox.prompt.imageGen': 'أنشئ خطة الأصول البصرية التالية لهذا التصميم: مراجع الأقسام أو أصول الواجهة الرئيسية أو الرسوم التوضيحية أو الأيقونات أو الصور الاجتماعية أو لوحة إلهام. حدِّد أولاً نوع الصورة المفقودة، ثم قدِّم موجِّهات توليد قابلة للتنفيذ / خطة ملفات.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'حوِّل هذا التصميم نحو الفيديو: أنشئ لوحة قصة لفيديو قصير، أو بنية إطارات Hyperframes / Remotion، أو موجِّهًا جاهزًا لـ Sora/fal. فضِّل جعل محتوى HTML / الصفحة الحالي يتحوّل بشكل طبيعي إلى لقطات.',
  'chat.designToolbox.prompt.useSkill': 'استخدم {skill} على التصميم الحالي.',
  'chat.designToolbox.prompt.skillInstruction': 'حدِّد أولاً أفضل هدف للمتابعة، ثم أكمِل تمريرة ملموسة واحدة. وإذا كان يعتمد على أصول أو واجهات API خارجية، فقدِّم بديلاً احتياطيًا قابلاً للتشغيل أو بيِّن ما أحتاج إلى توفيره.',
  'chat.designToolbox.prompt.selectedResource': 'المورد المحدد: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'وصف المورد: {description}',
  'chat.designToolbox.prompt.pluginResource': 'استخدم هذه الإضافة كسياق رئيسي لتدفّق التصميم الحالي. إذا كانت تكشف مدخلات أو GenUI، فأرشدني إلى الاختيار عند الحاجة؛ وإذا لم تناسب الهدف، فاختر موردًا عامًا أفضل واشرح السبب.',
  'chat.designToolbox.prompt.mcpResource': 'فضِّل إمكانية MCP هذه لخطوة التصميم التالية. عند الحاجة إلى أصول خارجية أو التقاط من الويب أو توليد صور/فيديو أو بيانات، حدِّد أولاً ما إذا كانت قادرة على إنجاز المهمة، ثم قدِّم خطة قابلة للتنفيذ.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'هذا الـ MCP قالب قابل للتهيئة. إذا كان الأداة الأكثر فائدة لخطوة التصميم هذه، فأرشِد إلى الإعداد أولاً؛ وإذا وُجد بديل مُهيّأ، فتابِع بذلك البديل.',
  'chat.designToolbox.prompt.connectorResource': 'استخدم هذا الموصِّل عند الحاجة إلى بيانات حقيقية أو أصول أو محتوى حساب أو الوصول إلى سير عمل خارجي. قبل استخدامه، اشرح ما الذي ستتم قراءته أو كتابته واطلب التأكيد عند الاقتضاء.',
  'chat.designToolbox.prompt.fileResource': 'استخدم ملف التصميم هذا كهدف تصميم حالي أو أصل مرجعي وأكمِل الخطوة التالية انطلاقًا منه. وإذا احتاجت ملفات أخرى إلى المقارنة، فتابِع البحث عبر جميع ملفات التصميم.',
  'chat.designToolbox.prompt.resourceIndex': 'فهرس الموارد العام: المهارات({skills})، الإضافات({plugins})، MCP({mcpEnabled} مُفعَّل / {mcpTemplates} قالب)، الموصِّلات({connectors} متصل)، ملفات التصميم({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'المهارات القابلة للبحث',
  'chat.designToolbox.prompt.searchablePlugins': 'الإضافات القابلة للبحث',
  'chat.designToolbox.prompt.availableMcp': 'MCP المتاح',
  'chat.designToolbox.prompt.connectedConnectors': 'الموصِّلات المتصلة',
  'chat.designToolbox.prompt.referenceDesignFiles': 'ملفات التصميم المرجعية',
  'chat.designToolbox.prompt.mcpTemplateName': 'قالب {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': '، +{count} أخرى',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'أسطح الإشارة',
  'chat.mentionTabAll': 'الكل',
  'chat.mentionTabTabs': 'علامات التبويب',
  'chat.mentionTabPlugins': 'الإضافات',
  'chat.mentionTabSkills': 'المهارات',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'الموصِّلات',
  'chat.mentionTabFiles': 'ملفات التصميم',
  'chat.mentionNoResults': 'لا نتائج لـ “{query}”.',
  'chat.mentionSearchPrompt': 'ابحث في ملفات التصميم وعلامات التبويب والإضافات والمهارات وخوادم MCP والموصِّلات.',
  'chat.mentionSectionTabs': 'علامات التبويب',
  'chat.mentionSectionPlugins': 'الإضافات',
  'chat.mentionSectionSkills': 'المهارات',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'الموصِّلات',
  'chat.mentionSectionFiles': 'ملفات التصميم',
  'chat.mentionActiveSkill': 'نشط',
  'chat.mentionUseMcpTitle': 'استخدم {name}',
  'chat.mentionUseConnectorTitle': 'استخدم {name}',
  'chat.mentionPluginOfficial': 'رسمي',
  'chat.mentionPluginMine': 'إضافتي',
  'chat.linkedFolderRemoveAria': 'إزالة المجلد المرتبط {path}',
  'chat.linkedFolderNotFound': 'المجلد غير موجود',
  'chat.linkedFolderAlready': 'هذا المجلد مرتبط بالفعل',
  'chat.linkedFolderPickError': 'تعذر فتح منتقي المجلدات',
  'chat.queuedHeader': 'في قائمة الانتظار',
  'chat.queuedToSend': 'للإرسال',
  'chat.queuedEditQueuedTaskAria': 'تحرير المهمة في قائمة الانتظار',
  'chat.queuedSave': 'حفظ',
  'chat.queuedCancel': 'إلغاء',
  'chat.queuedReorder': 'اسحب لإعادة الترتيب',
  'chat.queuedEdit': 'تحرير',
  'chat.queuedMore': 'في قائمة الانتظار',
  'chat.queuedFollowUpFallback': 'متابعة في قائمة الانتظار',
  'chat.send': 'إرسال',
  'chat.stop': 'إيقاف',
  'chat.removeAria': 'إزالة {name}',
  'chat.example1Title': 'عرض تقديمي تحريري',
  'chat.example1Tag': 'مجلة',
  'chat.example1Prompt': 'عرض تقديمي تحريري من 10 شرائح لاستوديو تصميم يجمع تمويلاً - تخطيط شبكة سويسرية، عناوين عريضة مع أحرف استهلالية بارزة، أرقام أقسام أحادية المسافة، مساحات سلبية سخية، وشرائح صور بملء الشاشة تتخللها شرائح نصية مكثفة. الغلاف، الرؤية، السوق، المنتج، الزخم، الفريق، الطلب، الاتصال.',
  'chat.example2Title': 'لوحة تحكم تحليلات SaaS',
  'chat.example2Tag': 'بيانات',
  'chat.example2Prompt': 'لوحة تحكم تحليلات مكثفة لـ SaaS لأدوات المطورين - شريط KPI مع التغييرات الأسبوعية، مخططان خطيان متراكمان (MRR ومساحات العمل النشطة)، خريطة حرارية عالمية للاستخدام، شبكة احتفاظ بالمجموعات، لوحة صدارة لكبار العملاء، وخلاصة أحداث فورية. سمة داكنة، أرقام أحادية المسافة، تأثيرات sparkline.',
  'chat.example3Title': 'تقرير سنوي بالتمرير الطويل',
  'chat.example3Tag': 'تحريري',
  'chat.example3Prompt': 'تقرير سنوي تفاعلي لمنظمة مناخية غير ربحية - تخطيط تحريري بالتمرير الطويل يمزج بين كتل الاقتباسات الكبيرة، تصورات البيانات (أعمدة متراكمة، عدادات متحركة، خريطة لمواقع المشاريع)، فواصل صور، جدار المتبرعين، ودعوة نهائية للعمل. خط متن حديث، تسميات مخططات sans-serif، لوحة ألوان ورقية ترابية.',
  'home.recommendation.eyebrow': 'موصى به لك',
  'home.recommendation.primaryCta': 'ابدأ الإنشاء',
  'home.recommendation.change': 'جرّب نوعًا آخر',
  'home.recommendation.browseAll': 'كل الأنواع',
  'home.recommendation.defaultProjectName': 'مشروع جديد',
  'home.recommendation.startFailed': 'تعذّر بدء الإنشاء. حاول مرة أخرى.',
  'studio.firstArtifactHint.title': 'تصميمك الأول جاهز',
  'studio.firstArtifactHint.body': 'جرّب التحرير وإضافة التعليقات مباشرة — صدِّر أو شارك متى كنت راضيًا.',
  'studio.firstArtifactHint.dismiss': 'حسنًا',
  'home.starter.product_ui_prototype.title': 'ابدأ بنموذج منتج أولي قابل للتحرير',
  'home.starter.product_ui_prototype.desc': 'بناءً على هدفك، ابدأ بواجهة قابلة للنقر يمكنك تحسينها.',
  'home.starter.product_ui_prototype.firstPrompt': 'صمّم نموذجًا أوليًا قابلًا للتحرير لمنتج [منتجك] يتضمن الشاشات الرئيسية وتدفقًا أساسيًا واضحًا.',
  'home.starter.product_ui_component.title': 'ابدأ من مكوّن قابل لإعادة الاستخدام',
  'home.starter.product_ui_component.desc': 'ابنِ مكوّنًا واحدًا أولًا، ثم اجمعه في شاشات كاملة.',
  'home.starter.product_ui_component.firstPrompt': 'صمّم مكوّن [اسم المكوّن] قابلًا لإعادة الاستخدام مع حالاته الرئيسية وتنويعاته.',
  'home.starter.product_ui_lowfi.title': 'ابدأ بنموذج أولي منخفض الدقة',
  'home.starter.product_ui_lowfi.desc': 'ارسم الهيكل أولًا، ثم ارفع مستوى الدقة.',
  'home.starter.product_ui_lowfi.firstPrompt': 'أنشئ إطارًا سلكيًا منخفض الدقة للشاشات الرئيسية لمنتج [منتجك].',
  'home.starter.marketing_landing.title': 'ابدأ بصفحة هبوط',
  'home.starter.marketing_landing.desc': 'حوّل حملتك إلى صفحة هبوط جاهزة للنشر.',
  'home.starter.marketing_landing.firstPrompt': 'صمّم صفحة هبوط لمنتج [منتجك] تتضمن قسمًا رئيسيًا، والمزايا الأساسية، ودعوة واضحة للعمل.',
  'home.starter.marketing_multivariant.title': 'ابدأ بعدة تنويعات لصفحة الهبوط',
  'home.starter.marketing_multivariant.desc': 'أنشئ بضع نسخ للمقارنة قبل أن تحسم قرارك.',
  'home.starter.marketing_multivariant.firstPrompt': 'أنشئ 3 تنويعات لصفحة الهبوط لمنتج [منتجك] برسائل رئيسية مختلفة للمقارنة.',
  'home.starter.internal_dashboard.title': 'ابدأ بلوحة تحكم داخلية',
  'home.starter.internal_dashboard.desc': 'ابدأ من تخطيط لوحة تحكم لسير عملك.',
  'home.starter.internal_dashboard.firstPrompt': 'صمّم لوحة تحكم داخلية تعرض [المقاييس الرئيسية] مع عوامل تصفية وجدول بيانات.',
  'home.starter.internal_report.title': 'ابدأ بتقرير',
  'home.starter.internal_report.desc': 'صِف البيانات والحقول التي تريد رؤيتها.',
  'home.starter.internal_report.firstPrompt': 'أنشئ صفحة تقرير تلخّص [صف البيانات والحقول والمقاييس التي تهمك].',
  'home.starter.general_menu.title': 'ابدأ بمشروعك الأول',
  'home.starter.general_menu.desc': 'صِف ما تريده وسننشئ نسخة أولى قابلة للتحرير.',
  'home.starter.general_menu.firstPrompt': 'أنشئ نسخة أولى قابلة للتحرير من [صف ما تريد إنشاءه].',
  'chat.example4Title': 'فيديو حركة للمنتج',
  'chat.example4Tag': 'حركة',
  'chat.example4Prompt': 'أنشئ ستوريبورد فيديو حركة مدته 15 ثانية لإطلاق تطبيق إنتاجية: افتتاحية جاذبة، لقطات قريبة للواجهة، تايبوجرافي حركي، انتقالات للميزات، شعار ختامي و CTA. أضف التوقيت، وصف المشاهد، حركة الكاميرا، والنصوص على الشاشة.',
  'preview.usePlugin': 'استخدام الإضافة',
  'preview.usePluginOnly': 'استخدام بدون مطالبة',
  'preview.usePluginOnlyDesc': 'استخدم بنية الإضافة بدون تحميل المطالبة النموذجية',
  'preview.replicateContent': 'استخدام',
  'preview.replicateContentDesc': 'استخدم المطالبة النموذجية لإعادة إنشاء المعاينة',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'حوّل هذا المثال إلى مشروع جديد قابل للتحرير عبر Remix',
  'preview.shareMenu': 'مشاركة',
  'preview.exportMenu': 'تصدير',
  'preview.shareTemplateBadge': 'قالب',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'نسخ رابط القالب',
  'preview.copyShareText': 'نسخ نص المشاركة',
  'preview.shareSocialGroup': 'مشاركة على وسائل التواصل',
  'preview.shareCopyGroup': 'نسخ',
  'preview.shareExportGroup': 'تصدير الملفات',
  'preview.shareCopied': 'تم النسخ',
  'preview.shareCopyFailed': 'فشل النسخ',
  'preview.shareTextDefault': 'قالب Open Design: {title}',
  'preview.openInNewTab': 'فتح في علامة تبويب جديدة',
  'preview.exit': '⤓ خروج',
  'preview.fullscreen': '⤢ ملء الشاشة',
  'preview.closeTitle': 'إغلاق (Esc)',
  'preview.loading': 'جاري تحميل {label}...',
  'preview.errorTitle': 'تعذّر تحميل هذا المثال.',
  'preview.errorBody': 'فشل جلب HTML الخاص بالمثال. تأكد من تشغيل Open Design ثم أعد المحاولة.',
  'preview.retry': 'إعادة المحاولة',
  'preview.unavailableTitle': 'لا توجد معاينة مرفقة لـ{noun}.',
  'preview.unavailableBody': 'شغّل الأمر في المحادثة لإنشاء مخرجات {kind}.',
  'preview.nounSkill': 'هذه المهارة',
  'preview.nounPlugin': 'هذه الإضافة',
  'preview.nounTemplate': 'هذا القالب',
  'preview.showSidebar': 'إظهار {label}',
  'preview.hideSidebar': 'إخفاء {label}',
  'misc.savedTemplate': 'قالب محفوظ',
  'misc.primary': 'أساسي',
  'misc.designSystem': 'نظام تصميم',
  'workspace.designFiles': 'ملفات التصميم',
  'workspace.focusMode': 'التركيز على مساحة العمل',
  'workspace.showChat': 'إظهار المحادثة',
  'workspace.closeTab': 'إغلاق علامة التبويب',
  'workspace.fileSyncDownloading': 'جارٍ التنزيل من الفريق…',
  'workspace.fileSyncUploading': 'جارٍ المزامنة مع الفريق…',
  'workspace.deleteFileConfirm': 'حذف "{name}" من مجلد المشروع؟',
  'workspace.readonlyNotice': 'هذا مشروع مشترك — يمكنك عرضه والتعليق عليه، لكن لا يمكنك تعديل العناصر عبر الدردشة أو أدوات التحرير.',
  'workspace.readonlyNoticeBy': 'هذا مشروع مشترك أنشأه {owner} — يمكنك عرضه والتعليق عليه، لكن لا يمكنك تعديل العناصر عبر الدردشة أو أدوات التحرير.',
  'workspace.deleteSelectedFilesConfirm': 'حذف {n} ملف(ات) محددة من مجلد المشروع؟',
  'workspace.deleteSelectedFilesPartial': 'فشل حذف {n} ملف(ات).',
  'workspace.openFromDesignFiles': 'فتح ملف من',
  'workspace.designFilesLink': 'ملفات التصميم',
  'workspace.loadingSketch': 'جاري تحميل الرسم...',
  'workspace.newTab': 'علامة تبويب جديدة',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'علامات التبويب المفتوحة',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.newSketchDescription': 'Sketch rough layouts and notes for the agent to use as design context',
  'workspace.terminalStarting': 'جارٍ بدء تشغيل الطرفية…',
  'workspace.terminalStartingDescription': 'يتم تجهيز صدفة المشروع. يستغرق ذلك عادة بضع ثوانٍ.',
  'workspace.terminalSessionEnded': 'انتهت الجلسة',
  'workspace.terminalReconnecting': 'جارٍ إعادة الاتصال…',
  'workspace.terminalStartFailed': 'تعذّر بدء جلسة الطرفية',
  'workspace.terminalRestart': 'إعادة التشغيل',
  'designFiles.title': 'ملفات التصميم',
  'designFiles.upload': 'رفع ملفات',
  'designFiles.pasteText': 'لصق كملف نصي',
  'designFiles.newSketch': 'رسم جديد',
  'designFiles.newDocument': 'مستند جديد',
  'designFiles.newDocumentTitle': 'إنشاء مستند Markdown جديد',
  'designFiles.empty': 'ستظهر الإبداعات هنا',
  'designFiles.syncing': 'جارٍ مزامنة الملفات المشتركة مع الفريق…',
  'designFiles.refresh': 'تحديث',
  'designFiles.delete': 'حذف',
  'designFiles.searchPlaceholder': 'بحث في الملفات...',
  'designFiles.up': 'للأعلى',
  'designFiles.back': 'رجوع',
  'designFiles.crumbs': 'مشروع',
  'designFiles.rowMenu': 'قائمة الصف',
  'designFiles.openInTab': 'فتح في علامة تبويب',
  'designFiles.download': 'تحميل',
  'designFiles.downloadSelected': 'تنزيل {n} كـ ZIP',
  'designFiles.deleteSelected': 'حذف {n}',
  'designFiles.clearSelection': 'مسح التحديد',
  'designFiles.selectPage': 'تحديد الكل في الصفحة',
  'designFiles.selectAll': 'تحديد الكل',
  'designFiles.dropTitle': '⤓ أسقط الملفات هنا',
  'designFiles.dropDesc': 'الصور، المستندات، المراجع، أو المجلدات - سيستخدمها الوكيل كسياق.',
  'designFiles.dropLabel': 'أفلت الملفات هنا',
  'designFiles.upload.title': 'رفع ملفات',
  'designFiles.paste.title': "لصق نص كملف",
  'designFiles.upload.label': 'رفع',
  'designFiles.paste.label': "لصق",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Open Design should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Open Design agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Open Design to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'فتح',
  'designFiles.previewClose': 'إغلاق المعاينة',
  'designFiles.modified': 'تم التعديل {time} · {size}',
  'designFiles.weeksAgo': 'منذ {n} أسبوع',
  'designFiles.groupBy': 'التجميع حسب',
  'designFiles.groupByKind': 'النوع',
  'designFiles.groupByModified': 'تاريخ التعديل',
  'designFiles.filterBy': 'تصفية حسب النوع',
  'designFiles.filterClear': 'مسح',
  'designFiles.filterCount': '{n} أنواع',
  'designFiles.expandGroup': 'توسيع',
  'designFiles.collapseGroup': 'طي',
  'designFiles.sectionPages': 'صفحات',
  'designFiles.sectionScripts': 'سكربتات',
  'designFiles.sectionImages': 'صور',
  'designFiles.sectionSketches': 'رسومات',
  'designFiles.sectionLiveArtifacts': 'عناصر حية',
  'designFiles.sectionOther': 'أخرى',
  'designFiles.modifiedToday': 'اليوم',
  'designFiles.modifiedYesterday': 'أمس',
  'designFiles.modifiedPrevious7Days': 'آخر 7 أيام',
  'designFiles.modifiedPrevious30Days': 'آخر 30 يومًا',
  'designFiles.modifiedOlder': 'أقدم',
  'designFiles.showMore': 'عرض +{n} أخرى',
  'designFiles.kindHtml': 'صفحة HTML',
  'designFiles.kindImage': 'صورة',
  'designFiles.kindSketch': 'رسم',
  'designFiles.kindText': 'نص',
  'designFiles.kindCode': 'سكربت',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'مستند',
  'designFiles.kindPresentation': 'عرض تقديمي',
  'designFiles.kindSpreadsheet': 'جدول بيانات',
  'designFiles.kindLiveArtifact': 'عنصر حي',
  'designFiles.kindBinary': 'ثنائي',
  'designFiles.kindFolder': 'مجلد',
  'designFiles.folderCount': '{n} ملفات',
  'designFiles.newFolderTitle': 'مجلد جديد',
  'designFiles.newFolderLabel': 'اسم المجلد',
  'designFiles.moveTitle': 'نقل إلى مجلد',
  'designFiles.moveLabel': 'المجلد الوجهة',
  'designFiles.moveRoot': 'جذر المشروع',
  'designFiles.moveNewFolder': 'مجلد جديد…',
  'designFiles.move': 'نقل',
  'designFiles.copyPath': 'نسخ المسار',
  'designFiles.copiedPath': 'تم نسخ المسار',
  'designFiles.copyLocalPath': 'نسخ مسار الملف المحلي',
  'designFiles.copiedLocalPath': 'تم نسخ مسار الملف المحلي',
  'designFiles.deleteFolderConfirm': 'حذف المجلد "{name}" وكل محتوياته؟',
  'designFiles.folderCreated': 'تم إنشاء المجلد "{name}"',
  'designFiles.folderDeleted': 'تم حذف المجلد "{name}"',
  'designFiles.filesMoved': 'تم نقل {n} إلى {dest}',
  'designFiles.colName': 'الاسم',
  'designFiles.colKind': 'النوع',
  'designFiles.colModified': 'آخر تعديل',
  'designFiles.perPage': 'عرض',
  'designFiles.all': 'الكل',
  'designFiles.prev': 'السابق',
  'designFiles.next': 'التالي',
  'designFiles.jumpToPage': 'انتقل إلى الصفحة',
  'designFiles.pageInfo': '{start}–{end} من {total}',
  'designFiles.sectionFolders': 'المجلدات',
  'designFiles.sectionStylesheets': 'أوراق الأنماط',
  'designFiles.sectionDocuments': 'المستندات',
  'designFiles.kindStylesheet': 'ورقة أنماط',
  'designFiles.modifiedExt': 'عُدّل {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'معلومات مفيدة',
  'designFiles.usefulInfoTip': 'انقر نقرًا مزدوجًا على أي ملف لفتحه في علامة تبويب كاملة.',
  'designFiles.usefulInfoTip2': 'اكتب @ في المحادثة للإشارة إلى ملف كسياق.',
  'designFiles.usefulInfoTip4': 'اختر نظام تصميم لتحصل على نتائج متوافقة مع هوية علامتك.',
  'designFiles.usefulInfoTip5': 'لا توجد أفكار؟ جرّب قالب إضافة من قسم المجتمع في الصفحة الرئيسية.',
  'designFiles.usefulInfoTip6': 'لديك سؤال أو اقتراح؟ انضم إلينا على Discord.',
  'designFiles.usefulInfoTip7': 'أعجبك Open Design؟ امنحنا نجمة على GitHub.',
  'designFiles.usefulInfoTip8': 'تابع @OpenDesignHQ على X لمعرفة آخر المستجدات.',
  'designFiles.usefulInfoTip9': 'اسحب الصور أو المستندات أو مجلدات كاملة إلى هذه اللوحة — سيستخدمها الوكيل كسياق.',
  'designFiles.usefulInfoTip10': 'انقر على «رسم جديد» وارسم تخطيطًا تقريبيًا ليولّد الوكيل التصميم منه.',
  'designFiles.usefulInfoTip11': 'حدد أي عنصر في المعاينة للتعليق عليه — سيجري الوكيل تعديلات موجهة.',
  'designFiles.usefulInfoTip12': 'لم تعجبك النتيجة؟ تحديد العنصر أسرع من إعادة الوصف.',
  'designFiles.usefulInfoTip13': 'صدّر أي تصميم كملف PDF أو صورة أو HTML مستقل بنقرة واحدة.',
  'designFiles.usefulInfoTip14': 'أعجبك مشروع؟ احفظه كقالب من قائمة المشاركة لإعادة استخدامه.',
  'designFiles.usefulInfoTip15': 'بعد النشر، أنشئ بطاقات مشاركة اجتماعية مباشرة.',
  'designFiles.usefulInfoTip16': 'تابع @opendesign.ai على Threads لمتابعة ما يجري خلف الكواليس.',
  'designFiles.usefulInfoTip17': 'تابع @opendesign.ai على Instagram للحصول على إلهام في التصميم.',
  'designFiles.usefulInfoTip18': 'اشترك في Open Design على YouTube لمشاهدة الشروحات والعروض.',
  'designFiles.usefulInfoTip19': 'تابع Open Design على LinkedIn لأخبار المنتج.',
  'designFiles.usefulInfoTip20': 'تابع Open Design على Xiaohongshu للحصول على نصائح وإلهام.',
  'quickSwitcher.placeholder': 'فتح ملف…',
  'quickSwitcher.empty': 'لا توجد ملفات في هذا المشروع',
  'quickSwitcher.noMatches': 'لا توجد نتائج',
  'quickSwitcher.navigate': 'تنقل',
  'quickSwitcher.open': 'فتح',
  'quickSwitcher.close': 'إغلاق',
  'pasteDialog.title': 'لصق نص',
  'pasteDialog.hint': 'يحفظ في مجلد المشروع. اختر أي اسم.',
  'pasteDialog.fileNameLabel': 'اسم الملف',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'المحتوى',
  'pasteDialog.contentPlaceholder': 'الصق أي شيء...',
  'pasteDialog.save': 'حفظ',
  'pasteDialog.cancel': 'إلغاء',
  'sketch.save': 'حفظ الرسم',
  'sketch.cancel': 'إلغاء',
  'sketch.saving': 'جاري الحفظ...',
  'sketch.saved': 'تم الحفظ',
  'sketch.tooltipMainMenu': 'القائمة الرئيسية: الحفظ والتصدير والمساعدة وإعدادات اللوحة',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'تغييرات غير محفوظة',
  'sketch.tooltipClean': 'تم الحفظ',
  'fileViewer.empty': 'اختر ملفاً لعرضه.',
  'fileViewer.loading': 'جاري التحميل...',
  'fileViewer.exportPptx': 'تصدير كـ PPTX',
  'fileViewer.openInNewTab': 'فتح في علامة تبويب جديدة',
  'fileViewer.copyPath': 'نسخ المسار',
  'fileViewer.copied': 'تم النسخ!',
  'fileViewer.share': 'مشاركة',
  'fileViewer.binaryMeta': 'ثنائي · {size}',
  'fileViewer.binaryNote': 'ملف ثنائي ({size} بايت). حمله أو افتحه من القرص لفحصه.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'مستند',
  'fileViewer.presentationMeta': 'عرض تقديمي',
  'fileViewer.spreadsheetMeta': 'جدول بيانات',
  'fileViewer.previewUnavailable': 'المعاينة غير متوفرة. حمل الملف أو افتحه لفحصه.',
  'fileViewer.download': 'تحميل',
  'fileViewer.open': 'فتح',
  'fileViewer.imageMeta': 'صورة · {size}',
  'fileViewer.reactMeta': 'مكون React · {size}',
  'fileViewer.sketchMeta': 'رسم · {size}',
  'fileViewer.markdownStreamingMeta': 'معاينة متدفقة...',
  'fileViewer.markdownErrorMeta': 'قد تكون المعاينة غير مكتملة (خطأ في التوليد).',
  'fileViewer.markdownStreamingStatus': 'تدفق... عرض ماركداون جزئي.',
  'fileViewer.markdownErrorStatus': 'خطأ في التوليد. عرض آخر محتوى متوفر.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'فيديو · {size}',
  'fileViewer.audioMeta': 'صوت · {size}',
  'fileViewer.reload': 'إعادة تحميل',
  'fileViewer.reloadDisk': 'إعادة تحميل من القرص',
  'fileViewer.copy': 'نسخ',
  'fileViewer.copyTitle': 'نسخ محتويات الملف',
  'fileViewer.saveDisabled': 'حفظ (عارض للقراءة فقط)',
  'fileViewer.save': 'حفظ',
  'fileViewer.preview': 'معاينة',
  'fileViewer.source': 'المصدر',
  'fileViewer.tweaks': 'تعديلات',
  'fileViewer.tweaksUnavailable': 'لا توجد لوحة تعديلات في هذا العمل',
  'fileViewer.jsxModuleTitle': 'لا توجد معاينة مستقلة',
  'fileViewer.jsxModuleBody': 'هذا الملف وحدة مكوّن يتم تحميلها بواسطة صفحة أخرى.',
  'fileViewer.jsxModuleCta': 'افتح الصفحة التي تعرضه:',
  'fileViewer.comment': 'تعليق',
  'fileViewer.edit': 'تعديل',
  'fileViewer.draw': 'رسم',
  'fileViewer.mark': 'تحديد',
  'fileViewer.markTool': 'أداة التحديد',
  'fileViewer.boxSelect': 'تحديد بمربع',
  'fileViewer.textTool': 'نص',
  'fileViewer.textAnnotationRemove': 'إزالة النص',
  'fileViewer.screenshot': 'لقطة شاشة',
  'fileViewer.versions.entry': 'الإصدارات',
  'fileViewer.versions.entryFull': 'سجل الإصدارات',
  'fileViewer.versions.title': 'الإصدارات',
  'fileViewer.versions.countOne': 'إصدار واحد',
  'fileViewer.versions.countMany': '{count} إصدارات',
  'fileViewer.versions.current': 'الحالي',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'الإصدار {version}',
  'fileViewer.versions.listAria': 'إصدارات الملف',
  'fileViewer.versions.loading': 'جار تحميل الإصدارات...',
  'fileViewer.versions.empty': 'لا توجد إصدارات بعد.',
  'fileViewer.versions.loadFailed': 'تعذر تحميل الإصدارات.',
  'fileViewer.versions.previewFailed': 'تعذر تحميل معاينة هذا الإصدار.',
  'fileViewer.versions.previewLoading': 'جار تحميل معاينة الإصدار...',
  'fileViewer.versions.noPrompt': 'لا يوجد موجه محفوظ',
  'fileViewer.versions.noPromptBody': 'لم يتم حفظ موجه لهذا الإصدار.',
  'fileViewer.versions.promptTitle': 'الموجه',
  'fileViewer.versions.copyPrompt': 'نسخ الموجه',
  'fileViewer.versions.fullscreen': 'معاينة بملء الشاشة',
  'fileViewer.versions.open': 'فتح المعاينة',
  'fileViewer.versions.currentHelp': 'هذا هو الإصدار الحالي بالفعل.',
  'fileViewer.versions.restoreHelp': 'سيؤدي التبديل إلى استعادة ملف HTML هذا كإصدار حالي جديد.',
  'fileViewer.versions.restore': 'التبديل إلى هذا الإصدار',
  'fileViewer.versions.restoreConfirmTitle': 'التبديل إلى هذا الإصدار؟',
  'fileViewer.versions.restoreConfirmCta': 'تبديل',
  'fileViewer.versions.restoring': 'جار التبديل...',
  'fileViewer.versions.restoreFailed': 'تعذر التبديل إلى هذا الإصدار.',
  'fileViewer.versions.restoreSuccess': 'تم التبديل إلى هذا الإصدار.',
  'fileViewer.editScreenshotToChat': 'إرسال لقطة الشاشة إلى المحادثة',
  'manualEdit.layers': 'الطبقات',
  'manualEdit.editableCount': '{count} قابلة للتحرير',
  'manualEdit.hiddenBadge': 'مخفية',
  'manualEdit.title': 'المحرر اليدوي',
  'manualEdit.fallbackTitle': 'تحرير',
  'manualEdit.movePanel': 'نقل لوحة التحرير',
  'manualEdit.editParams': 'تعديل المعلمات',
  'manualEdit.closePanel': 'إغلاق لوحة التحرير',
  'manualEdit.selectLayer': 'اختر طبقة',
  'manualEdit.empty': 'انقر على عنصر في المعاينة أو اختر طبقة.',
  'manualEdit.noEditableLayers': 'لم يتم العثور على طبقات قابلة للتحرير.',
  'manualEdit.noClass': 'بدون فئة',
  'manualEdit.tabsAria': 'علامات تبويب التحرير اليدوي',
  'manualEdit.tabContent': 'المحتوى',
  'manualEdit.tabStyle': 'النمط',
  'manualEdit.tabAttributes': 'السمات',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'المصدر',
  'manualEdit.attributesJson': 'السمات بصيغة JSON',
  'manualEdit.selectedHtml': 'HTML للعنصر المحدد',
  'manualEdit.fullSource': 'المصدر الكامل للعنصر',
  'manualEdit.applyContent': 'تطبيق المحتوى',
  'manualEdit.applyStyle': 'تطبيق النمط',
  'manualEdit.applyAttributes': 'تطبيق السمات',
  'manualEdit.applyHtml': 'تطبيق HTML',
  'manualEdit.applySource': 'تطبيق المصدر',
  'manualEdit.invalidAttributes': 'السمات بصيغة JSON غير صالحة.',
  'manualEdit.changes': 'التغييرات',
  'manualEdit.undo': 'تراجع',
  'manualEdit.redo': 'إعادة',
  'manualEdit.noChanges': 'لا توجد تعديلات يدوية بعد.',
  'manualEdit.imageUrl': 'عنوان URL للصورة',
  'manualEdit.altText': 'النص البديل',
  'manualEdit.label': 'التسمية',
  'manualEdit.text': 'النص',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'لون النص',
  'manualEdit.background': 'الخلفية',
  'manualEdit.fontSize': 'حجم الخط',
  'manualEdit.weight': 'السماكة',
  'manualEdit.align': 'المحاذاة',
  'manualEdit.textAlignLeft': 'محاذاة لليسار',
  'manualEdit.textAlignCenter': 'توسيط',
  'manualEdit.textAlignRight': 'محاذاة لليمين',
  'manualEdit.padding': 'التباعد الداخلي',
  'manualEdit.margin': 'الهامش',
  'manualEdit.radius': 'نصف القطر',
  'manualEdit.referenceValues': 'القيم المرجعية',
  'manualEdit.referenceValuesEmpty': 'لا توجد قيم مرجعية مطابقة',
  'manualEdit.referenceValuesLoading': 'جارٍ التحميل…',
  'manualEdit.lineHeight': 'ارتفاع السطر',
  'manualEdit.letterSpacing': 'تباعد الأحرف',
  'manualEdit.borderStyle': 'نمط الحد',
  'manualEdit.borderStyleSolid': 'خط متصل',
  'manualEdit.borderStyleDashed': 'خط متقطع',
  'manualEdit.borderStyleDotted': 'خط منقّط',
  'manualEdit.borderStyleDouble': 'خط مزدوج',
  'manualEdit.borderStyleNone': 'بلا',
  'manualEdit.border': 'الحدود',
  'manualEdit.width': 'العرض',
  'manualEdit.minHeight': 'أدنى ارتفاع',
  'manualEdit.deleteElement': 'حذف العنصر',
  'manualEdit.deleteElementConfirm': 'حذف العنصر المحدد؟ يمكن التراجع عن ذلك باستخدام تراجع.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'رفع صورة',
  'manualEdit.uploadingImage': 'جارٍ رفع الصورة…',
  'manualEdit.uploadImageFailed': 'تعذّر رفع الصورة.',
  'manualEdit.focusSlides': 'التركيز على الشرائح',
  'manualEdit.showPanels': 'إظهار اللوحات',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'تصغير',
  'fileViewer.zoomIn': 'تكبير',
  'fileViewer.resetZoom': 'إعادة تعيين الزوم',
  'fileViewer.viewportAria': 'منفذ عرض المعاينة',
  'fileViewer.viewportDesktop': 'سطح المكتب',
  'fileViewer.viewportDesktopTitle': 'معاينة سطح المكتب بعرض كامل',
  'fileViewer.viewportTablet': 'الجهاز اللوحي',
  'fileViewer.viewportTabletTitle': 'معاينة الجهاز اللوحي بأبعاد 820 × 1180 (الأساس العمودي الحديث)',
  'fileViewer.viewportMobile': 'الجوال',
  'fileViewer.viewportMobileTitle': 'معاينة الجوال بأبعاد 390 × 844',
  'fileViewer.reloadAria': 'إعادة تحميل',
  'fileViewer.previousSlide': 'الشريحة السابقة',
  'fileViewer.nextSlide': 'الشريحة التالية',
  'fileViewer.slideNavAria': 'التنقل بين الشرائح',
  'fileViewer.speakerNotes': 'ملاحظات المتحدث',
  'fileViewer.speakerNotesSlide': 'الشريحة {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'لا توجد ملاحظات متحدث لهذه الشريحة.',
  'fileViewer.speakerNotesEdit': 'تحرير',
  'fileViewer.speakerNotesSave': 'حفظ الملاحظات',
  'fileViewer.speakerNotesSaving': 'جارٍ الحفظ…',
  'fileViewer.speakerNotesSaved': 'تم الحفظ',
  'fileViewer.speakerNotesSaveFailed': 'تعذر حفظ ملاحظات المتحدث.',
  'fileViewer.speakerNotesPlaceholder': 'أضف ملاحظات المتحدث لهذه الشريحة…',
  'fileViewer.previewAssetBlockedTitle': 'تم حظر أصل المعاينة',
  'fileViewer.previewAssetBlockedDetail': 'تعذر تحميل {filePath}. استبدل الروابط الرمزية الخارجية بملفات داخل هذا المشروع.',
  'fileViewer.presenterReset': 'إعادة ضبط',
  'fileViewer.present': 'تقديم',
  'fileViewer.presentInTab': 'في علامة التبويب هذه',
  'fileViewer.presentFullscreen': 'ملء الشاشة',
  'fileViewer.presentNewTab': 'علامة تبويب جديدة',
  'fileViewer.presentFromBeginning': 'ابدأ من البداية',
  'fileViewer.presentFromCurrentSlide': 'ابدأ من الشريحة الحالية',
  'fileViewer.presenterMode': 'وضع مقدم العرض',
  'fileViewer.exitPresentation': 'الخروج من العرض',
  'fileViewer.shareLabel': 'مشاركة',
  'fileViewer.shareMenuShareLink': 'مشاركة',
  'fileViewer.shareMenuPublishOnline': 'النشر على الإنترنت',
  'fileViewer.shareMenuDownload': 'تنزيل',
  'fileViewer.shareMenuPresentation': 'عرض تقديمي',
  'fileViewer.shareMenuSourceFiles': 'ملفات المصدر',
  'fileViewer.shareMenuSave': 'حفظ',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Publish this file for everyone',
  'fileViewer.publishSingleFileDescription': 'Make the current file externally visible. Anyone with the published link can view it online.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Publishing…',
  'fileViewer.unpublishFile': 'إلغاء النشر',
  'fileViewer.shareEmptyStateTitle': 'لا يوجد شيء للمشاركة بعد',
  'fileViewer.shareEmptyStateDescription': 'أنشئ فريقًا أو انضم إليه لمشاركة هذا الملف مع زملائك',
  'fileViewer.shareEmptyStateCreateTeam': 'إنشاء فريق',
  'fileViewer.shareTeamMissingTitle': 'لا يوجد فريق للمشاركة معه بعد',

  'fileViewer.publishFileRequiresTeam': 'يتطلب نشر رابط عام مساحة عمل جماعية. بدّل إلى مساحة عمل جماعية، أو استخدم النشر لإتاحة هذا الملف.',
  'fileViewer.publishFileRequiresWorkspace': 'يتطلب نشر رابط عام تسجيل الدخول إلى مساحة عمل. سجّل الدخول إلى Open Design Cloud، أو استخدم النشر لإتاحة هذا الملف.',
  'fileViewer.publishFileFailed': 'تعذّر نشر هذا الملف. يُرجى المحاولة مرة أخرى.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'نسخ رابط المشاركة',
  'fileViewer.openSharePage': 'فتح صفحة المشاركة',
  'fileViewer.shareLinkRequiresDeploy': 'انشر على الإنترنت أولاً للحصول على رابط',
  'fileViewer.shareLinkPublishGuide': 'انشر على الإنترنت أعلاه لتفعيل المشاركة ↑',
  'fileViewer.shareAfterGenerationComplete': 'يمكن المشاركة بعد اكتمال الإنشاء',
  'fileViewer.copyProviderLink': 'نسخ رابط {provider}',
  'fileViewer.copyCloudflareLink': 'نسخ رابط Cloudflare',
  'fileViewer.screenshotCopying': 'جارٍ نسخ لقطة الشاشة...',
  'fileViewer.screenshotCopied': 'تم نسخ لقطة الشاشة إلى الحافظة',
  'fileViewer.screenshotClipboardDenied': 'حظر المتصفح الوصول إلى الحافظة',
  'fileViewer.screenshotPreviewLoading': 'لا تزال المعاينة قيد التحميل. حاول مجددًا بعد لحظة.',
  'fileViewer.screenshotCaptureFailed': 'تعذّر التقاط المعاينة. يُرجى المحاولة مرة أخرى.',
  'fileViewer.exportPdf': 'تصدير كـ PDF',
  'fileViewer.exportPdfAllSlides': 'تصدير كـ PDF (كل الشرائح)',
  'fileViewer.exportPptxBusy': 'انتظر انتهاء الدور الحالي.',
  'fileViewer.exportPptxHint': 'أرسل طلباً للوكيل لتحويل هذا التصميم إلى PPTX.',
  'fileViewer.exportPptxNa': 'تصدير PPTX غير متوفر هنا.',
  'fileViewer.exportZip': 'تحميل كـ zip.',
  'fileViewer.exportHtml': 'تصدير كـ HTML مستقل',
  'fileViewer.exportMd': 'تصدير كـ Markdown',
  'fileViewer.exportImage': 'تصدير كصورة',
  'fileViewer.exportPptxImages': 'تصدير كـ PPTX (صور)',
  'fileViewer.exportPptxEditable': 'تصدير كـ PPTX (قابل للتحرير)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'جارٍ التصدير…',
  'fileViewer.exportSlideProgress': 'جارٍ تصدير الشريحة {current}/{total}…',
  'fileViewer.exportingElapsed': 'جارٍ التصدير… {seconds}ث',
  'fileViewer.exportSlideEta': 'الشريحة {current}/{total} · يتبقى ~{seconds}ث',
  'fileViewer.exportFailed': 'فشل التصدير. يرجى المحاولة مرة أخرى.',
  'fileViewer.exportDone': 'اكتمل التصدير',
  'fileViewer.exportImageFailed': 'فشل التقاط الصورة. يرجى المحاولة مرة أخرى أو استخدام أداة لقطة الشاشة في المتصفح.',
  'fileViewer.exportImageModalSubtitle': 'اختر تنسيقًا، ثم نزّل المعاينة الحالية كصورة.',
  'fileViewer.exportImageFormatLabel': 'التنسيق',
  'fileViewer.exportImageSaving': 'جارٍ حفظ الصورة…',
  'fileViewer.exportImageSaved': 'تم حفظ الصورة',
  'fileViewer.exportImageDownloadStarted': 'بدأ التنزيل',
  'fileViewer.exportImageDownloadDetails': 'إذا لم تظهر نافذة حفظ باسم، فابحث عن {filename} في مجلد تنزيلات المتصفح.',
  'fileViewer.exportJsx': 'تصدير كـ JSX',
  'fileViewer.exportReactHtml': 'تصدير المعاينة كـ HTML',
  'fileViewer.exportStarted': 'بدأ التصدير',
  'fileViewer.saveAsTemplate': 'حفظ كقالب...',
  'fileViewer.savingTemplate': 'جاري حفظ القالب...',
  'fileViewer.savedTemplate': 'تم الحفظ باسم "{name}"',
  'fileViewer.savedTemplateFail': 'تعذر حفظ القالب - حاول مرة أخرى.',
  'fileViewer.templateNamePrompt': 'اسم القالب',
  'fileViewer.templateNameDefault': 'قالب بدون عنوان',
  'fileViewer.templateDescPrompt': 'وصف قصير (اختياري - ما الذي يجعل هذا القالب مفيداً؟)',
  'liveArtifact.refresh.button': 'تحديث',
  'liveArtifact.refresh.buttonTitle': 'تحديث هذا العنصر المباشر',
  'liveArtifact.refresh.loadingTitle': 'جارٍ تحميل المُخرَج الحي…',
  'liveArtifact.refresh.noSourceTitle': 'لا يتوفر مصدر تحديث بعد.',
  'liveArtifact.refresh.running': 'جارٍ التحديث…',
  'liveArtifact.refresh.runningMessage': 'جارٍ تحديث البيانات والمعاينة. قد يستغرق ذلك لحظة.',
  'liveArtifact.refresh.runningAction': 'تبقى المعاينة السابقة ظاهرة حتى ينجح التحديث.',
  'liveArtifact.refresh.successOne': 'اكتمل التحديث. تم تحديث البيانات.',
  'liveArtifact.refresh.successMany': 'اكتمل التحديث. تم تحديث البيانات.',
  'liveArtifact.refresh.successAction': 'تمت إعادة تحميل المعاينة بأحدث البيانات المُلتزَم بها.',
  'liveArtifact.refresh.previousFailure': 'فشل التحديث السابق: {message}',
  'liveArtifact.refresh.failureAction': 'راجع سجل التحديثات، وأصلح مشكلة المصدر أو الأذونات، ثم حاول مرة أخرى.',
  'liveArtifact.refresh.networkFailure': 'فشل طلب التحديث. تحقق من اتصالك وحاول مرة أخرى.',
  'liveArtifact.refresh.genericFailure': 'فشل التحديث.',
  'liveArtifact.refresh.statusNever': 'غير قابل للتحديث',
  'liveArtifact.refresh.statusReady': 'جاهز للتحديث',
  'liveArtifact.refresh.statusSucceeded': 'محدَّث',
  'liveArtifact.refresh.statusFailed': 'فشل التحديث',
  'liveArtifact.refresh.statusRunning': 'جارٍ التحديث',
  'liveArtifact.refresh.statusRunningDescription': 'تجري حاليًا عملية تحديث.',
  'liveArtifact.refresh.statusSucceededDescription': 'اكتمل آخر تحديث بنجاح.',
  'liveArtifact.refresh.statusFailedDescription': 'لم تكتمل محاولة التحديث الأخيرة بنجاح.',
  'liveArtifact.refresh.statusReadyDescription': 'المصادر القابلة للتحديث مُهيّأة لكن لا توجد عملية قيد التشغيل.',
  'liveArtifact.refresh.statusNeverDescription': 'لا يحتوي هذا العنصر المباشر على مصدر تحديث بعد.',
  'liveArtifact.refresh.eventStarted': 'بدأ',
  'liveArtifact.refresh.eventSucceeded': 'نجح',
  'liveArtifact.refresh.eventFailed': 'فشل',
  'liveArtifact.refresh.eventStartedDetail': 'بدأ التحديث…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'تم تحديث {n} مصدر',
  'liveArtifact.refresh.sourcesUpdatedMany': 'تم تحديث {n} مصادر',
  'liveArtifact.refresh.timelineEmpty': 'لا يوجد نشاط تحديث بعد في هذه الجلسة. شغّل التحديث لتسجيل مخطط زمني، أو انتظر عمليات التشغيل التلقائية.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'آخر تحديث',
  'liveArtifact.refresh.heroLastRefreshedNever': 'مطلقًا',
  'liveArtifact.refresh.justNow': 'الآن',
  'liveArtifact.refresh.factCreated': 'تم الإنشاء',
  'liveArtifact.refresh.factLastUpdated': 'آخر تحديث',
  'liveArtifact.refresh.factUnknown': 'غير معروف',
  'liveArtifact.refresh.persistedTitle': 'سجل التحديثات المحفوظ',
  'liveArtifact.refresh.persistedHint': 'الإدخالات المُحمَّلة من refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'لا يوجد سجل تحديثات محفوظ بعد.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'نجح',
  'liveArtifact.refresh.persistedStatusRunning': 'قيد التشغيل',
  'liveArtifact.refresh.persistedStatusFailed': 'فشل',
  'liveArtifact.refresh.persistedStatusCancelled': 'أُلغي',
  'liveArtifact.refresh.persistedStatusSkipped': 'تم التخطي',
  'liveArtifact.refresh.sessionTitle': 'نشاط الجلسة',
  'liveArtifact.refresh.sessionHint': 'الأحداث المُلاحَظة أثناء فتح هذا التبويب',
  'liveArtifact.refresh.docSourceTitle': 'مصدر المستند',
  'liveArtifact.refresh.docSourceHint': 'تم تهيئة المصدر',
  'liveArtifact.refresh.docSourceType': 'النوع',
  'liveArtifact.refresh.docSourceTool': 'الأداة',
  'liveArtifact.refresh.docSourceConnector': 'موصِّل',
  'liveArtifact.refresh.debugSummary': 'بيانات تصحيح متقدمة',
  'liveArtifact.refresh.debugNote': 'قد تتضمن معرّفات الموصِّلات وأسماء الملفات وبيانات المصدر الوصفية ومسارات العناصر الداخلية.',
  'liveArtifact.viewer.tabPreview': 'معاينة',
  'liveArtifact.viewer.tabCode': 'الكود',
  'liveArtifact.viewer.tabData': 'البيانات',
  'liveArtifact.viewer.tabRefreshHistory': 'سجل التحديث',
  'liveArtifact.viewer.dataEmpty': 'لا توجد ذاكرة data.json مؤقتة متاحة.',
  'liveArtifact.viewer.code.templateHeading': 'HTML القالب',
  'liveArtifact.viewer.code.renderedHeading': 'HTML المعروض',
  'liveArtifact.viewer.code.templateHelp': 'القالب القابل للتحرير المستخدم مع data.json لإنشاء المعاينة.',
  'liveArtifact.viewer.code.renderedHelp': 'ملف index.html المُنشأ الذي تحمّله المعاينة حاليًا.',
  'liveArtifact.viewer.code.variantAria': 'متغير الكود',
  'liveArtifact.viewer.code.variantTemplate': 'القالب',
  'liveArtifact.viewer.code.variantRendered': 'معروض',
  'liveArtifact.viewer.code.loading': 'جارٍ تحميل الكود…',
  'liveArtifact.viewer.code.unavailable': 'الكود غير متاح بعد.',
  'liveArtifact.viewer.code.empty': 'ملف الكود هذا فارغ.',
  'fileViewer.deployToVercel': 'النشر إلى Vercel',
  'fileViewer.redeployToVercel': 'إعادة النشر',
  'fileViewer.deployingToVercel': 'جارٍ النشر إلى Vercel…',
  'fileViewer.deployProviderLabel': 'منصة النشر',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'الهدف',
  'fileViewer.deployTargetPreview': 'معاينة',
  'fileViewer.deployTargetProduction': 'الإنتاج',
  'fileViewer.deployToProvider': 'النشر إلى {provider}',
  'fileViewer.redeployToProvider': 'إعادة النشر إلى {provider}',
  'fileViewer.deployingToProvider': 'جارٍ النشر إلى {provider}…',
  'fileViewer.preparingPublicLink': 'جاري تحضير الرابط العام...',
  'fileViewer.copyDeployLink': 'نسخ الرابط',
  'fileViewer.deployModalTitle': 'النشر',
  'fileViewer.deployModalSubtitle': 'استخدم حساب منصة النشر المحددة لنشر معاينة HTML هذه.',
  'fileViewer.vercelToken': 'رمز Vercel',
  'fileViewer.vercelTokenGetLink': 'احصل على رمز Vercel',
  'fileViewer.vercelTokenPlaceholder': 'الصق رمز Vercel الخاص بك',
  'fileViewer.vercelTokenReuseHint': 'سيتم استخدام الرمز المحفوظ. أدخل رمزاً جديداً لاستبداله.',
  'fileViewer.vercelTokenRequired': 'أدخل واحفظ رمز Vercel أولاً.',
  'fileViewer.cloudflareApiToken': 'رمز Cloudflare API',
  'fileViewer.cloudflareApiTokenGetLink': 'الحصول على رمز API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'الصق رمز Cloudflare API الخاص بك',
  'fileViewer.cloudflareApiTokenReuseHint': 'سيتم استخدام رمز Cloudflare API المحفوظ. أدخل رمزاً جديداً لاستبداله.',
  'fileViewer.cloudflareApiTokenRequired': 'أدخل واحفظ رمز Cloudflare API أولاً.',
  'fileViewer.cloudflareApiTokenScopeHint': 'اختر Pages Edit عند إنشاء رمز API؛ تحتاج النطاقات المخصصة إلى Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'معرف الفريق',
  'fileViewer.vercelTeamSlug': 'اسم الفريق اللطيف',
  'fileViewer.cloudflareAccountId': 'معرف الحساب',
  'fileViewer.cloudflareAccountIdHint': 'اعثر على معرف الحساب في لوحة Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'أدخل واحفظ Cloudflare Account ID أولاً.',
  'fileViewer.cloudflareZoneLabel': 'النطاق',
  'fileViewer.cloudflareZonePlaceholder': 'احفظ إعدادات Cloudflare لتحميل النطاقات',
  'fileViewer.cloudflareZoneRequired': 'اختر نطاق Cloudflare أولًا.',
  'fileViewer.cloudflareZonesLoading': 'جارٍ تحميل نطاقات Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'تحديث النطاقات',
  'fileViewer.cloudflareZonesLoadFailed': 'تعذّر تحميل نطاقات Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'لم يتم العثور على نطاقات Cloudflare كاملة نشطة لهذا الحساب.',
  'fileViewer.cloudflareDomainPrefixLabel': 'بادئة النطاق الفرعي',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'استخدم تسمية DNS واحدة فقط: أحرف صغيرة وأرقام وشرطات.',
  'fileViewer.cloudflareHostnamePreview': 'معاينة النطاق المخصص: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'اختياري: اربط نطاقاً مخصصاً. تركه فارغاً سيظل ينشئ رابط pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'عنوان pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'نطاق مخصص',
  'fileViewer.optional': 'اختياري',
  'fileViewer.vercelPreviewOnly': 'النشر للمعاينة فقط حالياً.',
  'fileViewer.cloudflarePagesPreviewHint': 'تستخدم Cloudflare Pages أسلوب Direct Upload.',
  'fileViewer.savingConfig': 'جاري الحفظ...',
  'fileViewer.deployConfigSaveFailed': 'تعذر حفظ إعدادات Vercel.',
  'fileViewer.deployFailed': 'فشل النشر. تحقق من إعدادات Vercel وحاول مرة أخرى.',
  'fileViewer.deployProviderConfigSaveFailed': 'تعذر حفظ إعدادات {provider}.',
  'fileViewer.deployProviderFailed': 'فشل النشر إلى {provider}. تحقق من الإعدادات وحاول مرة أخرى.',
  'fileViewer.deployResultLabel': 'رابط النشر',
  'fileViewer.deployLinkReady': 'جاهز',
  'fileViewer.deploySuccessToast': 'تم رفع النشر بنجاح',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'الرابط العام معلق',
  'fileViewer.deployLinkDelayed': 'تم نشر الموقع، لكن الرابط العام ما زال قيد التحضير.',
  'fileViewer.deployLinkFailed': 'فشل النطاق المخصص',
  'fileViewer.deployLinkProtectedLabel': 'حماية النشر مفعلة',
  'fileViewer.deployLinkProtected': 'تم نشر الموقع، لكن رابط المعاينة هذا يتطلب المصادقة. عطّل Deployment Protection أو استخدم نطاقاً مخصصاً.',
  'fileViewer.retryLink': 'إعادة المحاولة الآن',
  'questionForm.submit': 'إرسال',
  'questionForm.skip': 'تخطي',
  'questionForm.locked': 'تمت الإجابة',
  'conv.switch': 'تبديل المحادثة',
  'conv.label': 'المحادثة',
  'conv.heading': 'المحادثات',
  'conv.new': '+ جديد',
  'conv.empty': 'لا توجد محادثات بعد.',
  'conv.untitled': 'محادثة بدون عنوان',
  'conv.renameTooltip': 'انقر مرتين لإعادة التسمية',
  'conv.delete': 'حذف المحادثة',
  'conv.deleteConfirm': 'هل تريد حذف "{title}"؟ سيؤدي هذا لإزالة رسائلها.',
  'agentPicker.label': 'الوكيل',
  'agentPicker.modeChoose': 'اختر وضع التنفيذ',
  'agentPicker.localCli': 'CLI محلي',
  'agentPicker.daemonOff': 'البرنامج الخفي متوقف',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'اختر وكيل كود مكتشف',
  'agentPicker.noAgents': 'لا يوجد وكلاء في PATH',
  'agentPicker.notInstalled': 'غير مثبت',
  'agentPicker.rescan': 'إعادة مسح PATH المحلي للوكلاء',
  'tool.openInTab': 'فتح {name} في علامة تبويب',
  'tool.open': 'فتح',
  'tool.todos': 'المهام',
  'tool.todosExpand': 'عرض المهام',
  'tool.todosCollapse': 'إخفاء المهام',
  'tool.todosDone': 'تم',
  'tool.todosDismiss': 'إغلاق قائمة المهام',
  'tool.write': 'كتابة',
  'tool.edit': 'تعديل',
  'tool.read': 'قراءة',
  'tool.delete': 'حذف',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'جلب',
  'tool.search': 'بحث',
  'tool.lines': '{n} أسطر',
  'tool.changeSingular': 'تغيير',
  'tool.changePlural': 'تغييرات',
  'tool.in': 'في {path}',
  'tool.hide': 'إخفاء',
  'tool.output': 'المخرجات',
  'tool.running': 'جاري التشغيل...',
  'tool.error': 'خطأ',
  'tool.done': 'تم',
  'assistant.role': 'المساعد',
  'assistant.workingLabel': 'جاري العمل',
  'assistant.doneLabel': 'تم',
  'assistant.copyMarkdown': 'نسخ Markdown الرد',
  'assistant.forkConversation': 'تفرع من هنا',
  'assistant.forkingConversation': 'جارٍ التفرع…',
  'assistant.shareToOpenDesign': 'المشاركة على Open Design',
  'assistant.shareToOpenDesignBusy': 'جارٍ تجهيز الحزمة…',
  'assistant.feedbackPrompt': 'ملاحظات',
  'assistant.feedbackPositive': 'مفيد',
  'assistant.feedbackNegative': 'غير مفيد',
  'assistant.feedbackReasonTitle': 'أخبرنا بالسبب',
  'assistant.feedbackReasonPositiveMatched': 'فهم طلبي',
  'assistant.feedbackReasonPositiveVisual': 'يبدو جيدًا',
  'assistant.feedbackReasonPositiveUseful': 'بنية مفيدة',
  'assistant.feedbackReasonPositiveEasy': 'سهل المتابعة في التحرير',
  'assistant.feedbackReasonPositiveDesignSystem': 'اتّبع نظام التصميم',
  'assistant.feedbackReasonNegativeMissed': 'أغفل طلبي',
  'assistant.feedbackReasonNegativeVisual': 'الجودة البصرية تحتاج إلى تحسين',
  'assistant.feedbackReasonNegativeIncomplete': 'مخرجات غير مكتملة',
  'assistant.feedbackReasonNegativeHard': 'صعب الاستخدام',
  'assistant.feedbackReasonNegativeDesignSystem': 'لم يتّبع نظام التصميم',
  'assistant.feedbackReasonOther': 'أخرى',
  'assistant.feedbackReasonPlaceholder': 'أضف ملاحظة قصيرة...',
  'assistant.feedbackReasonSubmit': 'إرسال',
  'assistant.emptyResponseLabel': 'لا توجد مخرجات',
  'assistant.emptyResponseMessage': 'أنهى المزوّد الطلب دون إرجاع نص أو عنصر. جرّب نموذجًا أو مزوّدًا آخر، أو تحقّق من الحصة، أو أعد المحاولة.',
  'assistant.unfinishedLabel': 'توقف مع عمل غير مكتمل',
  'assistant.unfinishedSummary': 'تبقى {n} مهمة/مهام',
  'assistant.unfinishedMore': '+{n} أكثر',
  'assistant.continueRemaining': 'متابعة المهام المتبقية',
  'chat.resumeRunCta': 'متابعة التشغيل',
  'assistant.outTokens': '{n} خرج',
  'assistant.producedFiles': 'الملفات من هذا الدور',
  'assistant.openFile': 'فتح',
  'assistant.downloadFile': 'تحميل',
  'nextStep.title': 'الخطوة التالية',
  'nextStep.more': 'المزيد',
  'nextStep.share': 'مشاركة',
  'nextStep.download': 'تنزيل',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'المساهمة',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'جارٍ إنشاء التصميم...',
  'assistant.thinking': 'تفكير',
  'assistant.thought': 'فكّر',
  'assistant.thoughtFor': 'فكّر لمدة {s} ث',
  'assistant.systemReminder': 'تذكير النظام',
  'assistant.possiblePromptInjection': 'احتمال حقن التوجيه',
  'assistant.waitingFirstOutput': 'في انتظار أول مخرج',
  'assistant.statusBootingAgent': 'تشغيل الوكيل',
  'assistant.statusPreparing': 'جارٍ التحضير...',
  'assistant.statusStarting': 'بدء',
  'assistant.statusRequesting': 'إرسال الطلب',
  'assistant.statusThinking': 'تفكير',
  'assistant.statusStreaming': 'تدفق',
  'assistant.slowHint': 'يستغرق وقتاً أطول من المعتاد. يظهر النموذج عادة في 5-10 ثوانٍ - يمكنك التوقف وإعادة الصياغة.',
  'assistant.verbEditing': 'تعديل',
  'assistant.verbWriting': 'كتابة',
  'assistant.verbReading': 'قراءة',
  'assistant.verbSearching': 'بحث',
  'assistant.verbRunning': 'تشغيل',
  'assistant.verbTodos': 'مهام',
  'assistant.verbFetching': 'جلب',
  'assistant.verbCalling': 'اتصال',
  'qf.answered': 'تمت الإجابة',
  'qf.choose': 'اختر...',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'أخرى',
  'qf.required': 'مطلوب',
  'qf.lockedSubmitted': 'تم إرسال الإجابات - يستخدمها الوكيل لبقية الجلسة.',
  'qf.lockedPrev': 'هذا النموذج من دور سابق.',
  'qf.hint': 'اختر ما يناسبك. تخطى الحقول الاختيارية التي لا تهمك - سيستخدم الوكيل افتراضات معقولة.',
  'qf.submitDefault': 'إرسال الإجابات',
  'qf.submitDisabledTitle': 'املأ الحقول المطلوبة أولاً',
  'qf.submitTitle': 'إرسال الإجابات',
  'qf.cardSelected': 'محدد',
  'qf.cardRefs': 'المراجع:',
  'qf.cardSampleText': 'الثعلب البني السريع · 0123',
  'questions.tabLabel': 'أسئلة',
  'questions.banner': 'هل تمانع أن أطرح عليك بضعة أسئلة سريعة؟',
  'questions.bannerAnswered': 'تمت الإجابة عن الأسئلة',
  'questions.continue': 'متابعة',
  'questions.generating': 'جارٍ إنشاء الأسئلة…',
  'questions.skipAll': 'تخطّي الكل',
  'questions.autoSkipHint': 'يتابع تلقائيًا عند انتهاء المؤقّت',
  'questions.submitting': 'جارٍ الإرسال…',
  'sketch.toolSelect': 'تحديد (لا إجراء)',
  'sketch.toolPen': 'قلم',
  'sketch.toolText': 'نص',
  'sketch.toolRect': 'مستطيل',
  'sketch.toolArrow': 'سهم',
  'sketch.toolEraser': 'ممحاة',
  'sketch.color': 'اللون',
  'sketch.strokeSize': 'حجم الخط',
  'sketch.undo': 'تراجع',
  'sketch.clear': 'مسح',
  'sketch.close': 'إغلاق',
  'sketch.closeConfirm': 'إغلاق الرسم وتجاهل التغييرات غير المحفوظة؟',
  'sketch.textPrompt': 'النص:',
  'sketch.textModalTitle': 'إضافة نص',
  'critiqueTheater.userFacingName': 'لجنة تحكيم التصميم',
  'critiqueTheater.roleDesigner': 'المصمّم',
  'critiqueTheater.roleCritic': 'الناقد',
  'critiqueTheater.roleBrand': 'العلامة التجارية',
  'critiqueTheater.roleA11y': 'إمكانية الوصول',
  'critiqueTheater.roleCopy': 'النص',
  'critiqueTheater.roundLabel': 'الجولة {n} من {m}',
  'critiqueTheater.mustFix': '{n} يجب إصلاحها',
  'critiqueTheater.composite': 'مركّب',
  'critiqueTheater.threshold': 'العتبة',
  'critiqueTheater.consensus': 'الإجماع',
  'critiqueTheater.interrupt': 'مقاطعة',
  'critiqueTheater.interrupting': 'جارٍ المقاطعة…',
  'critiqueTheater.interrupted': 'تمّت المقاطعة',
  'critiqueTheater.degradedHeading': 'اللجنة غير متصلة في هذه الجلسة',
  'critiqueTheater.degradedReasonMalformed': 'مخرجات اللجنة غير صحيحة (رفض المحلّل الكتلة).',
  'critiqueTheater.degradedReasonOversize': 'تجاوزت مخرجات اللجنة الحدّ الآمن من البايتات.',
  'critiqueTheater.degradedReasonAdapter': 'المحوّل {adapter} لا يدعم بروتوكول Critique.',
  'critiqueTheater.degradedReasonProtocol': 'أرسل المحوّل {adapter} إصدار بروتوكول غير مدعوم.',
  'critiqueTheater.degradedReasonMissingArtifact': 'انتهت الجلسة دون عنصر نهائي.',
  'critiqueTheater.replay': 'إعادة التشغيل',
  'critiqueTheater.replaySpeed': 'سرعة إعادة التشغيل',
  'critiqueTheater.readOnly': 'للقراءة فقط',
  'critiqueTheater.shippedSummary': 'تم الإطلاق في الجولة {round} · النتيجة المركبة {composite}',
  'critiqueTheater.interruptedSummary': 'تمت المقاطعة في الجولة {round} · أفضل نتيجة مركبة {composite}',
  'critiqueTheater.shippedBadge': 'تم الإطلاق',
  'critiqueTheater.belowThresholdBadge': 'دون العتبة',
  'critiqueTheater.timedOutBadge': 'انتهت المهلة',
  'critiqueTheater.failedHeading': 'فشلت الجلسة',
  'critiqueTheater.failedReasonCliExit': 'خرج Agent CLI برمز غير صفري قبل أن تتمكّن اللجنة من الإنهاء.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'تجاوزت إحدى الجولات حدّها الزمني.',
  'critiqueTheater.failedReasonTotalTimeout': 'تجاوزت الجلسة الكاملة إجمالي حدّها الزمني.',
  'critiqueTheater.failedReasonOrchestrator': 'خطأ داخلي في المنسّق.',
  'critiqueTheater.transcriptEmpty': 'لا يوجد نص محادثة لإعادة تشغيله بعد. شغّل نقدًا لتسجيل واحد.',
  'critiqueTheater.transcriptLoading': 'جارٍ تحميل النص…',
  'critiqueTheater.transcriptError': 'تعذّر تحميل نص المحادثة: {error}',
  'critiqueTheater.replaySpeedPaused': 'متوقّف مؤقتًا',
  'critiqueTheater.replaySpeedInstant': 'فوري',
  'critiqueTheater.replaySpeedLive': 'مباشر',
  'critiqueTheater.replaySpeedFast': 'سريع',
  'critiqueTheater.settingsNav': 'لجنة تحكيم التصميم',
  'critiqueTheater.settingsNavHint': 'مراجعة تصميم بخمس لوحات لعمليات التشغيل الخاصة بك',
  'critiqueTheater.settingsEnabledLabel': 'إظهار لجنة تحكيم التصميم أثناء تشغيل الـ Agent',
  'critiqueTheater.settingsEnabledDescription': 'عند التفعيل، تظهر مراجعة بخمس لوحات بجانب مخرجات الـ Agent وتقيّم الناتج قبل التسليم. يمكنك المقاطعة في أي وقت.',
  'critiqueTheater.settingsEnabledProjectHint': 'تم الحفظ لهذا المشروع. ستمر عمليات التشغيل الجديدة في هذا المشروع عبر لجنة تحكيم التصميم من جانب الخادم.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'افتح مشروعًا للحفظ من جانب الخادم. حتى ذلك الحين، يغيّر هذا فقط التفضيل داخل المتصفح.',
  'pet.title': 'الحيوانات الأليفة',
  'pet.subtitle': 'تبنَّ رفيقاً صغيراً يطفو فوق مساحة عملك.',
  'pet.navTitle': 'الحيوانات الأليفة',
  'pet.navHint': 'تبنَّ أو خصص',
  'pet.tabBuiltIn': 'مدمج',
  'pet.tabBuiltInHint': 'رفقاء منتقون مدمجون مع Open Design - اختر واحداً وتبنَّه.',
  'pet.builtInEmpty': 'الحيوانات الأليفة المدمجة غير متوفرة حالياً. حاول تحديث تبويب المجتمع بمجرد اتصال البرنامج الخفي.',
  'pet.tabCustom': 'مخصص',
  'pet.tabCustomHint': 'اصنع خاصتك باسم، رمز، لون أو صورة.',
  'pet.tabCommunity': 'المجتمع',
  'pet.tabCommunityHint': 'حيوانات مفقوسة من Codex - تبنَّ واحداً أو ولد واحداً جديداً.',
  'pet.tabsAria': 'مصدر الحيوان الأليف',
  'pet.adopt': 'تبنَّ',
  'pet.adoptedBadge': 'تم التبني',
  'pet.adoptCallout': 'تبنَّ حيواناً أليفاً',
  'pet.changePet': 'تغيير الحيوان الأليف',
  'pet.wake': 'إيقاظ',
  'pet.tuck': 'إخفاء',
  'pet.wakeTitle': 'إيقاظ الحيوان الأليف - إظهار الطبقة العائمة.',
  'pet.tuckTitle': 'إخفاء الحيوان الأليف - إخفاء الطبقة العائمة.',
  'pet.settingsTitle': 'فتح إعدادات الحيوان الأليف',
  'pet.useCustom': 'استخدم حيواني',
  'pet.customTitle': 'اصنع خاصتك',
  'pet.customHint': 'اختر اسماً، رمزاً ولوناً - الطبقة تتحدث مباشرة.',
  'pet.customGreetingPlaceholder': 'قل مرحباً من حيوانك الأليف...',
  'pet.fieldName': 'الاسم',
  'pet.fieldGlyph': 'الرمز',
  'pet.fieldGlyphHint': 'إيموجي واحد يعمل بشكل أفضل (مثلاً: 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'التحية',
  'pet.fieldAccent': 'لون التمييز',
  'pet.fieldAccentCustom': 'لون مخصص',
  'pet.fieldAccentDefault': 'لون التمييز الافتراضي',
  'pet.overlayAria': 'رفيق الحيوان الأليف',
  'pet.spriteAria': '{name} - اسحب للتحريك، اضغط للدردشة',
  'pet.spriteTitle': 'مرحباً من {name}! اضغط للدردشة.',
  'pet.taskSummarySingle': 'تعمل {count} مهمة Agent.',
  'pet.taskSummaryMultiple': 'تعمل {count} مهام Agent عبر {projects} مشاريع.',
  'pet.taskSummaryRecentSingle': 'اكتملت مؤخرًا {count} مهمة Agent.',
  'pet.taskSummaryRecentMultiple': 'اكتملت مؤخرًا {count} مهام Agent.',
  'pet.taskListAria': 'مهام Agent النشطة',
  'pet.taskOpenProject': 'فتح {project}',
  'pet.taskGroup.running': 'قيد التشغيل',
  'pet.taskGroup.queued': 'في الانتظار',
  'pet.taskGroup.recent': 'اكتملت مؤخرًا',
  'pet.idleQuote.leonardo.text': 'التعلّم لا يُنهك العقل أبدًا.',
  'pet.idleQuote.leonardo.author': 'ليوناردو دافنشي',
  'pet.idleQuote.michelangelo.text': 'رأيتُ الملاك في الرخام ونحتُّ حتى حررتُه.',
  'pet.idleQuote.michelangelo.author': 'مايكل أنجلو',
  'pet.idleQuote.bernini.text': 'هناك أداتان يمكن أن تساعدا النحّات: الضوء والظل.',
  'pet.idleQuote.bernini.author': 'جان لورينزو برنيني',
  'pet.idleQuote.raphael.text': 'حين يرسم المرء فإنه لا يفكّر.',
  'pet.idleQuote.raphael.author': 'رفائيل',
  'pet.idleQuote.caravaggio.text': 'كل الأعمال، أيًّا كانت أو مهما كان من رسمها، ليست سوى تفاهات وأمور صبيانية ما لم تُصنع وتُرسم من الواقع.',
  'pet.idleQuote.caravaggio.author': 'كارافاجيو',
  'pet.idleQuote.rodin.text': 'الأهم هو أن تتأثّر، أن تحبّ، أن تأمل، أن ترتجف، أن تحيا.',
  'pet.idleQuote.rodin.author': 'أوغست رودان',
  'pet.composerTitle': 'الحيوانات الأليفة - إيقاظ، إخفاء، أو اختيار واحد',
  'pet.composerMenuTitle': 'الحيوانات الأليفة',
  'pet.composerMenuHint': 'تلميح: اكتب /pet للتبديل',
  'pet.composerOpenSettings': 'إدارة الحيوانات الأليفة',
  'pet.welcomeTeaserTitle': 'تبنَّ حيواناً أليفاً',
  'pet.welcomeTeaserBody': 'رفيق عائم صغير يقضي الوقت معك.',
  'pet.welcomeTeaserCta': 'اختر واحداً',
  'pet.imageUpload': 'رفع صورة',
  'pet.imageReplace': 'استبدال الصورة',
  'pet.imageRemove': 'استخدام إيموجي',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF أو SVG. رفع ورقة؟ أسقط شريطاً أفقياً وحدد عدد الإطارات.',
  'pet.imageHintActive': 'عرض صورتك. حدد الإطارات > 1 للمشي في ورقة صور أفقية.',
  'pet.fieldFrames': 'الإطارات',
  'pet.fieldFramesHint': '1 = ثابت. > 1 = ورقة صور أفقية.',
  'pet.fieldFps': 'السرعة (fps)',
  'pet.fieldFpsHint': 'مدى سرعة تدوير الإطارات.',
  'pet.atlasImport': 'استيراد صورة Codex',
  'pet.atlasImportTitle': 'استيراد أطلس حيوان مفقوس 8x9 / 192x208 (PNG أو WebP).',
  'pet.atlasPickerTitle': 'اختر صف رسوم متحركة',
  'pet.atlasPickerHint': 'حيوانات Codex تأتي بـ 9 صفوف رسوم متحركة. افتراضياً نحتفظ بالأطلس الكامل ليغير الحيوان الصفوف عند التحويم، السحب، والسكون. يمكنك أيضاً تجميده في حلقة واحدة.',
  'pet.atlasCancel': 'تجاهل الأطلس',
  'pet.atlasAdopt': 'تجميد في هذا الصف',
  'pet.atlasAdoptFull': 'استخدام الأطلس الكامل (متحرك)',
  'pet.atlasAdoptFullTitle': 'الاحتفاظ بكل الصفوف ليتفاعل الحيوان مع التحويم، اتجاه السحب، والسكون الطويل.',
  'pet.atlasAdoptRowTitle': 'قص الصف المظلل فقط في شريط متكرر واحد.',
  'pet.atlasActiveHint': 'الأطلس المتحرك نشط - يختار الحيوان صفاً من تفاعلك (تحويم، سحب، سكون).',
  'pet.atlasRow.idle': 'ساكن',
  'pet.atlasRow.running-right': 'جري يميناً',
  'pet.atlasRow.running-left': 'جري يساراً',
  'pet.atlasRow.waving': 'تلويح',
  'pet.atlasRow.jumping': 'قفز',
  'pet.atlasRow.failed': 'فشل',
  'pet.atlasRow.waiting': 'انتظار',
  'pet.atlasRow.running': 'جري',
  'pet.atlasRow.review': 'مراجعة',
  'pet.hatchTitle': 'فقس حيوان جديد بالذكاء الاصطناعي',
  'pet.hatchHint': 'استخدم مهارة hatch-pet في الدردشة لتوليد ورقة صور بأسلوب Codex، ثم استوردها هنا.',
  'pet.hatchConcept': 'مفهوم الحيوان (اختياري)',
  'pet.hatchConceptPlaceholder': 'مثلاً: شيبا بيكسل-آرت صغير في سترة مريحة',
  'pet.hatchCopy': 'نسخ الأمر',
  'pet.hatchCopied': 'تم النسخ!',
  'pet.hatchFoot': 'بعد أن يحفظ المساعد حيوانك، عد إلى هنا واختر "استيراد صورة Codex".',
  'pet.slashPopoverAria': 'أوامر Slash',
  'pet.slashPopoverTitle': 'الأوامر',
  'pet.slashPopoverHint': '↑↓ للتنقل · enter للاختيار · esc للتجاهل',
  'pet.slashPet': 'تبديل، تبني، أو الانتقال لإعدادات الحيوانات الأليفة.',
  'pet.slashPetWake': 'إيقاظ طبقة الحيوان الأليف العائمة.',
  'pet.slashPetTuck': 'إخفاء الحيوان الأليف حالياً.',
  'pet.slashHatch': 'توليد حيوان Codex عبر مهارة hatch-pet.',
  'pet.slashHatchArg': '<مفهوم>',
  'pet.slashSearch': 'ابحث في الويب عبر أمر OD research.',
  'pet.slashSearchArg': '<استعلام>',
  'pet.codexTitle': 'فقس مؤخراً',
  'pet.codexSubtitle': 'الحيوانات التي تمت تعبئتها بواسطة مهارة hatch-pet تظهر هنا للتبني بنقرة واحدة.',
  'pet.codexSubtitleWithDir': 'مسح {dir} للبحث عن حيوانات معبأة بواسطة مهارة hatch-pet.',
  'pet.codexEmpty': 'لا توجد حيوانات مفقوسة بعد. اكتب /hatch في الدردشة لتوليد واحد.',
  'pet.codexLoading': 'البحث عن حيوانات مفقوسة...',
  'pet.codexRefresh': 'تحديث',
  'pet.codexAdopt': 'تبنَّ',
  'pet.codexAdopting': 'جاري التبني...',
  'pet.communitySync': 'تحميل حيوانات المجتمع',
  'pet.communitySyncing': 'جاري التحميل...',
  'pet.communitySyncTitle': 'مزامنة أحدث الحيوانات من Codex Pet Share + j20 Hatchery إلى ~/.codex/pets/.',
  'pet.communitySyncDone': 'تمت مزامنة {wrote} حيواناً جديداً ({total} إجمالي).',
  'pet.communitySyncFailed': 'فشلت المزامنة: {error}',
  'pet.codexBundled': 'مدمج',
  'pet.codexBundledTitle': 'يأتي مع Open Design - لا حاجة للتحميل.',
  'settings.systemPrefsTitle': 'تفضيلات النظام',
  'settings.systemPrefsHint': 'صوت الإكمال وإشعارات المتصفح وتنبيهات حالة المهام.',
  'settings.notifications': 'الإشعارات',
  'settings.notificationsHint': 'صوت وإشعار سطح المكتب عند اكتمال المهمة',
  'settings.notifyCompletionSound': 'صوت الاكتمال',
  'settings.notifyCompletionSoundHint': 'يُشغَّل عند انتهاء الجولة. متوقف افتراضيًا.',
  'settings.notifySuccessSound': 'صوت النجاح',
  'settings.notifyFailureSound': 'صوت الفشل',
  'settings.notifyDesktop': 'إشعار سطح المكتب',
  'settings.notifyDesktopHint': 'يُرسَل عندما لا تكون النافذة في المقدمة.',
  'settings.notifyDesktopBlocked': 'تم حظر الإشعارات من المتصفح. اسمح بها من إعدادات الموقع.',
  'settings.notifyDesktopUnsupported': 'إشعارات سطح المكتب غير متاحة في هذه البيئة.',
  'settings.notifyTest': 'إرسال اختبار',
  'settings.notifyTestSent': 'تم إرسال إشعار الاختبار. إذا لم تظهر نافذة، فتحقق من إعدادات إشعارات المتصفح والنظام.',
  'settings.notifyTestFailed': 'فشل استدعاء الإشعار. تحقق من إعدادات إشعارات المتصفح والنظام.',
  'settings.notifySoundDing': 'دينج',
  'settings.notifySoundChime': 'جرس',
  'settings.notifySoundTwoToneUp': 'نغمتان صاعدتان',
  'settings.notifySoundPluck': 'نقرة وتر',
  'settings.notifySoundBuzz': 'طنين',
  'settings.notifySoundTwoToneDown': 'نغمتان هابطتان',
  'settings.notifySoundThud': 'دمدمة',
  'settings.skills': 'المهارات',
  'settings.skillsHint': 'المهارات الوظيفية التي يمكن للوكيل استدعاؤها أثناء المهمة',
  'settings.skillsNew': 'مهارة جديدة',
  'settings.skillsEmpty': 'حدد مهارة من اليسار أو أنشئ مهارة جديدة.',
  'settings.skillsEdit': 'تحرير',
  'settings.skillsDelete': 'حذف',
  'settings.skillsDeleteConfirm': 'تأكيد الحذف',
  'settings.skillsName': 'الاسم',
  'settings.skillsTriggers': 'محفزات (مفصولة بفواصل أو أسطر جديدة)',
  'settings.skillsDescription': 'الوصف',
  'settings.skillsBody': 'محتوى SKILL.md',
  'settings.skillsCreate': 'إنشاء',
  'settings.skillsSave': 'حفظ',
  'settings.skillsSaving': 'جاري الحفظ…',
  'settings.skillsOverrideCreate': 'إنشاء تجاوز المستخدم',
  'settings.skillsOverrideSave': 'حفظ كتجاوز المستخدم',
  'settings.skillsBuiltInOverrideWarning': 'يؤدي تعديل هذه المهارة المدمجة إلى إنشاء تجاوز خاص بالمستخدم. سيتم إخفاء العنصر المدمج من القائمة حتى تحذف التجاوز. هل تريد المتابعة؟',
  'settings.skillsFiles': 'الملفات',
  'settings.skillsNoFiles': 'لا توجد ملفات في مجلد هذه المهارة.',
  'settings.skillsNameRequired': 'اسم المهارة مطلوب.',
  'settings.skillsBodyRequired': 'محتوى المهارة مطلوب.',
  'settings.designSystems': 'أنظمة التصميم',
  'settings.designSystemsHint': 'تصفح وتفعيل أنظمة التصميم المتاحة للوكيل',
  'settings.designSystemsInstalled': 'مثبّتة',
  'settings.designSystemsAdd': 'إضافة نظام تصميم',
  'settings.designSystemsHiddenCount': '{count} مخفية من معرض الصفحة الرئيسية',
  'settings.designSystemsShowAll': 'عرض الكل',
  'settings.designSystemsShowHidden': 'عرض المخفية',
  'settings.designSystemsSource': 'المصدر',
  'settings.designSystemsSourceLocal': 'محلي',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'مرجع سجل shadcn',
  'settings.designSystemsImportShadcn': 'استيراد من shadcn',
  'settings.designSystemsStructure': 'البنية',
  'settings.designSystemsModeHybrid': 'مختلط',
  'settings.designSystemsModeNormalized': 'مطبّع',
  'settings.designSystemsModeVerbatim': 'كما هو',
  'settings.designSystemsCraft': 'الحِرفة',
  'settings.designSystemsCraftColor': 'اللون',
  'settings.designSystemsCraftAccessibility': 'إمكانية الوصول',
  'settings.designSystemsGithubUrl': 'رابط GitHub',
  'settings.designSystemsProjectPath': 'مسار المشروع',
  'settings.designSystemsImportGithub': 'استيراد من GitHub',
  'settings.designSystemsImportProject': 'استيراد من المشروع',
  'settings.designSystemsImportedStatus': 'تم استيراد {title}',
  'settings.designSystemsViewImported': 'عرض نظام التصميم المستورد',
  'settings.designSystemsCategory': 'الفئة',
  'settings.designSystemsAllCategories': 'كل الفئات',
  'settings.designSystemsShowInHomeGallery': 'إظهار في معرض الصفحة الرئيسية',
  'settings.projectLocations': 'مواقع المشاريع',
  'settings.projectLocationsHint': 'جذور تخزين مساحات العمل',
  'settings.projectLocationsDescription': 'أضف قواعد عمل يمكن أن تحتوي على عدة مجلدات مشاريع Open Design. تُحفظ المشاريع الجديدة كمجلد داخل القاعدة المحددة.',
  'settings.projectLocationsSaveError': 'تعذّر حفظ مواقع المشاريع. تحقق من أن كل مسار مجلد يمكن الوصول إليه.',
  'settings.projectLocationsSaved': 'تم حفظ مواقع المشاريع.',
  'settings.projectLocationsScanError': 'تعذّر فحص مواقع المشاريع.',
  'settings.projectLocationsScanComplete': 'اكتمل الفحص: تم استيراد {imported}، و{existing} مسجلة مسبقًا.',
  'settings.projectLocationsNoFolderSelected': 'لم يتم اختيار مجلد.',
  'settings.projectLocationsDuplicate': 'تمت إضافة قاعدة العمل هذه بالفعل.',
  'settings.projectLocationsWorkBaseMeta': 'قاعدة عمل · يتم إنشاء المشاريع هنا كمجلدات فرعية',
  'settings.projectLocationsAddFolder': 'إضافة مجلد…',
  'settings.projectLocationsDefaultBadge': 'الموقع الافتراضي',
  'settings.projectLocationsMakeDefault': 'تعيين كافتراضي',
  'settings.projectLocationsDefaultSaved': 'تم تحديث موقع المشروع الافتراضي.',
  'settings.librarySkills': 'المهارات',
  'settings.libraryDesignSystems': 'أنظمة التصميم',
  'settings.librarySearch': 'بحث...',
  'settings.libraryAll': 'الكل',
  'settings.libraryPreview': 'معاينة',
  'settings.libraryPreviewClose': 'إغلاق',
  'settings.libraryLoading': 'جارٍ التحميل...',
  'settings.libraryNoResults': 'لا توجد عناصر تطابق بحثك.',
  'settings.libraryEnabled': 'مفعّل',
  'settings.libraryDisabled': 'معطّل',
  'settings.connectorsNavHint': 'اتصالات الأنظمة الخارجية',
  'settings.connectorsHint': 'إدارة إعدادات الموصّلات ومزوّدي الأدوات لهذا الجهاز.',
  'settings.connectorsComposioApiKey': 'مفتاح API لـ Composio',
  'settings.connectorsSavedTitle': 'محفوظ في daemon المحلي',
  'settings.connectorsSavedWithTail': 'محفوظ · ••••{tail}',
  'settings.connectorsSaved': 'محفوظ',
  'settings.connectorsGetApiKey': 'الحصول على مفتاح API',
  'settings.connectorsReplaceKeyPlaceholder': 'الصق مفتاحًا جديدًا لاستبدال المحفوظ',
  'settings.connectorsApiKeyPlaceholder': 'الصق مفتاح API لـ Composio',
  'settings.connectorsClear': 'مسح',
  'settings.connectorsClearConfirmTitle': 'مسح مفتاح Composio API المحفوظ؟',
  'settings.connectorsClearConfirmBody': 'إزالة المفتاح ستفصل جميع موصلات Composio المرتبطة بمساحة العمل هذه. سيُحذف كل من الحسابات المتصلة وأذونات OAuth والوصول إلى الأدوات.',
  'settings.connectorsClearConfirmContinue': 'متابعة',
  'settings.connectorsClearFinalTitle': 'سيؤدي هذا إلى فصل جميع الموصلات',
  'settings.connectorsClearFinalBody': 'لا يمكن التراجع عن هذا الإجراء. ستحتاج إلى إعادة ربط كل تكامل من البداية بعد لصق مفتاح جديد.',
  'settings.connectorsClearFinalConfirm': 'حذف المفتاح وفصل التكاملات',
  'settings.connectorsClearArming': 'لحظة…',
  'settings.connectorsClearCancel': 'إلغاء',
  'settings.connectorsSaveKey': 'حفظ المفتاح',
  'settings.connectorsSaveKeyTitle': 'إرسال هذا المفتاح إلى الـ daemon المحلي',
  'settings.connectorsKeySaving': 'جارٍ الحفظ…',
  'settings.connectorsKeySaved': 'تم الحفظ ✓',
  'settings.connectorsKeyError': 'تعذّر حفظ المفتاح. تأكد أن الـ daemon المحلي يعمل ثم حاول مرة أخرى.',
  'settings.connectorsHelpSaved': 'يفتح مفتاحك الكتالوج أدناه ويبقى في daemon المحلي. الصق مفتاحًا جديدًا لاستبداله أو امسحه لإزالته.',
  'settings.connectorsHelpUnsaved': 'تغييرات غير محفوظة — اضغط على "حفظ المفتاح" لتخزين بيانات الاعتماد في الـ daemon المحلي وفتح الكتالوج أدناه.',
  'settings.connectorsHelpEmpty': 'أضف مفتاحًا لفتح الكتالوج أدناه. تُخزّن المفاتيح محليًا في daemon ولا تُرسل أبدًا عبر متغيرات البيئة.',
  'settings.connectorsLoadingSavedKey': 'جارٍ التحقق من مفتاح محفوظ في daemon المحلي…',
  'settings.autosaveSaving': 'جارٍ الحفظ…',
  'settings.autosaveSaved': 'تم حفظ جميع التغييرات',
  'settings.autosaveError': 'تعذّر حفظ التغييرات. قد يكون الـ daemon المحلي غير متاح.',
  'settings.libraryToggleLabel': 'تبديل',
  'settings.memory': 'الذاكرة',
  'settings.memoryHint': 'الحقائق والسياق المحفوظة للمحادثات المستقبلية',
  'settings.customInstructionsTitle': 'القواعد العامة',
  'settings.customInstructionsHint': 'تعليمات ثابتة يجب أن يتبعها OpenDesign في كل محادثة. احفظ الحقائق والتفضيلات وسياق المشروع كذكريات.',
  'settings.customInstructionsPlaceholder': 'مثال: "استخدم TypeScript دائمًا. فضّل المكوّنات الوظيفية. اجعل الردود موجزة."',
  'settings.memoryDescription': 'تحكّم في ما إذا كان سيُعاد استخدام الحقائق والتفضيلات وسياق المشروع المحفوظة في المحادثات المستقبلية.',
  'settings.memoryEnabled': 'مُفعّل',
  'settings.memoryDisabled': 'مُعطّل',
  'settings.memoryEnableLabel': 'تفعيل إدراج الذاكرة',
  'settings.memoryDisabledBanner': 'الذاكرة مُعطّلة حاليًا. تُحفظ الحقائق الموجودة على القرص لكنها لن تُدمج في المحادثات الجديدة، ولن تستخرج الأدوار الجديدة أي شيء جديد.',
  'settings.memoryNew': 'ذاكرة جديدة',
  'settings.memoryEdit': 'تعديل',
  'settings.memoryDelete': 'حذف',
  'settings.memoryPreview': 'معاينة',
  'settings.memoryEmpty': 'لا توجد ذاكرة بعد.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'أفضّل الوضع الداكن',
  'settings.memoryName': 'مثال: تفضيلات الواجهة',
  'settings.memoryDesc': 'جملة واحدة — ما موضوع هذه الذاكرة؟',
  'settings.memoryBody': '- القاعدة الأولى\n- القاعدة الثانية\n\nالسبب: سبب اختياري\nمتى تُطبَّق: نطاق اختياري',
  'settings.memoryBodyHint': 'اكتب القواعد كنقاط أولًا، ثم أضِف سطري السبب ومتى تُطبَّق اختياريًا. يدعم Markdown. أو انقر على مثال بدء أعلاه لتحميل مثال عملي.',
  'settings.memoryStartersLabel': 'تحتاج إلى نقطة بداية؟ انقر لملء النموذج:',
  'settings.memoryStarterUserName': 'دوري',
  'settings.memoryStarterUserDesc': 'أنا مهندس واجهات أمامية أعمل على أداة تصميم SaaS',
  'settings.memoryStarterUserBody': '- الدور: مهندس واجهات أمامية أول\n- التقنيات: React، TypeScript، Vite\n- المجال: أدوات التصميم / التعاون\n- المنطقة الزمنية: GMT+8 (آسيا/شنغهاي)\n\nمتى يُطبَّق: في أي محادثة — اجعل الأمثلة متمحورة حول واجهات الويب الأمامية.',
  'settings.memoryStarterFeedbackName': 'تفضيلات الواجهة',
  'settings.memoryStarterFeedbackDesc': 'الوضع الداكن، نص أساسي كبير، كثافة معلومات منخفضة',
  'settings.memoryStarterFeedbackBody': '- السمة: داكنة افتراضيًا\n- نص المحتوى: ≥ 18px\n- كثافة المعلومات: تفضيل المساحات البيضاء، عناصر أقل لكل شاشة\n\nالسبب: إجهاد أقل للعين أثناء الجلسات الطويلة.\nمتى يُطبَّق: كلما أنشأت واجهة مستخدم أو صفحات ويب أو شرائح عرض.',
  'settings.memoryStarterProjectName': 'المشروع الحالي',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — محرر تصميم يعمل بالمحادثة',
  'settings.memoryStarterProjectBody': '- الهدف: إطلاق المحرر القائم على المحادثة هذا الربع\n- الأولويات: التصيير المتدفق، الوسائط المتعددة المحلية، الأولوية لوضع عدم الاتصال\n- المنصة التقنية: Next.js 16، خادم Express، SQLite\n\nمتى يُطبّق: في أي محادثة حول هذا المشروع.',
  'settings.memorySaveHint': 'لا يُحفَظ تلقائيًا — انقر إنشاء / حفظ للتطبيق.',
  'settings.memoryIndexSaveHint': 'لا تُحفَظ التعديلات على الفهرس تلقائيًا — انقر حفظ الفهرس للتطبيق.',
  'settings.memoryIndexUnsaved': 'تغييرات غير محفوظة',
  'settings.memoryFlashCreated': '✓ تم إنشاء الذاكرة',
  'settings.memoryFlashSaved': '✓ تم حفظ الذاكرة',
  'settings.memoryFlashDeleted': '✓ تم حذف الذاكرة',
  'settings.memoryFlashIndexSaved': '✓ تم حفظ الفهرس',
  'settings.memoryFlashPathCopied': '✓ تم نسخ المسار',
  'settings.memoryNameLabel': 'العنوان',
  'settings.memoryTypeLabel': 'النوع',
  'settings.memoryDescLabel': 'الوصف',
  'settings.memoryBodyLabel': 'المحتوى',
  'settings.memoryTypeUser': 'المستخدم',
  'settings.memoryTypeFeedback': 'الملاحظات',
  'settings.memoryTypeProject': 'المشروع',
  'settings.memoryTypeReference': 'مرجع',
  'artifact.odCardTaskBriefChip': 'تم تطبيق الذاكرة · عرض الموجز',
  'artifact.odCardScorecardTitle': 'فحص ذاتي',
  'artifact.odCardScorecardStatusPass': 'ناجح',
  'artifact.odCardScorecardStatusPartial': 'جزئي',
  'artifact.odCardScorecardStatusFail': 'يحتاج إلى تحسين',
  'artifact.odCardRuleKicker': 'قاعدة مقترحة',
  'artifact.odCardRuleNameLabel': 'الاسم',
  'artifact.odCardRuleDescriptionLabel': 'الوصف',
  'artifact.odCardRuleAssertionLabel': 'يجب أن يتحقق',
  'artifact.odCardRuleCheckLabel': 'كيفية التحقق',
  'artifact.odCardRuleRationaleLabel': 'السبب',
  'artifact.odCardRuleKeep': 'احتفاظ',
  'artifact.odCardRuleEdit': 'تعديل',
  'artifact.odCardRuleDone': 'تم',
  'artifact.odCardRuleDiscard': 'تجاهل',
  'artifact.odCardRuleSaving': 'جارٍ الحفظ…',
  'artifact.odCardRuleSaved': 'تم حفظ “{name}” كقاعدة',
  'artifact.odCardRuleError': 'تعذّر حفظ القاعدة. حاول مرة أخرى.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': 'الملف الشخصي',
  'settings.memoryTypeRule': 'قاعدة',
  'settings.memoryTabMemories': 'الذكريات',
  'settings.memoryTabMemoriesCaption': 'عرض الذاكرة المحفوظة وإدارتها',
  'settings.memoryTabHow': 'كيف تعمل',
  'settings.memoryTabHowCaption': 'الحلقتان وعناصر التحكم فيهما',
  'settings.memoryAddDisclosure': 'إضافة ذكريات أو استيرادها',
  'settings.memoryAddDisclosureHint': 'الملف الشخصي أو الإدخال اليدوي أو التطبيقات المتصلة',
  'settings.memoryProfileTab': 'الملف الشخصي للعمل',
  'settings.memoryProfileTabCaption': 'من أنت وإعداداتك الافتراضية',
  'settings.memoryProfileTitle': 'ملفك الشخصي للعمل',
  'settings.memoryProfileHint':
    'بعض الحقائق عنك وعن إعداداتك الافتراضية. تُدرِج الذاكرة هذه قبل كل مهمة حتى يستنتج الوكيل ما تقصده من طلب قصير.',
  'settings.memoryProfileName': 'الملف الشخصي للعمل',
  'settings.memoryProfileDescription':
    'الدور والشركة والمجال والجمهور والذوق والإعدادات الافتراضية التي ينبغي للمساعد إعادة استخدامها.',
  'settings.memoryProfileSave': 'حفظ الملف الشخصي',
  'settings.memoryProfileSaving': 'جارٍ الحفظ…',
  'settings.memoryProfileSaved': 'تم حفظ الملف الشخصي',
  'settings.memoryProfileRole': 'الدور',
  'settings.memoryProfileRolePlaceholder': 'مثال: مؤسّس، مصمم، مدير منتج',
  'settings.memoryProfileCompany': 'الشركة / الفريق',
  'settings.memoryProfileCompanyPlaceholder': 'مثال: Acme، فريق النمو',
  'settings.memoryProfileDomain': 'المجال',
  'settings.memoryProfileDomainPlaceholder': 'مثال: B2B SaaS، fintech، devtools',
  'settings.memoryProfileAudience': 'الجمهور الأساسي',
  'settings.memoryProfileAudiencePlaceholder': 'مثال: المديرون التنفيذيون، المهندسون، المستخدمون النهائيون',
  'settings.memoryProfileAesthetic': 'الجمالية / الذوق',
  'settings.memoryProfileAestheticPlaceholder':
    'مثال: نظيف وتحريري، خلفيات فاتحة، مساحات بيضاء وفيرة',
  'settings.memoryProfileDeliverables': 'المخرجات الافتراضية',
  'settings.memoryProfileDeliverablesPlaceholder': 'مثال: صفحات هبوط، عروض تقديمية، صفحات موجزة',
  'settings.memoryProfileLocale': 'اللغة / المنطقة',
  'settings.memoryProfileLocalePlaceholder': 'مثال: الإنجليزية (الولايات المتحدة)، الصينية المبسّطة',
  'settings.memoryProfileGoals': 'الأهداف الحالية',
  'settings.memoryProfileGoalsPlaceholder':
    'مثال: إطلاق صفحة التسعير الجديدة، رفع معدّل التحويل في مسار التجربة',
  'settings.memoryHooksTitle': 'خطّافات الذاكرة',
  'settings.memoryHooksHint':
    'اختر أجزاء الذاكرة التي تعمل تلقائيًا. يوقفها جميعًا المفتاح الرئيسي أعلاه.',
  'settings.memoryHooksProfileLabel': 'استخدام ملفي الشخصي',
  'settings.memoryHooksProfileDesc': 'إدراج ملفك الشخصي للعمل في كل مهمة.',
  'settings.memoryHooksRewriteLabel': 'إعادة صياغة الطلبات القصيرة',
  'settings.memoryHooksRewriteDesc': 'قبل: توسيع طلب قصير إلى موجز مهمة كامل.',
  'settings.memoryHooksVerifyLabel': 'التحقق الذاتي من المخرجات',
  'settings.memoryHooksVerifyDesc': 'بعد: فحص النتيجة وفق قواعدك، ثم عرض بطاقة تقييم.',
  'settings.memoryHooksExtractionLabel': 'التعلّم من المحادثات',
  'settings.memoryHooksExtractionDesc': 'التقاط الحقائق والتفضيلات المفيدة من أدوار المحادثة.',
  'settings.memoryIndex': 'MEMORY.md (الفهرس)',
  'settings.memoryIndexSave': 'حفظ الفهرس',
  'settings.memoryIndexReset': 'إعادة تعيين',
  'settings.memoryToastChanged': 'تم تحديث الذاكرة',
  'settings.memoryToastClickHint': 'عرض',
  'settings.memoryAll': 'الكل',
  'settings.memoryExtractions': 'سجل الاستخراج',
  'settings.memoryExtractionsHint': 'يعمل Regex أولًا، ويعمل LLM في الخلفية.',
  'settings.memoryExtractionsEmpty': 'لا توجد عمليات استخراج بعد. ستملأ هذه القائمة في دور المحادثة التالي.',
  'settings.memoryExtractionsRefresh': 'تحديث',
  'settings.memoryExtractionsRefreshing': 'جارٍ التحديث…',
  'settings.memoryExtractionPhaseRunning': 'جارٍ التشغيل…',
  'settings.memoryExtractionPhaseSuccess': 'نجاح',
  'settings.memoryExtractionPhaseSkipped': 'تم التخطي',
  'settings.memoryExtractionPhaseFailed': 'فشل',
  'settings.memoryExtractionSkipNoProvider': 'لم يتم تكوين API key لاستخراج الذاكرة عبر LLM.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'الذاكرة معطّلة.',
  'settings.memoryExtractionSkipEmpty': 'رسالة المستخدم فارغة — لا يوجد ما يُستخرَج.',
  'settings.memoryExtractionSkipNoMatch': 'لم يتطابق أي نمط regex في هذا الدور.',
  'settings.memoryExtractionKindHeuristic': 'تعبير نمطي',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'إعدادات الوسائط',
  'settings.memoryExtractionProviderOverride': 'إعدادات الذاكرة',
  'settings.memoryExtractionProposed': 'مقترح',
  'settings.memoryExtractionWritten': 'مكتوب',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'حذف',
  'settings.memoryExtractionsClear': 'مسح',
  'settings.memoryExtractionsClearTitle': 'مسح كل سجل الاستخراج',
  'settings.memoryExtractionsClearConfirm': 'هل تريد مسح كل سجل الاستخراج؟ لا يمكن التراجع عن هذا الإجراء.',
  'settings.memoryNoProviderBannerTitle': 'استخراج الذاكرة عبر LLM غير قيد التشغيل',
  'settings.memoryNoProviderBannerBody': 'لم يُعثر على API key لمستخرج الذاكرة. أضف مفتاح OpenAI ضمن مزودي الوسائط، أو عيّن ANTHROPIC_API_KEY / OPENAI_API_KEY في البيئة لتفعيل الاستخراج المعتمد على LLM. لا يزال الاستخراج الاستدلالي عبر regex نشطًا.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'تثبيت',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'مسار محلي',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'تثبيت',
  'settings.libraryUninstall': 'إلغاء التثبيت',
  'settings.libraryBuiltIn': 'مدمج',
  'settings.libraryInstalled': 'مثبّت',
  'notify.successTitle': 'اكتملت المهمة',
  'notify.failureTitle': 'فشلت المهمة',
  'notify.successBody': 'انتهت جولة.',
  'notify.failureBody': 'انتهت المهمة بخطأ.',
  'updater.available': 'يتوفر تحديث',
  'updater.activeRunsTitle': 'لا يزال Open Design يعمل',
  'updater.activeRunsBody': 'لا تزال {count} مهام نشطة قيد التشغيل. ستؤدي إعادة التشغيل الآن إلى مقاطعتها.',
  'updater.activeRunsUnknownBody': 'تعذر على Open Design التأكد مما إذا كانت هناك مهام قيد التشغيل. قد تؤدي إعادة التشغيل الآن إلى مقاطعة العمل النشط.',
  'updater.availableBody': 'Open Design {version} متوفر. سيتم تنزيله قبل فتح المثبت.',
  'updater.checking': 'جارٍ البحث عن تحديثات',
  'updater.download': 'تنزيل التحديث',
  'updater.downloading': 'جارٍ تنزيل التحديث',
  'updater.downloadingPercent': 'جارٍ تنزيل التحديث {percent}%',
  'updater.done': 'تم',
  'updater.failed': 'فشل التحديث',
  'updater.installerOpenBody': 'المثبت مفتوح. يتم الآن إنهاء Open Design لتتمكن من إكمال التحديث.',
  'updater.installerOpened': 'تم فتح المثبت',
  'updater.later': 'لاحقًا',
  "updater.allowSilentUpdates": "السماح بالتثبيت التلقائي لتحديثات التطبيق الداخلية المستقبلية",
  'updater.openFailedFallback': 'تعذر فتح المثبت.',
  'updater.installRestart': 'التثبيت وإعادة التشغيل',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'تثبيت التحديث',
  'updater.opening': 'جارٍ فتح المثبت...',
  'updater.dialogAvailableGeneric': 'يتوفر إصدار جديد.\nنزّله لتثبيت التحديث.',
  'updater.dialogAvailableVersion': 'الإصدار v{version} متوفر.\nنزّله لتثبيت التحديث.',
  'updater.dialogCheckFailed': 'تعذر التحقق من وجود تحديثات.\nيرجى المحاولة مجددًا بعد قليل.',
  'updater.dialogReadyGeneric': 'الإصدار الجديد جاهز.\nتجربة أفضل وتصميم أكثر ذكاءً بانتظارك.',
  'updater.dialogReadyVersion': 'الإصدار v{version} جاهز.\nتجربة أفضل وتصميم أكثر ذكاءً بانتظارك.',
  'updater.dialogUnsupported': 'التحديث داخل التطبيق غير متاح هنا.\nنزّل أحدث إصدار من صفحة الإصدارات.',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'إنهاء Open Design',
  'updater.quitFailedBody': 'المثبت مفتوح، لكن تعذر إنهاء Open Design. أغلق Open Design قبل استبدال التطبيق.',
  'updater.quitFailedTitle': 'تعذر الإنهاء',
  'updater.quitting': 'جارٍ الإنهاء...',
  'updater.ready': 'التحديث جاهز',
  'updater.readyGeneric': 'إصدار جديد جاهز. سيتم إغلاق Open Design وفتح المثبت.',
  'updater.readyVersion': 'Open Design {version} جاهز. سيتم إغلاق Open Design وفتح المثبت.',
  'updater.reinstallLearnMore': 'معرفة المزيد',
  'updater.reinstallReadyGeneric': 'يتطلب هذا التحديث إعادة تثبيت كاملة. سيتم إغلاق Open Design وفتح المثبّت.',
  'updater.reinstallReadyVersion': 'يتطلب Open Design {version} إعادة تثبيت كاملة. سيتم إغلاق Open Design وفتح المثبّت.',
  'updater.restartAnyway': 'إعادة التشغيل على أي حال',
  'updater.upToDate': 'أنت تستخدم أحدث إصدار بالفعل.',
  'updater.viewVersionFeatures': 'استكشف ميزات الإصدار الجديد',
  'updater.manualDownload': 'تنزيل يدوي',
  'whatsNew.updatedTitle': 'وصل Open Design {version}',
  'whatsNew.cta': 'عرض ملاحظات الإصدار',
  'newsletter.label': 'النشرة (اختياري)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'الأتمتة',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'ملخص يومي للموصّلات',
  'settings.orbit.lede': 'اجمع نشاط الموصّلات وفق جدول وانشر النتيجة كـ live artifact قابل للتحديث.',
  'settings.orbit.statusOnTitle': 'التشغيلات اليومية المجدولة مفعّلة',
  'settings.orbit.statusOffTitle': 'التشغيلات اليومية المجدولة متوقفة',
  'settings.orbit.statusActive': 'نشط',
  'settings.orbit.statusOff': 'متوقف',
  'settings.orbit.runTitle': 'ابدأ تشغيل Orbit وافتح المحادثة الحية',
  'settings.orbit.running': 'قيد التشغيل…',
  'settings.orbit.runOpen': 'شغّله الآن',
  'settings.orbit.dailySummaryTitle': 'ملخص يومي',
  'settings.orbit.dailySummarySub': 'يعمل مرة يوميًا في الوقت المحلي المجدول.',
  'settings.orbit.on': 'تشغيل',
  'settings.orbit.off': 'متوقف',
  'settings.orbit.runTimeTitle': 'وقت التشغيل',
  'settings.orbit.runTimeSub': 'الافتراضي 08:00. احفظ لتطبيق جدول daemon.',
  'settings.orbit.runTimeAria': 'وقت تشغيل Orbit اليومي',
  'settings.orbit.nextRun': 'التشغيل التالي',
  'settings.orbit.nextRunScheduledAfterSave': 'سيُجدول بعد الحفظ',
  'settings.orbit.schedule': 'الجدول',
  'settings.orbit.pausedManualOnly': 'متوقف مؤقتًا — تشغيل يدوي فقط',
  'settings.orbit.templateTitle': 'قالب prompt',
  'settings.orbit.templateMissing': 'القالب {id} غير مثبت.',
  'settings.orbit.templateMissingOption': '{id} (مفقود)',
  'settings.orbit.templateMissingInstall': 'ثبّت skill لـ Orbit لتوجيه prompt.',
  'settings.orbit.templateMissingPickAnother': 'اختر قالبًا آخر من القائمة.',
  'settings.orbit.templateResetTitle': 'إعادة إلى {id}',
  'settings.orbit.templateReset': 'إعادة ضبط',
  'settings.orbit.templateHelp': 'وجّه Orbit باستخدام skill — يُحقن prompt المثال للقالب المحدد في كل تشغيل Orbit كي تتبع الملخصات شكل ذلك القالب.',
  'settings.orbit.templateAria': 'قالب prompt لـ Orbit',
  'settings.orbit.templatesLoading': 'جارٍ تحميل القوالب…',
  'settings.orbit.templatesOptgroup': 'قوالب skills لـ Orbit',
  'settings.orbit.lastRun': 'آخر تشغيل',
  'settings.orbit.triggerManual': 'يدوي',
  'settings.orbit.triggerScheduled': 'مجدول',
  'settings.orbit.meterAria': '{succeeded} نجح، {skipped} تم تخطيه، {failed} فشل من أصل {checked} تم فحصه',
  'settings.orbit.countChecked': 'تم الفحص',
  'settings.orbit.countSucceeded': 'نجح',
  'settings.orbit.countSkipped': 'تم التخطي',
  'settings.orbit.countFailed': 'فشل',
  'settings.orbit.runError': 'تعذر تشغيل Orbit. تأكد من أن daemon المحلي يعمل وأن الموصّلات مهيأة.',
  'settings.orbit.gateAriaLabel': 'يلزم وجود موصلات لاستخدام Orbit',
  'settings.orbit.gateEyebrow': 'الإعداد مطلوب',
  'settings.orbit.gateTitle': 'اربط أداة لتشغيل Orbit',
  'settings.orbit.gateBody': 'يلخّص Orbit نشاط الموصلات الخاصة بك. لم تربط أيّ موصل بعد — أضف تكاملًا واحدًا على الأقل ليعمل Orbit.',
  'settings.orbit.gateBodyNoKey': 'يلخّص Orbit نشاط موصلاتك، وتعمل الموصلات عبر Composio. أضِف مفتاح Composio API في «الموصلات» لفتح الكتالوج واختيار أوّل تكامل لك.',
  'settings.orbit.gateAction': 'فتح الموصلات',
  'settings.orbit.gateActionNoKey': 'تهيئة Composio',
  'settings.orbit.gateLoading': 'جارٍ فحص الموصلات…',
  'settings.orbit.controlsLockedBadge': 'مقفل',
  'settings.orbit.controlsLockedHint': 'اربط أداة لإلغاء قفل جدولة Orbit وقالبه.',
  'settings.orbit.artifactKickerLive': 'عنصر حي',
  'settings.orbit.artifactKickerLegacy': 'ملخص قديم',
  'settings.orbit.artifactTitle': 'ملخص نشاط Orbit اليومي',
  'settings.orbit.artifactMetaLive': 'artifact HTML قابل للتحديث تم إنشاؤه من نشاط الموصّلات.',
  'settings.orbit.artifactMetaLegacy': 'تم إنشاؤه قبل تفعيل دعم live artifact — شغّل Orbit مرة أخرى لنشر واحد.',
  'settings.orbit.copyMarkdownTitle': 'نسخ ملخص Markdown إلى الحافظة',
  'settings.orbit.copied': 'تم النسخ',
  'settings.orbit.copy': 'نسخ',
  'settings.orbit.openArtifact': 'فتح artifact',
  'settings.orbit.sourceMarkdown': 'Markdown المصدر',
  'settings.memoryModelInlineHintByokNeutral': 'تستخدم الذاكرة نموذجًا منفصلاً عن المحادثة. يكون الافتراضي هو نموذج المحادثة لديك.',
  'diagnostics.exportTitle': 'تصدير التشخيص',
  'diagnostics.exportButton': 'تصدير التشخيص',
  'diagnostics.exportHint': 'يحزم سجلات التطبيق الأخيرة ومعلومات الجهاز في ملف zip لمشاركته مع الفريق.',
  'diagnostics.exporting': 'جارٍ التصدير…',
  'diagnostics.exportSuccess': 'تم حفظ التشخيص في {path}',
  'diagnostics.exportFailed': 'تعذّر تصدير التشخيص: {message}',
  'automations.eyebrow': 'جلسات الـ Agent المجدولة',
  'automations.title': 'الأتمتة',
  'automations.lede': 'خطّط لمحادثات متكررة لأعمال المشاريع، وملخّصات Orbit، والقطع الحيّة.',
  'automations.summaryAria': 'ملخّص الأتمتة',
  'automations.metricActive': 'نشطة',
  'automations.metricPaused': 'متوقفة مؤقتًا',
  'automations.metricTemplates': 'القوالب',
  'automations.newAutomation': 'أتمتة جديدة',
  'automations.yourAutomations': 'أتمتاتك',
  'automations.loading': 'جارٍ التحميل',
  'automations.emptyTitle': 'لا توجد أتمتة بعد',
  'automations.emptyBody': 'أنشئ واحدة من قالب أو ابدأ بجدول فارغ.',
  'automations.targetNewEachRun': 'مشروع جديد في كل تشغيل',
  'automations.targetCreateEachRun': 'مشروع جديد في كل تشغيل',
  'automations.lastRun': 'آخر تشغيل {time}',
  'automations.openResult': 'فتح النتيجة',
  'automations.run': 'تشغيل',
  'automations.runNowTitle': 'التشغيل الآن وفتح المحادثة',
  'automations.history': 'السجل',
  'automations.hideHistory': 'إخفاء السجل',
  'automations.edit': 'تعديل',
  'automations.pause': 'إيقاف مؤقت',
  'automations.resume': 'استئناف',
  'automations.deleteAria': 'حذف الأتمتة',
  'automations.deleteTitle': 'حذف هذه الأتمتة',
  'automations.deleteConfirm': 'حذف هذه الأتمتة؟ تُحفَظ عمليات التشغيل السابقة ومشاريعها.',
  'automations.proposalsTitle': 'مقترحات التطوّر',
  'automations.proposalsSub': 'راجِع مُخرجات الأتمتة قبل أن تُغيّر الذاكرة أو المهارات أو أنظمة التصميم.',
  'automations.proposalsPending': '{n} قيد الانتظار',
  'automations.apply': 'تطبيق',
  'automations.reject': 'رفض',
  'automations.proposalsDismissReason': 'تم تجاهله في الأتمتة',
  'automations.templatesTitle': 'القوالب',
  'automations.templatesSub': 'Orbit والقطع الحيّة قوالب ضمن تدفّق الأتمتة نفسه.',
  'automations.templatesCount': '{filtered} من {total}',
  'automations.templateFiltersAria': 'عوامل تصفية القوالب',
  'automations.templatesEmptyTitle': 'لا توجد قوالب في هذه الفئة بعد.',
  'automations.templatesEmptyBody': 'جرّب عامل تصفية مختلفًا، أو ابدأ من أتمتة فارغة.',
  'automations.useTemplate': 'استخدام القالب',
  'automations.runHistoryLoading': 'جارٍ تحميل سجل التشغيل...',
  'automations.runHistoryEmpty': 'لا توجد عمليات تشغيل بعد.',
  'automations.runHistoryTitle': 'سجل التشغيل',
  'automations.runHistoryLatest': 'آخر 10',
  'automations.crystallize': 'تبلوُر',
  'automations.crystallizing': 'جارٍ التبلوُر',
  'automations.crystallizeTitle': 'صياغة مقترحات مهارات وذاكرة من هذا التشغيل',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'فتح المحادثة',
  'automations.runHistoryAria': 'سجل تشغيل الأتمتة',
  'automations.proposalsAria': 'مقترحات تطوّر الأتمتة',
  'automations.templatesAria': 'قوالب الأتمتة',
  'automations.runInProgress': 'قيد التنفيذ',
  'automations.promptPlaceholder': 'اجلب نشاط GitHub وLinear ليوم أمس ولخّص ما تغيّر.',
  'automations.scheduleStatusPaused': 'متوقفة مؤقتًا',
  'automations.nextRunManualOnly': 'يدوي فقط',
  'automations.nextRunScheduled': 'مجدول',
  'automations.nextRunAt': 'التالي {time}',
  'automations.statusSucceeded': 'نجح',
  'automations.statusFailed': 'فشل',
  'automations.statusRunning': 'قيد التشغيل',
  'automations.statusQueued': 'في قائمة الانتظار',
  'automations.statusCanceled': 'أُلغي',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'قطعة حيّة',
  'automations.kindAutomation': 'أتمتة',
  'automations.proposalTargetMemory': 'الذاكرة',
  'automations.proposalTargetDesignSystem': 'نظام التصميم',
  'automations.proposalTargetSkill': 'مهارة',
  'automations.proposalTargetTemplate': 'قالب أتمتة',
  'automations.proposalActionCreate': 'إنشاء',
  'automations.proposalActionUpdate': 'تحديث',
  'automations.proposalActionMerge': 'دمج',
  'automations.proposalActionMove': 'نقل',
  'automations.proposalActionDelete': 'حذف',
  'automations.proposalActionPromote': 'ترقية',
  'automations.filterAll': 'الكل',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'القطع الحيّة',
  'automations.filterMemory': 'الذاكرة',
  'automations.filterDesignSystems': 'أنظمة التصميم',
  'automations.filterSkills': 'المهارات',
  'automations.filterConnectors': 'الموصِّلات',
  'automations.filterCompression': 'الضغط',
  'automations.filterRelease': 'الإصدار',
  'automations.filterQuality': 'الجودة',
  'automations.tpl.memoryRefresh.title': 'تحديث ذاكرة المشروع من الأعمال الأخيرة.',
  'automations.tpl.memoryRefresh.desc': 'يحوّل القرارات والتفضيلات والملاحظات المتكررة إلى تحديثات ذاكرة قابلة لإعادة الاستخدام.',
  'automations.tpl.designSystemRefresh.title': 'تحديث أنظمة التصميم من القطع المُسلَّمة.',
  'automations.tpl.designSystemRefresh.desc': 'يكتشف الرموز والمكوّنات والقواعد القابلة لإعادة الاستخدام عبر أعمال التصميم الأخيرة.',
  'automations.tpl.liveArtifactRegistry.title': 'تدقيق القطع الحيّة وتحديث الإصدارات القديمة.',
  'automations.tpl.liveArtifactRegistry.desc': 'يُبقي لوحات المعلومات والتقارير والمعاينات الدائمة محدّثة بدلًا من تكرارها.',
  'automations.tpl.orbitDashboard.title': 'بناء لوحة معلومات لنشاط الموصِّلات.',
  'automations.tpl.orbitDashboard.desc': 'يجمّع الموصِّلات المحدّدة في لوحة معلومات حيّة بأسلوب Orbit.',
  'automations.tpl.releaseNotes.title': 'صياغة ملاحظات الإصدار من أعمال التصميم المُسلَّمة.',
  'automations.tpl.releaseNotes.desc': 'يربط طلبات الدمج PR والقطع والتغييرات الموجَّهة للمنتج في ملاحظات الإصدار.',
  'automations.tpl.qualityRegressionWatch.title': 'مراقبة تراجعات التصميم والتنفيذ.',
  'automations.tpl.qualityRegressionWatch.desc': 'يقارن التغييرات الأخيرة بالمعايير والتتبّعات والمراجع المعتمدة.',
  'automations.tpl.orbitDaily.title': 'ملخّص يومي للموصِّلات.',
  'automations.tpl.orbitDaily.desc': 'يحدّث ملخّص نشاط الموصِّلات وفق جدول زمني.',
  'automations.tpl.liveStatusBoard.title': 'إبقاء قطعة الحالة الحيّة محدّثة.',
  'automations.tpl.liveStatusBoard.desc': 'يحدّث قطعة دائمة واحدة بدلًا من إنشاء تقرير جديد في كل تشغيل.',
  'dsManager.areaAria': 'منطقة أنظمة التصميم',
  'dsManager.tabDesignSystem': 'نظام التصميم',
  'dsManager.tabTemplate': 'قالب',
  'dsManager.sourceAria': 'مصدر نظام التصميم',
  'dsManager.templateSourceAria': 'مصدر القالب',
  'dsManager.yourSystems': 'أنظمتك',
  'dsManager.officialPresets': 'الإعدادات المسبقة الرسمية',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'مزامنة مع الفريق',
  'dsManager.syncToTeamFailed': 'تعذّرت المزامنة مع الفريق',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'المؤسسات',
  'dsManager.yourTemplates': 'قوالبك',
  'dsManager.yourSystemsAria': 'أنظمة التصميم الخاصة بك',
  'dsManager.eyebrowDesignSystems': 'أنظمة التصميم',
  'dsManager.yourSystemsHeading': 'أنظمتك',
  'dsManager.filterAria': 'تصفية أنظمة التصميم',
  'dsManager.filterAll': 'الكل',
  'dsManager.filterPublished': 'منشورة',
  'dsManager.filterDraft': 'مسودة',
  'dsManager.createTitle': 'إنشاء نظام تصميم جديد',
  'dsManager.createBody': 'علّم Open Design علامتك التجارية ومنتجك وكودك وأصولك ومراجع التصميم الخاصة بك.',
  'dsManager.createAction': 'إنشاء',
  'dsManager.emptyMine': 'لا توجد أنظمة تصميم بعد. أنشئ واحدًا من سياق منتج حقيقي، وراجِع المسودة، ثم انشره للمشاريع المستقبلية.',
  'dsManager.badgeDefault': 'افتراضي',
  'dsManager.rowMetaUpdated': 'أنت · تم التحديث {date}',
  'dsManager.edit': 'تعديل',
  'dsManager.openSystem': 'فتح',
  'dsManager.editWithAgent': 'تحرير باستخدام Agent',
  'dsManager.downloadTitle': 'تنزيل نظام التصميم (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'تنزيل {title} كملف .zip',
  'dsManager.downloadFailed': 'تعذر تنزيل نظام التصميم. حاول مرة أخرى.',
  'dsManager.deleteConfirm': 'حذف "{title}"؟ سيؤدي ذلك إلى إزالة مسودة نظام التصميم من هذا الجهاز.',
  'dsManager.makeDefault': 'تعيين كافتراضي',
  'dsManager.statusPublished': 'منشور',
  'dsManager.statusDraft': 'مسودة',
  'dsManager.openSystemAria': 'فتح {title}',
  'dsManager.deleteSystemAria': 'حذف {title}',
  'dsManager.deletePermissionDenied': 'ليس لديك إذن بحذف نظام التصميم هذا.',
  'dsManager.presetsAria': 'الإعدادات المسبقة الرسمية لأنظمة التصميم',
  'dsManager.eyebrowLibrary': 'المكتبة',
  'dsManager.eyebrowTemplates': 'القوالب',
  'dsManager.yourTemplatesAria': 'قوالبك',
  'dsManager.emptyTemplates': 'لا توجد قوالب بعد. أنشئ واحدًا من أي مشروع مُنشأ عبر المشاركة بمجرد تفعيل نشر القوالب.',
  'dsManager.templateDescFallback': 'تم الإنشاء من مشروع',
  'dsManager.comingSoonBadge': 'قريبًا',
  'dsManager.enterpriseDsTitle': 'أنظمة تصميم المؤسسات',
  'dsManager.enterpriseDsBody': 'أنظمة التصميم المشتركة للفِرق ومكتبات العلامات التجارية المُدارة قريبًا.',
  'dsManager.enterpriseTplTitle': 'قوالب المؤسسات',
  'dsManager.enterpriseTplBody': 'القوالب المعتمدة من الفريق والنشر على مستوى المؤسسة قريبًا.',
  'settings.instructionsTitle': 'التعليمات والقواعد',
  'settings.instructionsSubtitle': 'سلوك ثابت ينبغي للمساعد اتباعه',
  'settings.instructionsNavSub': 'سلوك ثابت للمساعد',
  'settings.customInstructionsDesc': 'تعليمات ثابتة يتبعها Open Design في كل محادثة. هذه ليست ذكريات محفوظة؛ استخدم الذاكرة للحقائق والتفضيلات وسياق المشروع.',
  'mcpClient.forwardedToLabel': 'مُمرَّر إلى:',
  'mcpClient.notForwardedToLabel': 'غير مُمرَّر إلى:',
  'mcpClient.forwardedAcpNote': 'محوِّلات ACP المُعلَّمة بـ stdio تتلقى فقط خوادم MCP من نوع stdio من هذه القائمة؛ تُسقَط إدخالات HTTP وSSE عند بدء التشغيل.',
  'mcpClient.notForwardedNote': 'بالنسبة إلى تلك الـ Agents، اضبط خوادم MCP في ملف إعدادات الـ Agent الخاص به (مثل ~/.codex/config.toml و~/.gemini/settings.json)؛ الخوادم أدناه غير مستخدمة هناك دون إشعار.',

  // Brands library + extraction
  'brand.libraryTitle': 'حزمة العلامة التجارية',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'الصق موقعًا إلكترونيًا، أو اختر علامة تجارية أدناه، وسنستخرج ألوانها وخطوطها وشعارها.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'حزمة العلامة التجارية',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'مسح ذاكرة التخزين المؤقت للتحديث',
  'settings.clearUpdaterCacheHint': 'يزيل التحديثات التي تم تنزيلها وذاكرات التخزين المؤقت القديمة، ثم يعيد تعيين حالة التحديث. استخدمه عندما تبدو التحديثات عالقة.',
  'settings.clearUpdaterCacheButton': 'مسح ذاكرة التخزين المؤقت',
  'settings.clearUpdaterCacheConfirmButton': 'تأكيد المسح',
  'settings.clearUpdaterCacheSuccess': 'تم مسح ذاكرة التخزين المؤقت للتحديث.',
  'settings.clearUpdaterCacheFailed': 'تعذر مسح ذاكرة التخزين المؤقت للتحديث.',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'أنشئ مرة واحدة، وابنِ في كل مكان',
  'onboarding.buildBody': 'يحوّل Open Design علامتك التجارية إلى نظام تصميم قابل لإعادة الاستخدام، ويبقي كل ما تنشئه متّسقًا ومطابقًا للعلامة.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'إنشاء نظام تصميم',
  'onboarding.buildHome': 'الذهاب إلى الرئيسية',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'ابدأ من علامة تجارية تحبها',
  'brandPicker.subtext': 'انقر على أي علامة تجارية لاستخراج حزمتها مباشرة من موقعها الإلكتروني.',
  'brandPicker.quickPicksLabel': 'علامات تجارية شائعة — انقر للاستخراج',
  'brandPicker.searchPlaceholder': 'ابحث عن العلامات التجارية…',
  'brandPicker.allCategories': 'الكل',
  'brandPicker.extractAction': 'استخراج',
  'brandPicker.showMore': 'عرض المزيد',
  'brandPicker.opening': 'جارٍ بدء الاستخراج — جارٍ فتح {brand}…',
  'ds.kitVisualize': 'عرض',
  'ds.kitEdit': 'تحرير',
  'ds.kitSource': 'المصدر',
  'ds.saveDesignMd': 'حفظ DESIGN.md',
  'ds.saving': 'جارٍ الحفظ…',
  'ds.copyDesignMd': 'نسخ DESIGN.md',
  'ds.editDesignMd': 'تحرير DESIGN.md',
  'ds.openDesignMd': 'فتح DESIGN.md',
  'ds.copyDesignMdModule': 'نسخ قسم {module}',
  'ds.editDesignMdModule': 'تحرير قسم {module}',
  'ds.openDesignMdModule': 'فتح قسم {module}',
  'ds.uploadMd': 'رفع MD',
  'ds.uploadFont': 'إضافة ملف خط',
  'ds.pasteImage': 'لصق صورة',
  'ds.refresh': 'تحديث',
  'ds.download': 'تنزيل',
  'ds.importFolder': 'استيراد مجلد',
  'ds.reset': 'إعادة تعيين',
  'ds.editingDesignMdHint': 'سيؤدي تحرير Markdown هذا إلى تحديث وحدات الحزمة المعروضة.',
  'ds.editingModuleHint': 'يتم تحرير وحدة {module} فقط.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'حفظ الوحدة',
  'ds.uploadLogo': 'رفع الشعار',
  'ds.uploadImage': 'رفع صورة',
  'ds.uploading': 'جارٍ الرفع…',
  'ds.moduleEmptyLogo': 'لا يوجد شعار بعد',
  'ds.moduleEmptyFonts': 'لم يتم التقاط أي خطوط.',
  'ds.actionDone': 'تم',
  'ds.actionFailed': 'حدث خطأ. حاول مرة أخرى.',
  'ds.uploadDone': 'تم الرفع',
  'ds.uploadFailed': 'فشل الرفع. حاول مرة أخرى.',
  'ds.deleteLogo': 'حذف الشعار',
  'ds.deleteImage': 'حذف {caption}',
  'ds.deleteProjectConfirm': 'حذف "{title}"؟ سيؤدي ذلك إلى إزالة نظام التصميم ومشروعه نهائيًا من هذا الجهاز.',
  'ds.deleteProjectAction': 'حذف {title}',
  'ds.editColor': 'تحرير {name}',
  'ds.colorLabel': 'اللون',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'قيمة Hex',
  'ds.saveColor': 'حفظ اللون',
  'ds.invalidHexColor': 'أدخل لون Hex صالحًا، مثل #FF6A3D.',
  'ds.colorSaveFailed': 'تعذر حفظ هذا اللون.',
  'ds.colorResetFailed': 'تعذر إعادة تعيين هذا اللون.',
  'ds.designMdSectionLabel': 'قسم {module} في DESIGN.md',
  'ds.kitErrorTitle': 'واجه هذا العرض مشكلة.',
  'ds.kitErrorRetry': 'إعادة التحميل',
  'ds.shortcutsLabel': 'اختصارات لوحة المفاتيح',
  'ds.shortcutsHint': 'الاختصارات: E تحرير · C نسخ · U رفع · R تحديث · ⌫ حذف الشعار',
  'ds.moduleEmptyImages': 'لا توجد صور بعد',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'ابدأ من',
  'newproj.startBlank': 'فارغ',
  'newproj.startBlankHint': 'البدء من الصفر',
  'workspace.pages': 'الصفحات',
  'workspace.allProjectFiles': 'كل ملفات المشروع',
  'workspace.newBlankPage': 'صفحة فارغة جديدة',
  'workspace.noPagesYet': 'لا توجد صفحات بعد',
  'workspace.pageCreateFailed': 'تعذر إنشاء الصفحة.',
  'workspace.pageCreatorTitle': 'إنشاء صفحة',
  'workspace.pageCreatorSearch': 'البحث في القوالب',
  'workspace.pageCreatorCategoryAll': 'كل السيناريوهات',
  'workspace.pageCreatorEmpty': 'لا توجد أنواع صفحات تطابق بحثك.',
  'workspace.pageCreatorPreview': 'معاينة',
  'workspace.pageCreatorUse': 'استخدام',
  'fileViewer.presentInTabDeckHint': 'ملاحظات المتحدث في نافذة منبثقة',
  'fileViewer.presentEscHint': 'اضغط Esc للخروج',
  'fileViewer.presenterPause': 'إيقاف مؤقت',
  'fileViewer.presenterResume': 'استئناف',
  'fileViewer.presenterPrevious': 'السابق',
  'fileViewer.presenterNext': 'التالي',
  'questions.uploadingFiles': 'جارٍ رفع الملفات…',
  'questions.uploadNeedsProject': 'يتطلب رفع الملفات مشروعًا نشطًا.',
  'questions.uploadPartialFailed': 'تم رفع {uploaded} ملف(ات)، لكن فشل {failed}.',
  'questions.uploadFailed': 'فشل رفع {failed} ملف(ات).',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.usePrompt': 'استخدام كمُوجّه',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the Open Design Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the Open Design Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and Open Design will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'Open Design will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'Open Design will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'Open Design account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by Open Design; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'Open Design is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'Open Design is rebuilding tokens',
  'dsFlow.jobRevising': 'Open Design is revising',
  'dsFlow.jobStillWorking': 'Open Design is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask Open Design to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'Open Design is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'Open Design is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'Open Design is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'Open Design is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'Open Design official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
};
